// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               v3.19.1
// source: MCAPI_Types.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "mcapi";

/** @exclude import "google/protobuf/timestamp.proto"; */

/** Stereoscopic types */
export enum Stereoscopic {
  /** Undef - Undefined */
  Undef = 0,
  /** Monoscopic - Off */
  Monoscopic = 1,
  /** MonoLeft - Left eye only */
  MonoLeft = 2,
  /** MonoRight - Right eye only */
  MonoRight = 3,
  /** MonoLeadingEye - Leading eye */
  MonoLeadingEye = 4,
  /** HalfResX - Side by side */
  HalfResX = 5,
  /** HalfResY - Over/Under */
  HalfResY = 6,
  /** Full - Full */
  Full = 7,
  UNRECOGNIZED = -1,
}

export function stereoscopicFromJSON(object: any): Stereoscopic {
  switch (object) {
    case 0:
    case "Undef":
      return Stereoscopic.Undef;
    case 1:
    case "Monoscopic":
      return Stereoscopic.Monoscopic;
    case 2:
    case "MonoLeft":
      return Stereoscopic.MonoLeft;
    case 3:
    case "MonoRight":
      return Stereoscopic.MonoRight;
    case 4:
    case "MonoLeadingEye":
      return Stereoscopic.MonoLeadingEye;
    case 5:
    case "HalfResX":
      return Stereoscopic.HalfResX;
    case 6:
    case "HalfResY":
      return Stereoscopic.HalfResY;
    case 7:
    case "Full":
      return Stereoscopic.Full;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Stereoscopic.UNRECOGNIZED;
  }
}

export function stereoscopicToJSON(object: Stereoscopic): string {
  switch (object) {
    case Stereoscopic.Undef:
      return "Undef";
    case Stereoscopic.Monoscopic:
      return "Monoscopic";
    case Stereoscopic.MonoLeft:
      return "MonoLeft";
    case Stereoscopic.MonoRight:
      return "MonoRight";
    case Stereoscopic.MonoLeadingEye:
      return "MonoLeadingEye";
    case Stereoscopic.HalfResX:
      return "HalfResX";
    case Stereoscopic.HalfResY:
      return "HalfResY";
    case Stereoscopic.Full:
      return "Full";
    case Stereoscopic.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum TrackType {
  TRACKTYPE_PICTURE = 0,
  TRACKTYPE_SOUND = 1,
  TRACKTYPE_TIMECODE = 2,
  TRACKTYPE_EDGECODE = 3,
  TRACKTYPE_DATA = 4,
  UNRECOGNIZED = -1,
}

export function trackTypeFromJSON(object: any): TrackType {
  switch (object) {
    case 0:
    case "TRACKTYPE_PICTURE":
      return TrackType.TRACKTYPE_PICTURE;
    case 1:
    case "TRACKTYPE_SOUND":
      return TrackType.TRACKTYPE_SOUND;
    case 2:
    case "TRACKTYPE_TIMECODE":
      return TrackType.TRACKTYPE_TIMECODE;
    case 3:
    case "TRACKTYPE_EDGECODE":
      return TrackType.TRACKTYPE_EDGECODE;
    case 4:
    case "TRACKTYPE_DATA":
      return TrackType.TRACKTYPE_DATA;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TrackType.UNRECOGNIZED;
  }
}

export function trackTypeToJSON(object: TrackType): string {
  switch (object) {
    case TrackType.TRACKTYPE_PICTURE:
      return "TRACKTYPE_PICTURE";
    case TrackType.TRACKTYPE_SOUND:
      return "TRACKTYPE_SOUND";
    case TrackType.TRACKTYPE_TIMECODE:
      return "TRACKTYPE_TIMECODE";
    case TrackType.TRACKTYPE_EDGECODE:
      return "TRACKTYPE_EDGECODE";
    case TrackType.TRACKTYPE_DATA:
      return "TRACKTYPE_DATA";
    case TrackType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum AudioTrackType {
  UNSPECIFIED_TRACK_FORMAT = 0,
  MONO_AUDIO_TRACK_FORMAT = 1,
  STEREO_AUDIO_TRACK_FORMAT = 2,
  AUDIO_5_1_TRACK_FORMAT = 3,
  AUDIO_7_1_TRACK_FORMAT = 4,
  WIDEST_AUDIO_TRACK_FORMAT = 5,
  UNRECOGNIZED = -1,
}

export function audioTrackTypeFromJSON(object: any): AudioTrackType {
  switch (object) {
    case 0:
    case "UNSPECIFIED_TRACK_FORMAT":
      return AudioTrackType.UNSPECIFIED_TRACK_FORMAT;
    case 1:
    case "MONO_AUDIO_TRACK_FORMAT":
      return AudioTrackType.MONO_AUDIO_TRACK_FORMAT;
    case 2:
    case "STEREO_AUDIO_TRACK_FORMAT":
      return AudioTrackType.STEREO_AUDIO_TRACK_FORMAT;
    case 3:
    case "AUDIO_5_1_TRACK_FORMAT":
      return AudioTrackType.AUDIO_5_1_TRACK_FORMAT;
    case 4:
    case "AUDIO_7_1_TRACK_FORMAT":
      return AudioTrackType.AUDIO_7_1_TRACK_FORMAT;
    case 5:
    case "WIDEST_AUDIO_TRACK_FORMAT":
      return AudioTrackType.WIDEST_AUDIO_TRACK_FORMAT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AudioTrackType.UNRECOGNIZED;
  }
}

export function audioTrackTypeToJSON(object: AudioTrackType): string {
  switch (object) {
    case AudioTrackType.UNSPECIFIED_TRACK_FORMAT:
      return "UNSPECIFIED_TRACK_FORMAT";
    case AudioTrackType.MONO_AUDIO_TRACK_FORMAT:
      return "MONO_AUDIO_TRACK_FORMAT";
    case AudioTrackType.STEREO_AUDIO_TRACK_FORMAT:
      return "STEREO_AUDIO_TRACK_FORMAT";
    case AudioTrackType.AUDIO_5_1_TRACK_FORMAT:
      return "AUDIO_5_1_TRACK_FORMAT";
    case AudioTrackType.AUDIO_7_1_TRACK_FORMAT:
      return "AUDIO_7_1_TRACK_FORMAT";
    case AudioTrackType.WIDEST_AUDIO_TRACK_FORMAT:
      return "WIDEST_AUDIO_TRACK_FORMAT";
    case AudioTrackType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Type of the error message which can be returned to user.
 * It can be OS error or Media Composer error.
 */
export enum CommandErrorType {
  NoError = 0,
  /** OS_WritePermissions - Operation System errors */
  OS_WritePermissions = 1,
  /** OS_DirectoryPathNotFound - the specified location does not exist */
  OS_DirectoryPathNotFound = 2,
  /** OS_FilePathLocation - the specified file path could not be found */
  OS_FilePathLocation = 3,
  /** OS_DuplicateName - the session name to be created is a duplicate of some existing */
  OS_DuplicateName = 4,
  /** OS_ReadError - command hits read permissions or can not read specified file */
  OS_ReadError = 5,
  /** OS_DiskSpace - not enough free space on disk */
  OS_DiskSpace = 6,
  /** OS_IllegalCharacters - the session name contains illegal characters/symbols */
  OS_IllegalCharacters = 7,
  /** OS_CharactersLimit - the session/track name is too long (250 characters allowed) */
  OS_CharactersLimit = 8,
  /** OS_FileNotFound - the specified file location does not exist */
  OS_FileNotFound = 9,
  /** OS_TimeOut - time out */
  OS_TimeOut = 10,
  /** OS_FileOpenFailed - the specified file could not be open */
  OS_FileOpenFailed = 11,
  /** OS_DirectoryCannotBeCreated - The directory cannot be created */
  OS_DirectoryCannotBeCreated = 12,
  /** MC_BinNotOpened - The bin was not opened. */
  MC_BinNotOpened = 50,
  /** MC_FileExists - The file already exists */
  MC_FileExists = 51,
  /** MC_DownloadFailed - The download was failed */
  MC_DownloadFailed = 52,
  /** MC_MobNotFound - The mod ID is not found */
  MC_MobNotFound = 53,
  /** MC_BinColumnNotFound - The bin column is not found */
  MC_BinColumnNotFound = 54,
  /** MC_BinElementIsNotModifiable - The bin element is not modifiable */
  MC_BinElementIsNotModifiable = 55,
  /** MC_ProjectDataIdIsNotValid - Custom project data Id is not valid or empty */
  MC_ProjectDataIdIsNotValid = 56,
  /** MC_ProjectDatakeyIsNotValid - Custom project data key is not valid or empty */
  MC_ProjectDatakeyIsNotValid = 57,
  /** MC_AccessTokenIsNotValid - Access token is not valid or empty */
  MC_AccessTokenIsNotValid = 58,
  /** MC_EDLSettingsNotFound - No EDL List Tool settings were found */
  MC_EDLSettingsNotFound = 59,
  /** MC_ExportSettingsNotFound - No Export settings were found */
  MC_ExportSettingsNotFound = 60,
  /** MC_ImportSettingsNotFound - No Import settings were found */
  MC_ImportSettingsNotFound = 61,
  /** MC_MissedParameter - Mandatory message parameter is empty */
  MC_MissedParameter = 62,
  /** MC_ImportFileFailed - The import file was failed */
  MC_ImportFileFailed = 63,
  /** MC_ExportFileFailed - The export file was failed */
  MC_ExportFileFailed = 64,
  /** MC_ShutDown - The server was shut down */
  MC_ShutDown = 65,
  /** MC_InvalidArgument - Used argument is not correct */
  MC_InvalidArgument = 66,
  /** MC_AddMarkerFailed - Add marker finished not successfully */
  MC_AddMarkerFailed = 67,
  /** MC_ParseFileFailed - The file could not be parsed */
  MC_ParseFileFailed = 68,
  /** MC_BinNotFound - Bin file is not found in the OS file system */
  MC_BinNotFound = 69,
  /** MC_InternalError - Internal implementation error */
  MC_InternalError = 70,
  /** MC_ProjectNotOpen - Project is not opened */
  MC_ProjectNotOpen = 71,
  /** MC_InvalidMobID - Mob ID is in incorrect format */
  MC_InvalidMobID = 72,
  /** MC_MediaComposerIsBusy - Media Composer is busy or modial dialog is active */
  MC_MediaComposerIsBusy = 73,
  MC_EDLComposeFailed = 74,
  MC_EDLDecomposeFailed = 75,
  MC_EDLNotSuportedFrameRate = 76,
  MC_BinIsLocked = 77,
  /** MC_LinkSettingsNotFound - No Link settings were found */
  MC_LinkSettingsNotFound = 78,
  MC_MarkerNotFound = 79,
  MC_MarkerCollision = 80,
  /** MC_UnknownError - MC errors */
  MC_UnknownError = 1000,
  UNRECOGNIZED = -1,
}

export function commandErrorTypeFromJSON(object: any): CommandErrorType {
  switch (object) {
    case 0:
    case "NoError":
      return CommandErrorType.NoError;
    case 1:
    case "OS_WritePermissions":
      return CommandErrorType.OS_WritePermissions;
    case 2:
    case "OS_DirectoryPathNotFound":
      return CommandErrorType.OS_DirectoryPathNotFound;
    case 3:
    case "OS_FilePathLocation":
      return CommandErrorType.OS_FilePathLocation;
    case 4:
    case "OS_DuplicateName":
      return CommandErrorType.OS_DuplicateName;
    case 5:
    case "OS_ReadError":
      return CommandErrorType.OS_ReadError;
    case 6:
    case "OS_DiskSpace":
      return CommandErrorType.OS_DiskSpace;
    case 7:
    case "OS_IllegalCharacters":
      return CommandErrorType.OS_IllegalCharacters;
    case 8:
    case "OS_CharactersLimit":
      return CommandErrorType.OS_CharactersLimit;
    case 9:
    case "OS_FileNotFound":
      return CommandErrorType.OS_FileNotFound;
    case 10:
    case "OS_TimeOut":
      return CommandErrorType.OS_TimeOut;
    case 11:
    case "OS_FileOpenFailed":
      return CommandErrorType.OS_FileOpenFailed;
    case 12:
    case "OS_DirectoryCannotBeCreated":
      return CommandErrorType.OS_DirectoryCannotBeCreated;
    case 50:
    case "MC_BinNotOpened":
      return CommandErrorType.MC_BinNotOpened;
    case 51:
    case "MC_FileExists":
      return CommandErrorType.MC_FileExists;
    case 52:
    case "MC_DownloadFailed":
      return CommandErrorType.MC_DownloadFailed;
    case 53:
    case "MC_MobNotFound":
      return CommandErrorType.MC_MobNotFound;
    case 54:
    case "MC_BinColumnNotFound":
      return CommandErrorType.MC_BinColumnNotFound;
    case 55:
    case "MC_BinElementIsNotModifiable":
      return CommandErrorType.MC_BinElementIsNotModifiable;
    case 56:
    case "MC_ProjectDataIdIsNotValid":
      return CommandErrorType.MC_ProjectDataIdIsNotValid;
    case 57:
    case "MC_ProjectDatakeyIsNotValid":
      return CommandErrorType.MC_ProjectDatakeyIsNotValid;
    case 58:
    case "MC_AccessTokenIsNotValid":
      return CommandErrorType.MC_AccessTokenIsNotValid;
    case 59:
    case "MC_EDLSettingsNotFound":
      return CommandErrorType.MC_EDLSettingsNotFound;
    case 60:
    case "MC_ExportSettingsNotFound":
      return CommandErrorType.MC_ExportSettingsNotFound;
    case 61:
    case "MC_ImportSettingsNotFound":
      return CommandErrorType.MC_ImportSettingsNotFound;
    case 62:
    case "MC_MissedParameter":
      return CommandErrorType.MC_MissedParameter;
    case 63:
    case "MC_ImportFileFailed":
      return CommandErrorType.MC_ImportFileFailed;
    case 64:
    case "MC_ExportFileFailed":
      return CommandErrorType.MC_ExportFileFailed;
    case 65:
    case "MC_ShutDown":
      return CommandErrorType.MC_ShutDown;
    case 66:
    case "MC_InvalidArgument":
      return CommandErrorType.MC_InvalidArgument;
    case 67:
    case "MC_AddMarkerFailed":
      return CommandErrorType.MC_AddMarkerFailed;
    case 68:
    case "MC_ParseFileFailed":
      return CommandErrorType.MC_ParseFileFailed;
    case 69:
    case "MC_BinNotFound":
      return CommandErrorType.MC_BinNotFound;
    case 70:
    case "MC_InternalError":
      return CommandErrorType.MC_InternalError;
    case 71:
    case "MC_ProjectNotOpen":
      return CommandErrorType.MC_ProjectNotOpen;
    case 72:
    case "MC_InvalidMobID":
      return CommandErrorType.MC_InvalidMobID;
    case 73:
    case "MC_MediaComposerIsBusy":
      return CommandErrorType.MC_MediaComposerIsBusy;
    case 74:
    case "MC_EDLComposeFailed":
      return CommandErrorType.MC_EDLComposeFailed;
    case 75:
    case "MC_EDLDecomposeFailed":
      return CommandErrorType.MC_EDLDecomposeFailed;
    case 76:
    case "MC_EDLNotSuportedFrameRate":
      return CommandErrorType.MC_EDLNotSuportedFrameRate;
    case 77:
    case "MC_BinIsLocked":
      return CommandErrorType.MC_BinIsLocked;
    case 78:
    case "MC_LinkSettingsNotFound":
      return CommandErrorType.MC_LinkSettingsNotFound;
    case 79:
    case "MC_MarkerNotFound":
      return CommandErrorType.MC_MarkerNotFound;
    case 80:
    case "MC_MarkerCollision":
      return CommandErrorType.MC_MarkerCollision;
    case 1000:
    case "MC_UnknownError":
      return CommandErrorType.MC_UnknownError;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CommandErrorType.UNRECOGNIZED;
  }
}

export function commandErrorTypeToJSON(object: CommandErrorType): string {
  switch (object) {
    case CommandErrorType.NoError:
      return "NoError";
    case CommandErrorType.OS_WritePermissions:
      return "OS_WritePermissions";
    case CommandErrorType.OS_DirectoryPathNotFound:
      return "OS_DirectoryPathNotFound";
    case CommandErrorType.OS_FilePathLocation:
      return "OS_FilePathLocation";
    case CommandErrorType.OS_DuplicateName:
      return "OS_DuplicateName";
    case CommandErrorType.OS_ReadError:
      return "OS_ReadError";
    case CommandErrorType.OS_DiskSpace:
      return "OS_DiskSpace";
    case CommandErrorType.OS_IllegalCharacters:
      return "OS_IllegalCharacters";
    case CommandErrorType.OS_CharactersLimit:
      return "OS_CharactersLimit";
    case CommandErrorType.OS_FileNotFound:
      return "OS_FileNotFound";
    case CommandErrorType.OS_TimeOut:
      return "OS_TimeOut";
    case CommandErrorType.OS_FileOpenFailed:
      return "OS_FileOpenFailed";
    case CommandErrorType.OS_DirectoryCannotBeCreated:
      return "OS_DirectoryCannotBeCreated";
    case CommandErrorType.MC_BinNotOpened:
      return "MC_BinNotOpened";
    case CommandErrorType.MC_FileExists:
      return "MC_FileExists";
    case CommandErrorType.MC_DownloadFailed:
      return "MC_DownloadFailed";
    case CommandErrorType.MC_MobNotFound:
      return "MC_MobNotFound";
    case CommandErrorType.MC_BinColumnNotFound:
      return "MC_BinColumnNotFound";
    case CommandErrorType.MC_BinElementIsNotModifiable:
      return "MC_BinElementIsNotModifiable";
    case CommandErrorType.MC_ProjectDataIdIsNotValid:
      return "MC_ProjectDataIdIsNotValid";
    case CommandErrorType.MC_ProjectDatakeyIsNotValid:
      return "MC_ProjectDatakeyIsNotValid";
    case CommandErrorType.MC_AccessTokenIsNotValid:
      return "MC_AccessTokenIsNotValid";
    case CommandErrorType.MC_EDLSettingsNotFound:
      return "MC_EDLSettingsNotFound";
    case CommandErrorType.MC_ExportSettingsNotFound:
      return "MC_ExportSettingsNotFound";
    case CommandErrorType.MC_ImportSettingsNotFound:
      return "MC_ImportSettingsNotFound";
    case CommandErrorType.MC_MissedParameter:
      return "MC_MissedParameter";
    case CommandErrorType.MC_ImportFileFailed:
      return "MC_ImportFileFailed";
    case CommandErrorType.MC_ExportFileFailed:
      return "MC_ExportFileFailed";
    case CommandErrorType.MC_ShutDown:
      return "MC_ShutDown";
    case CommandErrorType.MC_InvalidArgument:
      return "MC_InvalidArgument";
    case CommandErrorType.MC_AddMarkerFailed:
      return "MC_AddMarkerFailed";
    case CommandErrorType.MC_ParseFileFailed:
      return "MC_ParseFileFailed";
    case CommandErrorType.MC_BinNotFound:
      return "MC_BinNotFound";
    case CommandErrorType.MC_InternalError:
      return "MC_InternalError";
    case CommandErrorType.MC_ProjectNotOpen:
      return "MC_ProjectNotOpen";
    case CommandErrorType.MC_InvalidMobID:
      return "MC_InvalidMobID";
    case CommandErrorType.MC_MediaComposerIsBusy:
      return "MC_MediaComposerIsBusy";
    case CommandErrorType.MC_EDLComposeFailed:
      return "MC_EDLComposeFailed";
    case CommandErrorType.MC_EDLDecomposeFailed:
      return "MC_EDLDecomposeFailed";
    case CommandErrorType.MC_EDLNotSuportedFrameRate:
      return "MC_EDLNotSuportedFrameRate";
    case CommandErrorType.MC_BinIsLocked:
      return "MC_BinIsLocked";
    case CommandErrorType.MC_LinkSettingsNotFound:
      return "MC_LinkSettingsNotFound";
    case CommandErrorType.MC_MarkerNotFound:
      return "MC_MarkerNotFound";
    case CommandErrorType.MC_MarkerCollision:
      return "MC_MarkerCollision";
    case CommandErrorType.MC_UnknownError:
      return "MC_UnknownError";
    case CommandErrorType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Status of execution of the MC task. */
export enum TaskStatus {
  /** Queued - Waiting for a request to come in. */
  Queued = 0,
  /** Pending - The request was received, waiting to be processed. */
  Pending = 1,
  /** InProgress - The request is being processed. */
  InProgress = 2,
  /** Completed - The request was completed successfully. */
  Completed = 3,
  /** Failed - The request was failed with a error. */
  Failed = 4,
  /** WaitingForUserInput - need wait for user input, for example if MC license required */
  WaitingForUserInput = 5,
  UNRECOGNIZED = -1,
}

export function taskStatusFromJSON(object: any): TaskStatus {
  switch (object) {
    case 0:
    case "Queued":
      return TaskStatus.Queued;
    case 1:
    case "Pending":
      return TaskStatus.Pending;
    case 2:
    case "InProgress":
      return TaskStatus.InProgress;
    case 3:
    case "Completed":
      return TaskStatus.Completed;
    case 4:
    case "Failed":
      return TaskStatus.Failed;
    case 5:
    case "WaitingForUserInput":
      return TaskStatus.WaitingForUserInput;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TaskStatus.UNRECOGNIZED;
  }
}

export function taskStatusToJSON(object: TaskStatus): string {
  switch (object) {
    case TaskStatus.Queued:
      return "Queued";
    case TaskStatus.Pending:
      return "Pending";
    case TaskStatus.InProgress:
      return "InProgress";
    case TaskStatus.Completed:
      return "Completed";
    case TaskStatus.Failed:
      return "Failed";
    case TaskStatus.WaitingForUserInput:
      return "WaitingForUserInput";
    case TaskStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ExportFileOption {
  /** Export_StopIf_MixedAudio - Stop the Export if mixed audio sample rates are detected. (exported file may not be playable in other applications) */
  Export_StopIf_MixedAudio = 0,
  /** Export_StopIf_OfflineMedia - Stop the Export if mob contains offline media */
  Export_StopIf_OfflineMedia = 1,
  /** Export_StopIf_UnknownFX - Stop the Export if sequence contains unloaded or unknown effects */
  Export_StopIf_UnknownFX = 2,
  /** Export_StopIf_LongGOP - Stop the Export if a clip contains LongGOP media. Such media is not supported for embedded export. If export continues, such media will not be added to the exported file. */
  Export_StopIf_LongGOP = 3,
  /** Export_StopIf_NonNative - Stop the Export if the linked clip contains non-native media. Such media is not supported for embedded export. If export continues, such media will not be added to the exported file. */
  Export_StopIf_NonNative = 4,
  /** Export_StopIf_32kHzAudio - Stop the Export if mob  contains 32kHz audio */
  Export_StopIf_32kHzAudio = 5,
  /** Export_OMF_Audio_To_WAVE - If the OMF export setting spec for audio is not currently supported, continue export and convert audio to WAVE. */
  Export_OMF_Audio_To_WAVE = 6,
  /** Export_OMF_Audio_To_AIFFC - If the OMF export setting spec for audio is not currently supported, continue export and convert audio to AIFFC. */
  Export_OMF_Audio_To_AIFFC = 7,
  /** Export_Conver_Audio_To_PCM - If the embedded AAF export setting for audio is not currently supported, continue export and convert audio to PCM. */
  Export_Conver_Audio_To_PCM = 8,
  /** Export_StopIf_Color_Will_Not_Seen_In_Quick_Time_Reference - If the sequence contains color correction, and it will thus not be seen in the QT reference, stop the export. */
  Export_StopIf_Color_Will_Not_Seen_In_Quick_Time_Reference = 9,
  /** Export_StopIf_Cannot_Export_Mixed_Resolution_Sequence - If the AVI export setting spec uses Source Compression and it's a mixed resolution sequence, stop the export (would take long). */
  Export_StopIf_Cannot_Export_Mixed_Resolution_Sequence = 10,
  /** Export_Keep_Partial_Render - If export stops while rendering effects, then keep the partial render. */
  Export_Keep_Partial_Render = 11,
  /** Export_StopIf_Some_Audio_Clips_Do_Not_Match_Current_Hardware_Or_Software_Sample_Rate - If audio clips that do not match HW/SW rate are present and will thus be rendered as silent, stop the export. */
  Export_StopIf_Some_Audio_Clips_Do_Not_Match_Current_Hardware_Or_Software_Sample_Rate = 12,
  /** Export_StopIf_Current_Master_Fader_Format_Cannot_Accomodate_Surround_Or_7_1_Surround_Tracks - If the current master fader format cannot accomodate surround or 7.1 tracks and the master fader gain and effects will thus not be applied, stop the export. */
  Export_StopIf_Current_Master_Fader_Format_Cannot_Accomodate_Surround_Or_7_1_Surround_Tracks = 13,
  /** Export_StopIf_Some_Clips_Dont_Have_High_Resolution_Video_Available - If some clips do not have High Resolution video, don't use proxy - stop the export. */
  Export_StopIf_Some_Clips_Dont_Have_High_Resolution_Video_Available = 14,
  UNRECOGNIZED = -1,
}

export function exportFileOptionFromJSON(object: any): ExportFileOption {
  switch (object) {
    case 0:
    case "Export_StopIf_MixedAudio":
      return ExportFileOption.Export_StopIf_MixedAudio;
    case 1:
    case "Export_StopIf_OfflineMedia":
      return ExportFileOption.Export_StopIf_OfflineMedia;
    case 2:
    case "Export_StopIf_UnknownFX":
      return ExportFileOption.Export_StopIf_UnknownFX;
    case 3:
    case "Export_StopIf_LongGOP":
      return ExportFileOption.Export_StopIf_LongGOP;
    case 4:
    case "Export_StopIf_NonNative":
      return ExportFileOption.Export_StopIf_NonNative;
    case 5:
    case "Export_StopIf_32kHzAudio":
      return ExportFileOption.Export_StopIf_32kHzAudio;
    case 6:
    case "Export_OMF_Audio_To_WAVE":
      return ExportFileOption.Export_OMF_Audio_To_WAVE;
    case 7:
    case "Export_OMF_Audio_To_AIFFC":
      return ExportFileOption.Export_OMF_Audio_To_AIFFC;
    case 8:
    case "Export_Conver_Audio_To_PCM":
      return ExportFileOption.Export_Conver_Audio_To_PCM;
    case 9:
    case "Export_StopIf_Color_Will_Not_Seen_In_Quick_Time_Reference":
      return ExportFileOption.Export_StopIf_Color_Will_Not_Seen_In_Quick_Time_Reference;
    case 10:
    case "Export_StopIf_Cannot_Export_Mixed_Resolution_Sequence":
      return ExportFileOption.Export_StopIf_Cannot_Export_Mixed_Resolution_Sequence;
    case 11:
    case "Export_Keep_Partial_Render":
      return ExportFileOption.Export_Keep_Partial_Render;
    case 12:
    case "Export_StopIf_Some_Audio_Clips_Do_Not_Match_Current_Hardware_Or_Software_Sample_Rate":
      return ExportFileOption.Export_StopIf_Some_Audio_Clips_Do_Not_Match_Current_Hardware_Or_Software_Sample_Rate;
    case 13:
    case "Export_StopIf_Current_Master_Fader_Format_Cannot_Accomodate_Surround_Or_7_1_Surround_Tracks":
      return ExportFileOption
        .Export_StopIf_Current_Master_Fader_Format_Cannot_Accomodate_Surround_Or_7_1_Surround_Tracks;
    case 14:
    case "Export_StopIf_Some_Clips_Dont_Have_High_Resolution_Video_Available":
      return ExportFileOption.Export_StopIf_Some_Clips_Dont_Have_High_Resolution_Video_Available;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ExportFileOption.UNRECOGNIZED;
  }
}

export function exportFileOptionToJSON(object: ExportFileOption): string {
  switch (object) {
    case ExportFileOption.Export_StopIf_MixedAudio:
      return "Export_StopIf_MixedAudio";
    case ExportFileOption.Export_StopIf_OfflineMedia:
      return "Export_StopIf_OfflineMedia";
    case ExportFileOption.Export_StopIf_UnknownFX:
      return "Export_StopIf_UnknownFX";
    case ExportFileOption.Export_StopIf_LongGOP:
      return "Export_StopIf_LongGOP";
    case ExportFileOption.Export_StopIf_NonNative:
      return "Export_StopIf_NonNative";
    case ExportFileOption.Export_StopIf_32kHzAudio:
      return "Export_StopIf_32kHzAudio";
    case ExportFileOption.Export_OMF_Audio_To_WAVE:
      return "Export_OMF_Audio_To_WAVE";
    case ExportFileOption.Export_OMF_Audio_To_AIFFC:
      return "Export_OMF_Audio_To_AIFFC";
    case ExportFileOption.Export_Conver_Audio_To_PCM:
      return "Export_Conver_Audio_To_PCM";
    case ExportFileOption.Export_StopIf_Color_Will_Not_Seen_In_Quick_Time_Reference:
      return "Export_StopIf_Color_Will_Not_Seen_In_Quick_Time_Reference";
    case ExportFileOption.Export_StopIf_Cannot_Export_Mixed_Resolution_Sequence:
      return "Export_StopIf_Cannot_Export_Mixed_Resolution_Sequence";
    case ExportFileOption.Export_Keep_Partial_Render:
      return "Export_Keep_Partial_Render";
    case ExportFileOption.Export_StopIf_Some_Audio_Clips_Do_Not_Match_Current_Hardware_Or_Software_Sample_Rate:
      return "Export_StopIf_Some_Audio_Clips_Do_Not_Match_Current_Hardware_Or_Software_Sample_Rate";
    case ExportFileOption.Export_StopIf_Current_Master_Fader_Format_Cannot_Accomodate_Surround_Or_7_1_Surround_Tracks:
      return "Export_StopIf_Current_Master_Fader_Format_Cannot_Accomodate_Surround_Or_7_1_Surround_Tracks";
    case ExportFileOption.Export_StopIf_Some_Clips_Dont_Have_High_Resolution_Video_Available:
      return "Export_StopIf_Some_Clips_Dont_Have_High_Resolution_Video_Available";
    case ExportFileOption.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ImportFileOption {
  /** Import_StopIf_Media_No_in_DB -  */
  Import_StopIf_Media_No_in_DB = 0,
  UNRECOGNIZED = -1,
}

export function importFileOptionFromJSON(object: any): ImportFileOption {
  switch (object) {
    case 0:
    case "Import_StopIf_Media_No_in_DB":
      return ImportFileOption.Import_StopIf_Media_No_in_DB;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ImportFileOption.UNRECOGNIZED;
  }
}

export function importFileOptionToJSON(object: ImportFileOption): string {
  switch (object) {
    case ImportFileOption.Import_StopIf_Media_No_in_DB:
      return "Import_StopIf_Media_No_in_DB";
    case ImportFileOption.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Colors of markers */
export enum MarkerColor {
  Red = 0,
  Green = 1,
  Blue = 2,
  Cyan = 3,
  Magenta = 4,
  Yellow = 5,
  Black = 6,
  White = 7,
  UNRECOGNIZED = -1,
}

export function markerColorFromJSON(object: any): MarkerColor {
  switch (object) {
    case 0:
    case "Red":
      return MarkerColor.Red;
    case 1:
    case "Green":
      return MarkerColor.Green;
    case 2:
    case "Blue":
      return MarkerColor.Blue;
    case 3:
    case "Cyan":
      return MarkerColor.Cyan;
    case 4:
    case "Magenta":
      return MarkerColor.Magenta;
    case 5:
    case "Yellow":
      return MarkerColor.Yellow;
    case 6:
    case "Black":
      return MarkerColor.Black;
    case 7:
    case "White":
      return MarkerColor.White;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MarkerColor.UNRECOGNIZED;
  }
}

export function markerColorToJSON(object: MarkerColor): string {
  switch (object) {
    case MarkerColor.Red:
      return "Red";
    case MarkerColor.Green:
      return "Green";
    case MarkerColor.Blue:
      return "Blue";
    case MarkerColor.Cyan:
      return "Cyan";
    case MarkerColor.Magenta:
      return "Magenta";
    case MarkerColor.Yellow:
      return "Yellow";
    case MarkerColor.Black:
      return "Black";
    case MarkerColor.White:
      return "White";
    case MarkerColor.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ViewerType {
  /** Source - can display clips or sequences */
  Source = 0,
  /** Record - can display only sequences */
  Record = 1,
  /** Popup - can display clips or sequences */
  Popup = 2,
  UNRECOGNIZED = -1,
}

export function viewerTypeFromJSON(object: any): ViewerType {
  switch (object) {
    case 0:
    case "Source":
      return ViewerType.Source;
    case 1:
    case "Record":
      return ViewerType.Record;
    case 2:
    case "Popup":
      return ViewerType.Popup;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ViewerType.UNRECOGNIZED;
  }
}

export function viewerTypeToJSON(object: ViewerType): string {
  switch (object) {
    case ViewerType.Source:
      return "Source";
    case ViewerType.Record:
      return "Record";
    case ViewerType.Popup:
      return "Popup";
    case ViewerType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** The request of GetListOfBinItems() */
export interface GetListOfBinItemsRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: GetListOfBinItemsRequestBody | undefined;
}

/** The response of GetListOfBinItems() */
export interface GetListOfBinItemsResponse {
  /** Response header */
  header:
    | ResponseHeader
    | undefined;
  /** Response body */
  body: GetListOfBinItemsResponseBody | undefined;
}

/** The body of GetListOfBinItems */
export interface GetListOfBinItemsRequestBody {
  binRelativePath: string;
  binFlags: GetListOfBinItemsRequestBody_BinItemFlags[];
  onlyVisibleFlag: boolean;
  onlySelectedFlag: boolean;
}

export enum GetListOfBinItemsRequestBody_BinItemFlags {
  AllTypes = 0,
  masterClips = 1,
  linkedMasterClips = 2,
  subclips = 3,
  sequences = 4,
  sources = 5,
  effects = 6,
  motionEffects = 7,
  preCompsRE = 8,
  preCompsTMK = 9,
  groups = 10,
  stereoscopicClips = 11,
  UNRECOGNIZED = -1,
}

export function getListOfBinItemsRequestBody_BinItemFlagsFromJSON(
  object: any,
): GetListOfBinItemsRequestBody_BinItemFlags {
  switch (object) {
    case 0:
    case "AllTypes":
      return GetListOfBinItemsRequestBody_BinItemFlags.AllTypes;
    case 1:
    case "masterClips":
      return GetListOfBinItemsRequestBody_BinItemFlags.masterClips;
    case 2:
    case "linkedMasterClips":
      return GetListOfBinItemsRequestBody_BinItemFlags.linkedMasterClips;
    case 3:
    case "subclips":
      return GetListOfBinItemsRequestBody_BinItemFlags.subclips;
    case 4:
    case "sequences":
      return GetListOfBinItemsRequestBody_BinItemFlags.sequences;
    case 5:
    case "sources":
      return GetListOfBinItemsRequestBody_BinItemFlags.sources;
    case 6:
    case "effects":
      return GetListOfBinItemsRequestBody_BinItemFlags.effects;
    case 7:
    case "motionEffects":
      return GetListOfBinItemsRequestBody_BinItemFlags.motionEffects;
    case 8:
    case "preCompsRE":
      return GetListOfBinItemsRequestBody_BinItemFlags.preCompsRE;
    case 9:
    case "preCompsTMK":
      return GetListOfBinItemsRequestBody_BinItemFlags.preCompsTMK;
    case 10:
    case "groups":
      return GetListOfBinItemsRequestBody_BinItemFlags.groups;
    case 11:
    case "stereoscopicClips":
      return GetListOfBinItemsRequestBody_BinItemFlags.stereoscopicClips;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GetListOfBinItemsRequestBody_BinItemFlags.UNRECOGNIZED;
  }
}

export function getListOfBinItemsRequestBody_BinItemFlagsToJSON(
  object: GetListOfBinItemsRequestBody_BinItemFlags,
): string {
  switch (object) {
    case GetListOfBinItemsRequestBody_BinItemFlags.AllTypes:
      return "AllTypes";
    case GetListOfBinItemsRequestBody_BinItemFlags.masterClips:
      return "masterClips";
    case GetListOfBinItemsRequestBody_BinItemFlags.linkedMasterClips:
      return "linkedMasterClips";
    case GetListOfBinItemsRequestBody_BinItemFlags.subclips:
      return "subclips";
    case GetListOfBinItemsRequestBody_BinItemFlags.sequences:
      return "sequences";
    case GetListOfBinItemsRequestBody_BinItemFlags.sources:
      return "sources";
    case GetListOfBinItemsRequestBody_BinItemFlags.effects:
      return "effects";
    case GetListOfBinItemsRequestBody_BinItemFlags.motionEffects:
      return "motionEffects";
    case GetListOfBinItemsRequestBody_BinItemFlags.preCompsRE:
      return "preCompsRE";
    case GetListOfBinItemsRequestBody_BinItemFlags.preCompsTMK:
      return "preCompsTMK";
    case GetListOfBinItemsRequestBody_BinItemFlags.groups:
      return "groups";
    case GetListOfBinItemsRequestBody_BinItemFlags.stereoscopicClips:
      return "stereoscopicClips";
    case GetListOfBinItemsRequestBody_BinItemFlags.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** The body of GetListOfBinItems */
export interface GetListOfBinItemsResponseBody {
  /** The message to be returned from the server */
  mobName: string;
  mobId: string;
  mobSelected: boolean;
}

/** The request of Echo() */
export interface EchoRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: EchoRequestBody | undefined;
}

/** The response of Echo() */
export interface EchoResponse {
  /** Response header */
  header:
    | ResponseHeader
    | undefined;
  /** Response body */
  body: EchoResponseBody | undefined;
}

/** The body of EchoRequest */
export interface EchoRequestBody {
  /** The message to be sent to the server */
  message: string;
}

/** The body of EchoResponse */
export interface EchoResponseBody {
  /** The message to be returned from the server */
  message: string;
}

/** The request of GetValues */
export interface GetValuesRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: GetValuesRequestBody | undefined;
}

/** The response of GetValues */
export interface GetValuesResponse {
  /** Response header */
  header:
    | ResponseHeader
    | undefined;
  /** Response body */
  body: GetValuesResponseBody | undefined;
}

/** The body of GetValuesRequest */
export interface GetValuesRequestBody {
  key: string;
  count: number;
}

/** The body of message GetValuesResponse */
export interface GetValuesResponseBody {
  value: string;
}

/** The request of GetAppInfo() */
export interface GetAppInfoRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: GetAppInfoRequestBody | undefined;
}

/** The body of GetAppInfoRequest */
export interface GetAppInfoRequestBody {
}

/** The response of GetAppInfo() */
export interface GetAppInfoResponse {
  /** Request header */
  header:
    | ResponseHeader
    | undefined;
  /** Request body */
  body: GetAppInfoResponseBody | undefined;
}

/** The body of GetAppInfoResponse */
export interface GetAppInfoResponseBody {
  /** The name of the application */
  appName: string;
  /** The version of the application */
  appVersion: string;
  /** The busy status of the application */
  appBusyStatus: GetAppInfoResponseBody_AppBusyStatus;
  /** The version of panel SDK */
  sdkVersion: string;
}

/** Status Media Composer app */
export enum GetAppInfoResponseBody_AppBusyStatus {
  /** Idle - Media Composer is idle */
  Idle = 0,
  /** Playing - Media Composer is playing */
  Playing = 1,
  /** ModalDialog - A modal dialog is being displayed */
  ModalDialog = 2,
  /** Busy - Media Composer is busy (displaying spining cursor) */
  Busy = 3,
  UNRECOGNIZED = -1,
}

export function getAppInfoResponseBody_AppBusyStatusFromJSON(object: any): GetAppInfoResponseBody_AppBusyStatus {
  switch (object) {
    case 0:
    case "Idle":
      return GetAppInfoResponseBody_AppBusyStatus.Idle;
    case 1:
    case "Playing":
      return GetAppInfoResponseBody_AppBusyStatus.Playing;
    case 2:
    case "ModalDialog":
      return GetAppInfoResponseBody_AppBusyStatus.ModalDialog;
    case 3:
    case "Busy":
      return GetAppInfoResponseBody_AppBusyStatus.Busy;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GetAppInfoResponseBody_AppBusyStatus.UNRECOGNIZED;
  }
}

export function getAppInfoResponseBody_AppBusyStatusToJSON(object: GetAppInfoResponseBody_AppBusyStatus): string {
  switch (object) {
    case GetAppInfoResponseBody_AppBusyStatus.Idle:
      return "Idle";
    case GetAppInfoResponseBody_AppBusyStatus.Playing:
      return "Playing";
    case GetAppInfoResponseBody_AppBusyStatus.ModalDialog:
      return "ModalDialog";
    case GetAppInfoResponseBody_AppBusyStatus.Busy:
      return "Busy";
    case GetAppInfoResponseBody_AppBusyStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** The request of GetHostInfo() */
export interface GetHostInfoRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: GetHostInfoRequestBody | undefined;
}

/** The body of GetHostInfoRequest */
export interface GetHostInfoRequestBody {
}

/** The response of GetHostInfo() */
export interface GetHostInfoResponse {
  /** Request header */
  header:
    | ResponseHeader
    | undefined;
  /** Request body */
  body: GetHostInfoResponseBody | undefined;
}

/** The body of GetHostInfoResponse */
export interface GetHostInfoResponseBody {
  /** The name of application executable */
  applName: string;
  /** The username */
  userName: string;
  /** The name of workstation */
  workstationName: string;
}

/** The request of GetBins */
export interface GetBinsRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: GetBinsRequestBody | undefined;
}

/** The body of GetBinsRequest */
export interface GetBinsRequestBody {
  /** Project path. For performance reasons, leave empty if requesting the bins in the currently open project. */
  projectPath?:
    | string
    | undefined;
  /** Specifies which type to be returned */
  requestFlag: GetBinsRequestBody_GetBinsFlag[];
}

/** Specifies which types to be returned */
export enum GetBinsRequestBody_GetBinsFlag {
  /** AllTypes - All bin types */
  AllTypes = 0,
  /** BinType - Bin */
  BinType = 1,
  /** ScriptType - Script */
  ScriptType = 2,
  /** VolumeType - Volume Bin */
  VolumeType = 3,
  OnlyOpen = 4,
  UNRECOGNIZED = -1,
}

export function getBinsRequestBody_GetBinsFlagFromJSON(object: any): GetBinsRequestBody_GetBinsFlag {
  switch (object) {
    case 0:
    case "AllTypes":
      return GetBinsRequestBody_GetBinsFlag.AllTypes;
    case 1:
    case "BinType":
      return GetBinsRequestBody_GetBinsFlag.BinType;
    case 2:
    case "ScriptType":
      return GetBinsRequestBody_GetBinsFlag.ScriptType;
    case 3:
    case "VolumeType":
      return GetBinsRequestBody_GetBinsFlag.VolumeType;
    case 4:
    case "OnlyOpen":
      return GetBinsRequestBody_GetBinsFlag.OnlyOpen;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GetBinsRequestBody_GetBinsFlag.UNRECOGNIZED;
  }
}

export function getBinsRequestBody_GetBinsFlagToJSON(object: GetBinsRequestBody_GetBinsFlag): string {
  switch (object) {
    case GetBinsRequestBody_GetBinsFlag.AllTypes:
      return "AllTypes";
    case GetBinsRequestBody_GetBinsFlag.BinType:
      return "BinType";
    case GetBinsRequestBody_GetBinsFlag.ScriptType:
      return "ScriptType";
    case GetBinsRequestBody_GetBinsFlag.VolumeType:
      return "VolumeType";
    case GetBinsRequestBody_GetBinsFlag.OnlyOpen:
      return "OnlyOpen";
    case GetBinsRequestBody_GetBinsFlag.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** The response of GetBins */
export interface GetBinsResponse {
  header: ResponseHeader | undefined;
  body: GetBinsResponseBody | undefined;
}

/** The body of GetBinsResponse */
export interface GetBinsResponseBody {
  /** Absolute path, including name and extension */
  absolutePath: string;
}

/** The request of GetBinInfo() */
export interface GetBinInfoRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: GetBinInfoRequestBody | undefined;
}

/** The body of GetBinInfoRequest */
export interface GetBinInfoRequestBody {
  /** Bin path relative to project path */
  relativeBinPath: string;
}

/** The response of GetBinInfo */
export interface GetBinInfoResponse {
  /** Response header */
  header:
    | ResponseHeader
    | undefined;
  /** Response body */
  body: GetBinInfoResponseBody | undefined;
}

/** The body of GetBinInfoResponse */
export interface GetBinInfoResponseBody {
  /** True if the bin is locked */
  lockState: boolean;
  /** Username of the lock's owner */
  lockOwner: string;
  /** The size of the bin (unit ?) */
  size: number;
  /** True if the bin was opened, false otherwise */
  isOpen: boolean;
  /** Bin's background color. In this format: '#rrggbb' */
  backgroundColor: string;
}

/** The request of GetBinColumnInfo() */
export interface GetBinColumnInfoRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: GetBinColumnInfoRequestBody | undefined;
}

/** The body of GetBinColumnInfoRequest */
export interface GetBinColumnInfoRequestBody {
  /** Bin path can be relative to project folder or an absolute path */
  binPath: string;
}

/** The response of GetBinColumnInfo() */
export interface GetBinColumnInfoResponse {
  /** Response header */
  header:
    | ResponseHeader
    | undefined;
  /** Response body */
  body: GetBinColumnInfoResponseBody | undefined;
}

/** The body of GetBinColumnInfoResponse */
export interface GetBinColumnInfoResponseBody {
  /** Contains the information of all bin columns */
  column: GetBinColumnInfoResponseBody_BinColumnInfo[];
}

export interface GetBinColumnInfoResponseBody_BinColumnInfo {
  /** Bin column name */
  columnName: string;
  /** The type of the bin column value, such as string, integer, float, etc. */
  columnValueType: string;
  /** True if the bin column is hidden */
  columnHidden: boolean;
  /** True if the bin column is user custom column */
  columnIsCustom: boolean;
  /** True if the bin column cant be modified */
  columnIsReadonly: boolean;
}

/** The request of GetMobInfo */
export interface GetMobInfoRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: GetMobInfoRequestBody | undefined;
}

/**
 * The body of GetMobInfoRequest. For better performance,
 * set only_visible_columns to true or includes_empty_columns to false.
 */
export interface GetMobInfoRequestBody {
  /** SMPTE formatted mob ID string returned from GetMobContent() */
  mobId: string;
  /** True if we only want to include visible columns */
  onlyVisibleColumns: boolean;
  /** True if we want to also includes empty columns. */
  includesEmptyColumns: boolean;
}

/** The response of GetMobInfo */
export interface GetMobInfoResponse {
  /** Repsponse header */
  header:
    | ResponseHeader
    | undefined;
  /** The body of GetMobInfoResponse */
  body: GetMobInfoResponseBody | undefined;
}

/** Contains the information of a single column */
export interface GetMobInfoResponseBody {
  /** Column name */
  columnName: string;
  /** Column value. For clip color, returned value will be in the format "#RRGGBB" */
  columnValue: string;
  /** The type of the column value, such as string, integer, float, etc. */
  columnValueType: string;
  /** True if the column is hidden */
  columnHidden: boolean;
  /** True if the column is user custom column */
  columnIsCustom: boolean;
}

/** The request of SetMobInfo() */
export interface SetMobInfoRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: SetMobInfoRequestBody | undefined;
}

/** The body of SetMobInfoRequest */
export interface SetMobInfoRequestBody {
  /** SMPTE formatted mob ID strings returned from GetListOfBinItems() */
  mobId: string;
  /** The column to be set */
  column: ColumnInfo | undefined;
}

/** Describes the column info */
export interface ColumnInfo {
  /** Column name */
  columnName: string;
  /**
   * Column value. For columns supported by menu picks,
   * the English string will be supported. For clip color, use the format "#RRGGBB"
   */
  columnValue: string;
}

/** The response of SetMobInfo */
export interface SetMobInfoResponse {
  /** Response header */
  header:
    | ResponseHeader
    | undefined;
  /** The body of SetMobInfoResponse */
  body: SetMobInfoResponseBody | undefined;
}

/** Contains the information of a single column */
export interface SetMobInfoResponseBody {
  /** @deprecated */
  mobFailure: SetMobInfoResponseBody_MobFailure[];
}

/** Describes the detail of SetMobInfo failure */
export interface SetMobInfoResponseBody_MobFailure {
  /** SMPTE formatted mob ID strings returned from GetListOfBinItems() */
  mobId: string;
  /** The columns that failed SetMobInfo */
  failedColumns: ColumnInfo[];
}

/** The request of OpenBin() */
export interface OpenBinRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: OpenBinRequestBody | undefined;
}

/** The body of OpenBinRequest */
export interface OpenBinRequestBody {
  /** path can be relative to project folder or an absolute path */
  binPath: string;
  /** request for locking the bin upon opening */
  locked: boolean;
}

/** The response of OpenBin() */
export interface OpenBinResponse {
  /** Request header */
  header:
    | ResponseHeader
    | undefined;
  /** Request body */
  body: OpenBinResponseBody | undefined;
}

/** The body of OpenBinResponse */
export interface OpenBinResponseBody {
  /** True if the bin is locked by other user, false if it is locked by you. */
  isLockedByOther: boolean;
  /** The username who is holding the lock of the bin. */
  lockOwner: string;
}

/** The request of CreateBin */
export interface CreateBinRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: CreateBinRequestBody | undefined;
}

/** The body of CreateBinRequest */
export interface CreateBinRequestBody {
  /** Folder path is in the currently opened project, if folder_path  is empty we create at the root folder of the project */
  folderPath: string;
  /** Bin name */
  binName: string;
  /** Specifies how the bin should be opened. */
  option: CreateBinRequestBody_OpenBinOption;
}

/** Specifies how the bin should be opened, as a floating window, or as a new tab in the active Bin Container */
export enum CreateBinRequestBody_OpenBinOption {
  /** FloatBin - Bin will be opened in a floating window */
  FloatBin = 0,
  /** LastActiveBinContainer - Bin will be opened as a new tab in the last known active Bin Container */
  LastActiveBinContainer = 1,
  /** FollowBinSettings - Open bin according to Bin settings. */
  FollowBinSettings = 2,
  UNRECOGNIZED = -1,
}

export function createBinRequestBody_OpenBinOptionFromJSON(object: any): CreateBinRequestBody_OpenBinOption {
  switch (object) {
    case 0:
    case "FloatBin":
      return CreateBinRequestBody_OpenBinOption.FloatBin;
    case 1:
    case "LastActiveBinContainer":
      return CreateBinRequestBody_OpenBinOption.LastActiveBinContainer;
    case 2:
    case "FollowBinSettings":
      return CreateBinRequestBody_OpenBinOption.FollowBinSettings;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CreateBinRequestBody_OpenBinOption.UNRECOGNIZED;
  }
}

export function createBinRequestBody_OpenBinOptionToJSON(object: CreateBinRequestBody_OpenBinOption): string {
  switch (object) {
    case CreateBinRequestBody_OpenBinOption.FloatBin:
      return "FloatBin";
    case CreateBinRequestBody_OpenBinOption.LastActiveBinContainer:
      return "LastActiveBinContainer";
    case CreateBinRequestBody_OpenBinOption.FollowBinSettings:
      return "FollowBinSettings";
    case CreateBinRequestBody_OpenBinOption.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** The response of CreateBin() */
export interface CreateBinResponse {
  /** Response header */
  header:
    | ResponseHeader
    | undefined;
  /** Response body */
  body: CreateBinResponseBody | undefined;
}

/** The body of CreateBinResponse */
export interface CreateBinResponseBody {
}

/** The request of ConfigureSRTStream */
export interface ConfigureSRTStreamRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: ConfigureSRTStreamRequestBody | undefined;
}

/** The body of ConfigureSRTStreamRequest */
export interface ConfigureSRTStreamRequestBody {
  /** Stream name */
  streamName: string;
  /** IP address */
  ipAddress: string;
  /** Port */
  port: number;
  /** Pasword */
  password: string;
  /** Latency */
  latency: number;
  /** Specifies the quality the stream should have. */
  qualityOption: ConfigureSRTStreamRequestBody_QualityOption;
  /** Specifies the mode of the stream. */
  modeOption: ConfigureSRTStreamRequestBody_ModeOption;
}

/** Specifies the quality the stream should have. */
export enum ConfigureSRTStreamRequestBody_QualityOption {
  /** Low - Low */
  Low = 0,
  /** Medium - Medium */
  Medium = 1,
  /** High - High */
  High = 2,
  UNRECOGNIZED = -1,
}

export function configureSRTStreamRequestBody_QualityOptionFromJSON(
  object: any,
): ConfigureSRTStreamRequestBody_QualityOption {
  switch (object) {
    case 0:
    case "Low":
      return ConfigureSRTStreamRequestBody_QualityOption.Low;
    case 1:
    case "Medium":
      return ConfigureSRTStreamRequestBody_QualityOption.Medium;
    case 2:
    case "High":
      return ConfigureSRTStreamRequestBody_QualityOption.High;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ConfigureSRTStreamRequestBody_QualityOption.UNRECOGNIZED;
  }
}

export function configureSRTStreamRequestBody_QualityOptionToJSON(
  object: ConfigureSRTStreamRequestBody_QualityOption,
): string {
  switch (object) {
    case ConfigureSRTStreamRequestBody_QualityOption.Low:
      return "Low";
    case ConfigureSRTStreamRequestBody_QualityOption.Medium:
      return "Medium";
    case ConfigureSRTStreamRequestBody_QualityOption.High:
      return "High";
    case ConfigureSRTStreamRequestBody_QualityOption.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Specifies the type of the stream. */
export enum ConfigureSRTStreamRequestBody_ModeOption {
  /** Listener - Listener */
  Listener = 0,
  /** Caller - Caller */
  Caller = 1,
  UNRECOGNIZED = -1,
}

export function configureSRTStreamRequestBody_ModeOptionFromJSON(
  object: any,
): ConfigureSRTStreamRequestBody_ModeOption {
  switch (object) {
    case 0:
    case "Listener":
      return ConfigureSRTStreamRequestBody_ModeOption.Listener;
    case 1:
    case "Caller":
      return ConfigureSRTStreamRequestBody_ModeOption.Caller;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ConfigureSRTStreamRequestBody_ModeOption.UNRECOGNIZED;
  }
}

export function configureSRTStreamRequestBody_ModeOptionToJSON(
  object: ConfigureSRTStreamRequestBody_ModeOption,
): string {
  switch (object) {
    case ConfigureSRTStreamRequestBody_ModeOption.Listener:
      return "Listener";
    case ConfigureSRTStreamRequestBody_ModeOption.Caller:
      return "Caller";
    case ConfigureSRTStreamRequestBody_ModeOption.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** The response of ConfigureSRTStream() */
export interface ConfigureSRTStreamResponse {
  /** Response header */
  header:
    | ResponseHeader
    | undefined;
  /** Response body */
  body: ConfigureSRTStreamResponseBody | undefined;
}

/** The body of ConfigureSRTStreamResponse */
export interface ConfigureSRTStreamResponseBody {
}

/** The request of GetSRTStreamSettings */
export interface GetSRTStreamSettingsRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: GetSRTStreamSettingsRequestBody | undefined;
}

/** The body of GetSRTStreamSettings */
export interface GetSRTStreamSettingsRequestBody {
}

/** The response of GetSRTStreamSettings() */
export interface GetSRTStreamSettingsResponse {
  /** Response header */
  header:
    | ResponseHeader
    | undefined;
  /** Response body */
  body: GetSRTStreamSettingsResponseBody | undefined;
}

/** The body of GetSRTStreamSettingsResponse */
export interface GetSRTStreamSettingsResponseBody {
  /** Stream name */
  streamName: string;
  /** IP address */
  ipAddress: string;
  /** Port */
  port: number;
  /** Pasword */
  password: string;
  /** Latency */
  latency: number;
  /** Specifies the quality the stream should have. */
  qualityOption: GetSRTStreamSettingsResponseBody_QualityOption;
  /** Specifies the mode of the stream. */
  modeOption: GetSRTStreamSettingsResponseBody_ModeOption;
}

/** Specifies the quality the stream should have. */
export enum GetSRTStreamSettingsResponseBody_QualityOption {
  /** Low - Low */
  Low = 0,
  /** Medium - Medium */
  Medium = 1,
  /** High - High */
  High = 2,
  UNRECOGNIZED = -1,
}

export function getSRTStreamSettingsResponseBody_QualityOptionFromJSON(
  object: any,
): GetSRTStreamSettingsResponseBody_QualityOption {
  switch (object) {
    case 0:
    case "Low":
      return GetSRTStreamSettingsResponseBody_QualityOption.Low;
    case 1:
    case "Medium":
      return GetSRTStreamSettingsResponseBody_QualityOption.Medium;
    case 2:
    case "High":
      return GetSRTStreamSettingsResponseBody_QualityOption.High;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GetSRTStreamSettingsResponseBody_QualityOption.UNRECOGNIZED;
  }
}

export function getSRTStreamSettingsResponseBody_QualityOptionToJSON(
  object: GetSRTStreamSettingsResponseBody_QualityOption,
): string {
  switch (object) {
    case GetSRTStreamSettingsResponseBody_QualityOption.Low:
      return "Low";
    case GetSRTStreamSettingsResponseBody_QualityOption.Medium:
      return "Medium";
    case GetSRTStreamSettingsResponseBody_QualityOption.High:
      return "High";
    case GetSRTStreamSettingsResponseBody_QualityOption.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Specifies the type of the stream. */
export enum GetSRTStreamSettingsResponseBody_ModeOption {
  /** Listener - Listener */
  Listener = 0,
  /** Caller - Caller */
  Caller = 1,
  UNRECOGNIZED = -1,
}

export function getSRTStreamSettingsResponseBody_ModeOptionFromJSON(
  object: any,
): GetSRTStreamSettingsResponseBody_ModeOption {
  switch (object) {
    case 0:
    case "Listener":
      return GetSRTStreamSettingsResponseBody_ModeOption.Listener;
    case 1:
    case "Caller":
      return GetSRTStreamSettingsResponseBody_ModeOption.Caller;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GetSRTStreamSettingsResponseBody_ModeOption.UNRECOGNIZED;
  }
}

export function getSRTStreamSettingsResponseBody_ModeOptionToJSON(
  object: GetSRTStreamSettingsResponseBody_ModeOption,
): string {
  switch (object) {
    case GetSRTStreamSettingsResponseBody_ModeOption.Listener:
      return "Listener";
    case GetSRTStreamSettingsResponseBody_ModeOption.Caller:
      return "Caller";
    case GetSRTStreamSettingsResponseBody_ModeOption.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** The request of GetOTSSessionStatus */
export interface GetOTSSessionStatusRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: GetOTSSessionStatusRequestBody | undefined;
}

/** The body of GetOTSSessionStatusRequest */
export interface GetOTSSessionStatusRequestBody {
}

/** The response of GetOTSSessionStatus() */
export interface GetOTSSessionStatusResponse {
  /** Response header */
  header:
    | ResponseHeader
    | undefined;
  /** Response body */
  body: GetOTSSessionStatusResponseBody | undefined;
}

/** The body of GetOTSSessionStatusResponse */
export interface GetOTSSessionStatusResponseBody {
  /** Session's status */
  status: string;
  /** Session's id */
  sessionId: string;
  /** Sessions's creation time in ISO */
  creationDate: string;
  /** Tenant id */
  tenantId: string;
  /** Stream name */
  streamName: string;
  /** IP address */
  ipAddress: string;
  /** Port */
  port: number;
  /** Pasword */
  password: string;
  /** Latency */
  latency: number;
  /** Specifies the quality the stream should have. */
  qualityOption: GetOTSSessionStatusResponseBody_QualityOption;
  /** Specifies the mode of the stream. */
  modeOption: GetOTSSessionStatusResponseBody_ModeOption;
}

/** Specifies the quality the stream should have. */
export enum GetOTSSessionStatusResponseBody_QualityOption {
  /** Low - Low */
  Low = 0,
  /** Medium - Medium */
  Medium = 1,
  /** High - High */
  High = 2,
  UNRECOGNIZED = -1,
}

export function getOTSSessionStatusResponseBody_QualityOptionFromJSON(
  object: any,
): GetOTSSessionStatusResponseBody_QualityOption {
  switch (object) {
    case 0:
    case "Low":
      return GetOTSSessionStatusResponseBody_QualityOption.Low;
    case 1:
    case "Medium":
      return GetOTSSessionStatusResponseBody_QualityOption.Medium;
    case 2:
    case "High":
      return GetOTSSessionStatusResponseBody_QualityOption.High;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GetOTSSessionStatusResponseBody_QualityOption.UNRECOGNIZED;
  }
}

export function getOTSSessionStatusResponseBody_QualityOptionToJSON(
  object: GetOTSSessionStatusResponseBody_QualityOption,
): string {
  switch (object) {
    case GetOTSSessionStatusResponseBody_QualityOption.Low:
      return "Low";
    case GetOTSSessionStatusResponseBody_QualityOption.Medium:
      return "Medium";
    case GetOTSSessionStatusResponseBody_QualityOption.High:
      return "High";
    case GetOTSSessionStatusResponseBody_QualityOption.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Specifies the type of the stream. */
export enum GetOTSSessionStatusResponseBody_ModeOption {
  /** Listener - Listener */
  Listener = 0,
  /** Caller - Caller */
  Caller = 1,
  UNRECOGNIZED = -1,
}

export function getOTSSessionStatusResponseBody_ModeOptionFromJSON(
  object: any,
): GetOTSSessionStatusResponseBody_ModeOption {
  switch (object) {
    case 0:
    case "Listener":
      return GetOTSSessionStatusResponseBody_ModeOption.Listener;
    case 1:
    case "Caller":
      return GetOTSSessionStatusResponseBody_ModeOption.Caller;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GetOTSSessionStatusResponseBody_ModeOption.UNRECOGNIZED;
  }
}

export function getOTSSessionStatusResponseBody_ModeOptionToJSON(
  object: GetOTSSessionStatusResponseBody_ModeOption,
): string {
  switch (object) {
    case GetOTSSessionStatusResponseBody_ModeOption.Listener:
      return "Listener";
    case GetOTSSessionStatusResponseBody_ModeOption.Caller:
      return "Caller";
    case GetOTSSessionStatusResponseBody_ModeOption.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** The request of SetOTSSessionStatus */
export interface SetOTSSessionStatusRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: SetOTSSessionStatusRequestBody | undefined;
}

/** The body of SetOTSSessionStatusRequest */
export interface SetOTSSessionStatusRequestBody {
  /** Session's status */
  status: string;
  /** Session's id */
  sessionId: string;
  /** Tenant id */
  tenantId: string;
  /** Stream name */
  streamName: string;
  /** IP address */
  ipAddress: string;
  /** Port */
  port: number;
  /** Pasword */
  password: string;
  /** Latency */
  latency: number;
  /** Specifies the quality the stream should have. */
  qualityOption: SetOTSSessionStatusRequestBody_QualityOption;
  /** Specifies the mode of the stream. */
  modeOption: SetOTSSessionStatusRequestBody_ModeOption;
}

/** Specifies the quality the stream should have. */
export enum SetOTSSessionStatusRequestBody_QualityOption {
  /** Low - Low */
  Low = 0,
  /** Medium - Medium */
  Medium = 1,
  /** High - High */
  High = 2,
  UNRECOGNIZED = -1,
}

export function setOTSSessionStatusRequestBody_QualityOptionFromJSON(
  object: any,
): SetOTSSessionStatusRequestBody_QualityOption {
  switch (object) {
    case 0:
    case "Low":
      return SetOTSSessionStatusRequestBody_QualityOption.Low;
    case 1:
    case "Medium":
      return SetOTSSessionStatusRequestBody_QualityOption.Medium;
    case 2:
    case "High":
      return SetOTSSessionStatusRequestBody_QualityOption.High;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SetOTSSessionStatusRequestBody_QualityOption.UNRECOGNIZED;
  }
}

export function setOTSSessionStatusRequestBody_QualityOptionToJSON(
  object: SetOTSSessionStatusRequestBody_QualityOption,
): string {
  switch (object) {
    case SetOTSSessionStatusRequestBody_QualityOption.Low:
      return "Low";
    case SetOTSSessionStatusRequestBody_QualityOption.Medium:
      return "Medium";
    case SetOTSSessionStatusRequestBody_QualityOption.High:
      return "High";
    case SetOTSSessionStatusRequestBody_QualityOption.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Specifies the type of the stream. */
export enum SetOTSSessionStatusRequestBody_ModeOption {
  /** Listener - Listener */
  Listener = 0,
  /** Caller - Caller */
  Caller = 1,
  UNRECOGNIZED = -1,
}

export function setOTSSessionStatusRequestBody_ModeOptionFromJSON(
  object: any,
): SetOTSSessionStatusRequestBody_ModeOption {
  switch (object) {
    case 0:
    case "Listener":
      return SetOTSSessionStatusRequestBody_ModeOption.Listener;
    case 1:
    case "Caller":
      return SetOTSSessionStatusRequestBody_ModeOption.Caller;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SetOTSSessionStatusRequestBody_ModeOption.UNRECOGNIZED;
  }
}

export function setOTSSessionStatusRequestBody_ModeOptionToJSON(
  object: SetOTSSessionStatusRequestBody_ModeOption,
): string {
  switch (object) {
    case SetOTSSessionStatusRequestBody_ModeOption.Listener:
      return "Listener";
    case SetOTSSessionStatusRequestBody_ModeOption.Caller:
      return "Caller";
    case SetOTSSessionStatusRequestBody_ModeOption.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** The response of SetOTSSessionStatus() */
export interface SetOTSSessionStatusResponse {
  /** Response header */
  header:
    | ResponseHeader
    | undefined;
  /** Response body */
  body: SetOTSSessionStatusResponseBody | undefined;
}

/** The body of SetOTSSessionStatusResponse */
export interface SetOTSSessionStatusResponseBody {
}

/** The request of GetMediaVolumeList() */
export interface GetMediaVolumeListRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: GetMediaVolumeListRequestBody | undefined;
}

/** The body of GetMediaVolumeListRequest */
export interface GetMediaVolumeListRequestBody {
}

/** The response of GetMediaVolumeList */
export interface GetMediaVolumeListResponse {
  /** Response header */
  header:
    | ResponseHeader
    | undefined;
  /** Response body */
  body: GetMediaVolumeListResponseBody | undefined;
}

/** The body of GetMediaVolumeListResponse */
export interface GetMediaVolumeListResponseBody {
  /** The list of Avid media files volume */
  volumes: GetMediaVolumeListResponseBody_MediaVolume[];
}

/** Represents Avid meida files volume. */
export interface GetMediaVolumeListResponseBody_MediaVolume {
  /** Name of Avid media files volume */
  name: string;
  /** True if the volume resides on shared storage, false otherwise. */
  isShared: boolean;
  /** Volume free space in KB */
  freeSpace: number;
}

/** The body of GetMediaVolumeItemsRequest */
export interface GetMediaVolumeItemsRequestBody {
  /** value returned from GetMediaVolumeList() */
  volumeName: string;
  /** relative to Avid media files on the volume, use an empty string with `type == OnlyDirectories` to return the first level of media directories for the given volume name */
  relativePath: string;
  /** volume item filter */
  type: GetMediaVolumeItemsRequestBody_VolumeItemFilter;
}

/** Specifies the type of Avid media files volume items returned from GetMediaVolumeItems() */
export enum GetMediaVolumeItemsRequestBody_VolumeItemFilter {
  /** All - Both directories and files */
  All = 0,
  /** OnlyDirectories - Directories only */
  OnlyDirectories = 1,
  /** OnlyFiles - Files only */
  OnlyFiles = 2,
  UNRECOGNIZED = -1,
}

export function getMediaVolumeItemsRequestBody_VolumeItemFilterFromJSON(
  object: any,
): GetMediaVolumeItemsRequestBody_VolumeItemFilter {
  switch (object) {
    case 0:
    case "All":
      return GetMediaVolumeItemsRequestBody_VolumeItemFilter.All;
    case 1:
    case "OnlyDirectories":
      return GetMediaVolumeItemsRequestBody_VolumeItemFilter.OnlyDirectories;
    case 2:
    case "OnlyFiles":
      return GetMediaVolumeItemsRequestBody_VolumeItemFilter.OnlyFiles;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GetMediaVolumeItemsRequestBody_VolumeItemFilter.UNRECOGNIZED;
  }
}

export function getMediaVolumeItemsRequestBody_VolumeItemFilterToJSON(
  object: GetMediaVolumeItemsRequestBody_VolumeItemFilter,
): string {
  switch (object) {
    case GetMediaVolumeItemsRequestBody_VolumeItemFilter.All:
      return "All";
    case GetMediaVolumeItemsRequestBody_VolumeItemFilter.OnlyDirectories:
      return "OnlyDirectories";
    case GetMediaVolumeItemsRequestBody_VolumeItemFilter.OnlyFiles:
      return "OnlyFiles";
    case GetMediaVolumeItemsRequestBody_VolumeItemFilter.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** The request of GetMediaVolumeItems() */
export interface GetMediaVolumeItemsRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: GetMediaVolumeItemsRequestBody | undefined;
}

/** The response of GetMediaVolumeItems */
export interface GetMediaVolumeItemsResponse {
  /** Response header */
  header:
    | ResponseHeader
    | undefined;
  /** Response body */
  body: GetMediaVolumeItemsResponseBody | undefined;
}

/** The body of GetMediaVolumeItemsResponse */
export interface GetMediaVolumeItemsResponseBody {
  item: GetMediaVolumeItemsResponseBody_MediaVolumeItem[];
}

export interface GetMediaVolumeItemsResponseBody_MediaVolumeItem {
  /** relative path from the media volume. For example: */
  relativeVolumePath: string;
  /** true if the item is a directory, false otherwise */
  isDirectory: boolean;
}

/** Represents the request of GetOpenProjectInfo */
export interface GetOpenProjectInfoRequest {
  /** request header */
  header:
    | RequestHeader
    | undefined;
  /** request body */
  body: GetOpenProjectInfoRequestBody | undefined;
}

/** Represents the body of GetOpenProjectInfo */
export interface GetOpenProjectInfoRequestBody {
}

/** The response of GetOpenProjectInfo */
export interface GetOpenProjectInfoResponse {
  /** response header */
  header:
    | ResponseHeader
    | undefined;
  /** response body */
  body: GetOpenProjectInfoResponseBody | undefined;
}

/** The body of GetOpenProjectInfoResponse */
export interface GetOpenProjectInfoResponseBody {
  /** full path of the project */
  path: string;
  /** eg. 1080p/50 */
  projectType: string;
  /** frame rate */
  frameRate:
    | FrameRate
    | undefined;
  /** color space */
  colorSpace: string;
  /** raster width */
  rasterWidth: number;
  /** raster height */
  rasterHeight: number;
  /** stereoscopic type */
  stereoscopic: Stereoscopic;
  /** drop frame */
  dropFrame: boolean;
  /** project's creation time */
  creationDate:
    | Timestamp
    | undefined;
  /** project's last modified time */
  modifyDate:
    | Timestamp
    | undefined;
  /** is it a film project */
  film: boolean;
  /** film perf */
  filmPerf: string;
}

/** The request of GetCustomProjectData */
export interface GetCustomProjectDataRequest {
  /** request header */
  header:
    | RequestHeader
    | undefined;
  /** request body */
  body: GetCustomProjectDataRequestBody | undefined;
}

/** The body of GetCustomProjectDataRequest */
export interface GetCustomProjectDataRequestBody {
  dataId: string;
  /** Include vendor prefix from manifest file as part of the key */
  dataKey: string;
}

/** The response of GetCustomProjectData */
export interface GetCustomProjectDataResponse {
  /** response header */
  header:
    | ResponseHeader
    | undefined;
  /** response body */
  body: GetCustomProjectDataResponseBody | undefined;
}

/** The body of GetCustomProjectDataResponse */
export interface GetCustomProjectDataResponseBody {
  /** value associated with the GetCustomProjectData request's key */
  dataValue: string;
}

/** The request of SetCustomProjectData */
export interface SetCustomProjectDataRequest {
  /** request header */
  header:
    | RequestHeader
    | undefined;
  /** request body */
  body: SetCustomProjectDataRequestBody | undefined;
}

/** The body of SetCustomProjectDataRequest */
export interface SetCustomProjectDataRequestBody {
  dataId: string;
  /** Include vendor prefix from manifest file as part of the key */
  dataKey: string;
  /** the data associated with the key */
  dataValue: string;
}

/** The response of SetCustomProjectData */
export interface SetCustomProjectDataResponse {
  /** response header */
  header:
    | ResponseHeader
    | undefined;
  /** response body */
  body: SetCustomProjectDataResponseBody | undefined;
}

/** The body of SetCustomProjectDataResponse */
export interface SetCustomProjectDataResponseBody {
}

/** Frame rate. */
export interface FrameRate {
  /** numerator */
  num: number;
  /** denominator */
  den: number;
}

/** The request of ScanAvidMediaFilesFolder */
export interface ScanAvidMediaFilesFolderRequest {
  /** request header */
  header:
    | RequestHeader
    | undefined;
  /** request body */
  body: ScanAvidMediaFilesFolderRequestBody | undefined;
}

/** The body of ScanAvidMediaFilesFolderRequest */
export interface ScanAvidMediaFilesFolderRequestBody {
  /** within Avid media file path folder. Must contain a number */
  destinationPath: string;
}

/** The response of ScanAvidMediaFilesFolder */
export interface ScanAvidMediaFilesFolderResponse {
  /** response header */
  header:
    | ResponseHeader
    | undefined;
  /** response body */
  body: ScanAvidMediaFilesFolderResponseBody | undefined;
}

/** The body of ScanAvidMediaFilesFolderResponse */
export interface ScanAvidMediaFilesFolderResponseBody {
}

/** Structure that describes CreateClipsFromAvidMediaFilesFolder request. */
export interface CreateClipsFromAvidMediaFilesFolderRequest {
  /** request header */
  header:
    | RequestHeader
    | undefined;
  /** request body */
  body: CreateClipsFromAvidMediaFilesFolderRequestBody | undefined;
}

/** Structure that describes the body of CreateClipsFromAvidMediaFilesFolderRequest. */
export interface CreateClipsFromAvidMediaFilesFolderRequestBody {
  /** Path can be relative to project folder or an absolute path. The bin must be opened. */
  binPath: string;
  /** within Avid media file absolute path folder. Must contain a number */
  mediaFolderPath: string;
  /** relative paths without ".." to media file in media folder, if empty all clips in folder will be added */
  mediaFilePath: string[];
}

/** Structure that describes CreateClipsFromAvidMediaFilesFolder response. */
export interface CreateClipsFromAvidMediaFilesFolderResponse {
  /** response header */
  header:
    | ResponseHeader
    | undefined;
  /** response body */
  body: CreateClipsFromAvidMediaFilesFolderResponseBody | undefined;
}

/** Structure that describes CreateClipsFromAvidMediaFilesFolder response. */
export interface CreateClipsFromAvidMediaFilesFolderResponseBody {
}

/** The request of CreateCustomColumn */
export interface CreateCustomColumnRequest {
  /** request header */
  header:
    | RequestHeader
    | undefined;
  /** request body */
  body: CreateCustomColumnRequestBody | undefined;
}

/** The body of CreateCustomColumnRequest */
export interface CreateCustomColumnRequestBody {
  /** The bin must be opened. */
  absoluteBinPath: string;
  newColumnName: string;
  /** If empty or not found, new column will be at the far right. */
  afterColumnName: string;
  /** If true, new column will be hidden */
  columnHidden: boolean;
}

/** The response of CreateCustomColumn */
export interface CreateCustomColumnResponse {
  /** response header */
  header:
    | ResponseHeader
    | undefined;
  /** response body */
  body: CreateCustomColumnResponseBody | undefined;
}

/** The body of CreateCustomColumnResponse */
export interface CreateCustomColumnResponseBody {
}

/** The request of GetListOfExportEDLSettings */
export interface GetListOfExportEDLSettingsRequest {
  /** request header */
  header:
    | RequestHeader
    | undefined;
  /** request body */
  body: GetListOfExportEDLSettingsRequestBody | undefined;
}

/** The body of GetListOfExportEDLSettingsRequest */
export interface GetListOfExportEDLSettingsRequestBody {
}

/** The response of GetListOfExportEDLSettings */
export interface GetListOfExportEDLSettingsResponse {
  /** response header */
  header:
    | ResponseHeader
    | undefined;
  /** response body */
  body: GetListOfExportEDLSettingsResponseBody | undefined;
}

/** The body of GetListOfExportEDLSettingsResponse */
export interface GetListOfExportEDLSettingsResponseBody {
  /** List Tool EDL settings */
  settingNames: string[];
}

/** Structure that describes ExportEDL request message. */
export interface ExportEDLRequest {
  /** request header */
  header:
    | RequestHeader
    | undefined;
  /** request body */
  body: ExportEDLRequestBody | undefined;
}

/** Structure that describes the body of ExportEDLRequest. */
export interface ExportEDLRequestBody {
  /** mobID of a sequence. */
  mobId: string;
  /** Name of an already-existing EDL-specific setting from the MC List Tool. If empty or incorrect, default EDL setting is used. */
  edlSettingsName: string;
  /** If track list is empty, EDL will contain all sequence tracks. Only include picture, sound, and data tracks. */
  trackList: TrackList | undefined;
}

export interface TrackList {
  trackLabels: TrackLabel[];
}

export interface TrackLabel {
  type: TrackType;
  number: number;
}

/** Structure that describes ExportEDL response message. */
export interface ExportEDLResponse {
  /** response header */
  header:
    | ResponseHeader
    | undefined;
  /** response body */
  body: ExportEDLResponseBody | undefined;
}

/** Structure that describes ExportEDL response data. */
export interface ExportEDLResponseBody {
  /** path to a local file containing exported EDL */
  path: string;
  /**
   * contents of dialogs suppressed during EDL generation, if any
   *
   * @deprecated
   */
  dialogContents: string[];
}

export interface GetMobTrackInfoRequest {
  /** request header */
  header:
    | RequestHeader
    | undefined;
  /** request body */
  body: GetMobTrackInfoRequestBody | undefined;
}

/** The body of GetMobTrackInfoRequest */
export interface GetMobTrackInfoRequestBody {
  /** SMPTE formatted mob ID string returned from GetMobContent() */
  mobId: string;
}

export interface GetMobTrackInfoResponse {
  /** response header */
  header:
    | ResponseHeader
    | undefined;
  /** request body */
  body: GetMobTrackInfoResponseBody | undefined;
}

export interface TrackInfo {
  label:
    | TrackLabel
    | undefined;
  /** Default for track will not ahve any custom name. */
  customName: string;
  selected: boolean;
  /** Only one Video track can be monitored at a time. */
  monitored: boolean;
  /** TODO: Talk to Jeff about voices and how to represent that here! */
  enabled: boolean;
  solo: boolean;
  mute: boolean;
  locked: boolean;
  syncLocked: boolean;
  /** Number of segments on the track. */
  numSegments: number;
  audioType: AudioTrackType;
}

export interface TrackInfoList {
  trackInfo: TrackInfo[];
}

export interface GetMobTrackInfoResponseBody {
  trackInfoList: TrackInfoList | undefined;
}

/** Common data of request message. */
export interface RequestHeader {
  /** The id of the company */
  companyId: string;
  /** mcapi_access_token from cookie */
  accessToken: string;
}

/** Common data of response message. */
export interface ResponseHeader {
  /** unique identifier for each command */
  taskId: string;
  /**
   * status of command execution
   *
   * @deprecated
   */
  status: TaskStatus;
  /** progress of command execution in percentage */
  progress: number;
  /**
   * The error
   *
   * @deprecated
   */
  error:
    | CommandError
    | undefined;
  /** list of warnings */
  warnings: string[];
}

/** @exclude TODO remove this message after we upload all the Google protobuf to Nexus */
export interface Timestamp {
  /**
   * Represents seconds of UTC time since Unix epoch
   * 1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
   * 9999-12-31T23:59:59Z inclusive.
   */
  seconds: number;
  /**
   * Non-negative fractions of a second at nanosecond resolution. Negative
   * second values with fractions must still have non-negative nanos values
   * that count forward in time. Must be from 0 to 999,999,999
   * inclusive.
   */
  nanos: number;
}

/** Common data of the error message. */
export interface CommandError {
  /** type of the possible command error */
  commandErrorType: CommandErrorType;
  /** error or warning message */
  commandErrorMessage: string;
  /** if error is defined as a warning, command execution should be completed successfully */
  isWarning: boolean;
}

/** Structure that describes ExportFile request message. */
export interface ExportFileRequest {
  /** request header */
  header:
    | RequestHeader
    | undefined;
  /** request body */
  body: ExportFileRequestBody | undefined;
}

/** Structure that describes the body of ExportFileRequest. */
export interface ExportFileRequestBody {
  /** mobID of a sequence. */
  mobId: string;
  /** Name of file with will be created, If empty use default name. */
  fileName: string;
  /** Name of an already-existing export-specific setting from the MC. If empty or incorrect, default Export setting is used. */
  exportSettingsName: string;
  /** If empty, then use appropriate user's directory. */
  destinationPath: string;
  /** If not empty, export will create and use this named directory in the destination_path. (Mainly useful for export with multiple files) */
  inDirectory: string;
  optionFlags: ExportFileOption[];
}

/** Structure that describes ExportFile response message. */
export interface ExportFileResponse {
  /** response header */
  header:
    | ResponseHeader
    | undefined;
  /** response body */
  body: ExportFileResponseBody | undefined;
}

/** Structure that describes ExportFile response data. */
export interface ExportFileResponseBody {
  /**
   * path to a local file or subfolder containing mulitiple files.
   *
   * @deprecated
   */
  path: string;
}

/** Structure that describes ImportFile request message. */
export interface ImportFileRequest {
  /** request header */
  header:
    | RequestHeader
    | undefined;
  /** request body */
  body: ImportFileRequestBody | undefined;
}

/** Structure that describes the body of ImportFileRequest. */
export interface ImportFileRequestBody {
  /** path to file that is to be imported */
  filePath: string;
  /** Name of an already-existing import-specific setting from the MC. If empty or incorrect, default import setting is used. */
  importSettingsName: string;
  /** If empty, then use default Media Creation settings. */
  destinationVideoDrive: string;
  /** If empty, then use default Media Creation settings. */
  destinationAudioDrive: string;
  /** If empty, then use default Media Creation settings. */
  compression: string;
  /** If empty, then use default Media Creation settings. */
  videoWrapperFormat: string;
  /** If empty, then use default Media Creation settings. */
  audioWrapperFormat: string;
  /** relative path to destination bin */
  destinationBin: string;
  optionFlags: ImportFileOption[];
}

/** Structure that describes ImportFile response message. */
export interface ImportFileResponse {
  /** response header */
  header:
    | ResponseHeader
    | undefined;
  /** response body */
  body: ImportFileResponseBody | undefined;
}

/** Structure that describes ImportFile response data. */
export interface ImportFileResponseBody {
  /** @deprecated */
  mobId: string;
}

export interface LoadSettingRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: LoadSettingRequestBody | undefined;
}

export interface LoadSettingRequestBody {
  /** A unique identifier for this set of settings. This could be a guid or any other unique string */
  uniqueId: string;
  /** xml data created in Media Composer. See documentation. */
  xmlSetting: string;
}

export interface LoadSettingResponse {
  /** Request header */
  header: ResponseHeader | undefined;
}

/** The request of GetListOfExportSettings */
export interface GetListOfExportSettingsRequest {
  /** request header */
  header:
    | RequestHeader
    | undefined;
  /** request body */
  body: GetListOfExportSettingsRequestBody | undefined;
}

/** The body of GetListOfExportSettingsRequest */
export interface GetListOfExportSettingsRequestBody {
}

/** The response of GetListOfExportSettings */
export interface GetListOfExportSettingsResponse {
  /** response header */
  header:
    | ResponseHeader
    | undefined;
  /** response body */
  body: GetListOfExportSettingsResponseBody | undefined;
}

/** The body of GetListOfExportSettingsResponse */
export interface GetListOfExportSettingsResponseBody {
  /** export settings */
  settingNames: string[];
}

/** The request of GetListOfImportSettings */
export interface GetListOfImportSettingsRequest {
  /** request header */
  header:
    | RequestHeader
    | undefined;
  /** request body */
  body: GetListOfImportSettingsRequestBody | undefined;
}

/** The body of GetListOfImportSettingsRequest */
export interface GetListOfImportSettingsRequestBody {
}

/** The response of GetListOfImportSettings */
export interface GetListOfImportSettingsResponse {
  /** response header */
  header:
    | ResponseHeader
    | undefined;
  /** response body */
  body: GetListOfImportSettingsResponseBody | undefined;
}

/** The body of GetListOfImportSettingsResponse */
export interface GetListOfImportSettingsResponseBody {
  /** import settings */
  settingNames: string[];
}

/** The request of AddMarker */
export interface AddMarkerRequest {
  /** request header */
  header:
    | RequestHeader
    | undefined;
  /** request body */
  body: AddMarkerRequestBody | undefined;
}

/** The body of AddMarkerRequest */
export interface AddMarkerRequestBody {
  mobId: string;
  /** destination track for new marker.  Spanned markers can only be created on the TC track. */
  trackLabel:
    | TrackLabel
    | undefined;
  /** if >= 0 this will be used for marker position, if < 0 the timecode value will be used for marker position */
  offset: number;
  /** Timeline timecode position eg. "00:00:00:00", but see offset note above. */
  timecode: string;
  /** # of frames. For regular markers, use 1.  Greater than 1 is used for spanned markers. */
  length: number;
  /** Marker text. */
  comment: string;
  /** Marker color.  Note that Media Composer considers the color to be indicative of priority, though users may not use color this way. */
  color: MarkerColor;
  /** Name of the marker. */
  name: string;
  /** Usually the string representation of a standard UUID/GUID. */
  guid: string;
  /** An username, optional. Usually when a user creates a marker this defaults to their OS login name, but it can be used in other ways. */
  user: string;
}

/** The response of AddMarker */
export interface AddMarkerResponse {
  /** response header */
  header:
    | ResponseHeader
    | undefined;
  /** response body */
  body: AddMarkerResponseBody | undefined;
}

/** The body of AddMarkerResponse */
export interface AddMarkerResponseBody {
  /** the string representation of a standard UUID/GUID for just created marker */
  guid: string;
}

export interface LoadMobsIntoViewerRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: LoadMobsIntoViewerRequestBody | undefined;
}

export interface LoadMobsIntoViewerRequestBody {
  /** array of mob ids to load into monitor */
  mobIds: string[];
  /** which monitor to load into */
  viewType: ViewerType;
}

export interface LoadMobsIntoViewerResponse {
  /** Request header */
  header:
    | ResponseHeader
    | undefined;
  /** Request body */
  body: LoadMobsIntoViewerResponseBody | undefined;
}

export interface LoadMobsIntoViewerResponseBody {
}

export interface SelectMobsInBinRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: SelectMobsInBinRequestBody | undefined;
}

export interface SelectMobsInBinRequestBody {
  /** path can be relative to project folder or an absolute path */
  binPath: string;
  /** array of mob ids to select */
  mobIds: string[];
  /** true - add mob id to current selection, false - clear current selection first */
  addToSelection: boolean;
}

export interface SelectMobsInBinResponse {
  /** Request header */
  header:
    | ResponseHeader
    | undefined;
  /** Request body */
  body: SelectMobsInBinResponseBody | undefined;
}

export interface SelectMobsInBinResponseBody {
  /** List of correctly selected mobs from request. */
  selectedMobIds: string[];
}

export interface GetViewerMobsRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: GetViewerMobsRequestBody | undefined;
}

export interface GetViewerMobsRequestBody {
}

export interface GetViewerMobsResponse {
  /** Request header */
  header:
    | ResponseHeader
    | undefined;
  /** Request body */
  body: GetViewerMobsResponseBody | undefined;
}

export interface MobInViewer {
  mobId: string;
  viewType: ViewerType;
  currentFrame: number;
  currentTimecode: string;
}

export interface GetViewerMobsResponseBody {
  mobs: MobInViewer[];
}

export interface GetBinFromMobRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: GetBinFromMobRequestBody | undefined;
}

export interface GetBinFromMobRequestBody {
  mobId: string;
}

export interface GetBinFromMobResponse {
  /** Request header */
  header:
    | ResponseHeader
    | undefined;
  /** Request body */
  body: GetBinFromMobResponseBody | undefined;
}

export interface GetBinFromMobResponseBody {
  absolutePath: string;
}

export interface AddMarkersRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: AddMarkersRequestBody | undefined;
}

export interface RequestMarkerInfo {
  /** Name of the marker. */
  name: string;
  /** destination track for new marker.  Spanned markers can only be created on the TC track. */
  trackLabel:
    | TrackLabel
    | undefined;
  /** if >= 0 this will be used for marker position, if < 0 the timecode value will be used for marker position */
  offset: number;
  /** Timeline timecode position eg. "00:00:00:00", but see offset note above. */
  timecode: string;
  /** # of frames. For regular markers, use 1.  Greater than 1 is used for spanned markers. */
  length: number;
  /** Marker text. */
  comment: string;
  /** Marker color.  Note that Media Composer considers the color to be indicative of priority, though users may not use color this way. */
  color: MarkerColor;
  /** Usually the string representation of a standard UUID/GUID, optional */
  guid: string;
  /** An username, optional. Usually when a user creates a marker this defaults to their OS login name, but it can be used in other ways. */
  user: string;
}

export interface AddMarkersRequestBody {
  /** mob id */
  mobId: string;
  /** array of marker info */
  info: RequestMarkerInfo[];
}

export interface AddMarkersResponse {
  /** Response header */
  header:
    | ResponseHeader
    | undefined;
  /** Response body */
  body: AddMarkersResponseBody | undefined;
}

export interface AddMarkersResponseBody {
}

export interface GetMarkersRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: GetMarkersRequestBody | undefined;
}

export interface GetMarkersRequestBody {
  /** mob id */
  mobId: string;
  /** select specified marker GUID only, optional */
  guid: string;
  /** frame offset and length */
  offset?:
    | GetMarkersRequestBody_offsetFilter
    | undefined;
  /** timecode range */
  timecode?:
    | GetMarkersRequestBody_tcFilter
    | undefined;
  /** select markers for specified track only, optional */
  track?: TrackLabel | undefined;
}

export interface GetMarkersRequestBody_offsetFilter {
  frame: number;
  length: number;
}

export interface GetMarkersRequestBody_tcFilter {
  /** starting timecode position eg. "01:00:00:00" */
  start: string;
  /** timecode duration eg. "00:00:01:00" */
  duration: string;
}

export interface GetMarkersResponse {
  /** Response header */
  header:
    | ResponseHeader
    | undefined;
  /** Response body */
  body: GetMarkersResponseBody | undefined;
}

export interface ResponseMarkerInfo {
  name: string;
  trackLabel: TrackLabel | undefined;
  offset: number;
  timecode: string;
  length: number;
  comment: string;
  color: MarkerColor;
  creationDate: Timestamp | undefined;
  guid: string;
  user: string;
}

export interface GetMarkersResponseBody {
  /** array of marker info */
  info: ResponseMarkerInfo[];
}

export interface ChangeMarkerRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: ChangeMarkerRequestBody | undefined;
}

export interface ChangeMarkerRequestBody {
  /** mob id */
  mobId: string;
  /** marker GUID */
  guid: string;
  /** mutable marker info */
  info: ChangeMarkerRequestBody_MarkerInfo | undefined;
}

export interface ChangeMarkerRequestBody_MarkerInfo {
  /** Name of the marker. */
  name: string;
  /** Marker text. */
  comment: string;
  /** Marker color.  Note that Media Composer considers the color to be indicative of priority, though users may not use color this way. */
  color: MarkerColor;
  /** Marker track type and number.  Spanned markers can only be placed on the TC track. */
  trackLabel:
    | TrackLabel
    | undefined;
  /** An username, optional. */
  user: string;
}

export interface ChangeMarkerResponse {
  /** Response header */
  header:
    | ResponseHeader
    | undefined;
  /** Response body */
  body: ChangeMarkerResponseBody | undefined;
}

export interface ChangeMarkerResponseBody {
}

export interface CreateSubClipRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: CreateSubClipRequestBody | undefined;
}

export interface CreateSubClipRequestBody {
  /** Path can be relative to project folder or an absolute path. */
  destinationBinPath: string;
  /** SMPTE formatted mob ID strings returned from GetListOfBinItems(). */
  mobId: string;
  /** If track list is empty, CreateSubClip will use all avaliable tracks. */
  trackList:
    | TrackList
    | undefined;
  /** This bounds can be overwritten by head_frame/end_frame, head_timecode/end_timecode. */
  useClipBounds: boolean;
  /** This bounds can be overwritten by head_frame/end_frame, head_timecode/end_timecode. */
  useMarksBounds: boolean;
  /** Is used when head_frame >= 0, can be overwritten by head_timecode. */
  headFrame: number;
  /** Is used when is not empty. */
  headTimecode: string;
  /** Is used when end_frame >= 0, can be overwritten by end_timecode. */
  endFrame: number;
  /** Is used when is not empty. */
  endTimecode: string;
  /** Negative values can be applied to remove frames from the head. Only available frames can be added/removed */
  addFramesAtHead: number;
  /** Negative values can be applied to remove frames from the tail. Only available frames can be added/removed */
  addFramesAtEnd: number;
  /** Works only for sub clips. */
  retainMarks: boolean;
  /** Include the clip's markers in the new subclip. */
  retainMarkers: boolean;
  /** Only for sequence. A new sequence using the newly created subclips will be added to the destination bin */
  createNewSequence: boolean;
  /** Only for sequence. When enabled, subclips are created based on track selection in the timeline. When disabled, all tracks in the sequence are used */
  enabledTracksOnly: boolean;
}

export interface CreateSubClipResponse {
  /** Request header */
  header:
    | ResponseHeader
    | undefined;
  /** Request body */
  body: CreateSubClipResponseBody | undefined;
}

export interface CreateSubClipResponseBody {
}

/** The request of CloseBin() */
export interface CloseBinRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: CloseBinRequestBody | undefined;
}

/** The body of CloseBinRequest */
export interface CloseBinRequestBody {
  /** path can be relative to project folder or an absolute path */
  binPath: string;
}

/** The response of CloseBin() */
export interface CloseBinResponse {
  /** Request header */
  header:
    | ResponseHeader
    | undefined;
  /** Request body */
  body: CloseBinResponseBody | undefined;
}

/** The body of CloseBinResponse */
export interface CloseBinResponseBody {
}

/** The request of MoveBinItems() */
export interface MoveBinItemsRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: MoveBinItemsRequestBody | undefined;
}

/** The body of MoveBinItemsRequest */
export interface MoveBinItemsRequestBody {
  /** path can be relative to project folder or an absolute path */
  sourceBinPath: string;
  /** path can be relative to project folder or an absolute path */
  destinationBinPath: string;
  /** SMPTE formatted mob ID strings returned from GetListOfBinItems(). */
  mobId: string[];
}

/** The response of MoveBinItems() */
export interface MoveBinItemsResponse {
  /** Request header */
  header:
    | ResponseHeader
    | undefined;
  /** Request body */
  body: MoveBinItemsResponseBody | undefined;
}

/** The body of MoveBinItemsResponse */
export interface MoveBinItemsResponseBody {
  /** Correctly moved mobs */
  mobId: string[];
}

/** The request of CopyBinItems() */
export interface CopyBinItemsRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: CopyBinItemsRequestBody | undefined;
}

/** The body of CopyBinItemsRequest */
export interface CopyBinItemsRequestBody {
  /** path can be relative to project folder or an absolute path */
  sourceBinPath: string;
  /** path can be relative to project folder or an absolute path */
  destinationBinPath: string;
  /** SMPTE formatted mob ID strings returned from GetListOfBinItems(). */
  mobId: string[];
}

/** The response of CopyBinItems() */
export interface CopyBinItemsResponse {
  /** Request header */
  header:
    | ResponseHeader
    | undefined;
  /** Request body */
  body: CopyBinItemsResponseBody | undefined;
}

/** The body of CopyBinItemsResponse */
export interface CopyBinItemsResponseBody {
  /** Newly created mobs */
  mobId: string[];
}

/** The request of DuplicateBinItems() */
export interface DuplicateBinItemsRequest {
  /** Request header */
  header:
    | RequestHeader
    | undefined;
  /** Request body */
  body: DuplicateBinItemsRequestBody | undefined;
}

/** The body of DuplicateBinItemsRequest */
export interface DuplicateBinItemsRequestBody {
  /** path can be relative to project folder or an absolute path */
  binPath: string;
  /** SMPTE formatted mob ID strings returned from GetListOfBinItems(). */
  mobId: string[];
}

/** The response of DuplicateBinItems() */
export interface DuplicateBinItemsResponse {
  /** Request header */
  header:
    | ResponseHeader
    | undefined;
  /** Request body */
  body: DuplicateBinItemsResponseBody | undefined;
}

/** The body of DuplicateBinItemsResponse */
export interface DuplicateBinItemsResponseBody {
  /** Newly created mobs */
  mobId: string[];
}

/** The request of GetListOfLinkSettings */
export interface GetListOfLinkSettingsRequest {
  /** request header */
  header:
    | RequestHeader
    | undefined;
  /** request body */
  body: GetListOfLinkSettingsRequestBody | undefined;
}

/** The body of GetListOfLinkSettingsRequest */
export interface GetListOfLinkSettingsRequestBody {
}

/** The response of GetListOfLinkSettings */
export interface GetListOfLinkSettingsResponse {
  /** response header */
  header:
    | ResponseHeader
    | undefined;
  /** response body */
  body: GetListOfLinkSettingsResponseBody | undefined;
}

/** The body of GetListOfLinkSettingsResponse */
export interface GetListOfLinkSettingsResponseBody {
  /** link settings */
  settingNames: string[];
}

/** The request of LinkFile */
export interface LinkFileRequest {
  /** request header */
  header:
    | RequestHeader
    | undefined;
  /** request body */
  body: LinkFileRequestBody | undefined;
}

/** The body of LinkFileRequest */
export interface LinkFileRequestBody {
  /** path to file that is to be link */
  filePath: string;
  /** path can be relative to project folder or an absolute path */
  destinationBin: string;
  /** Name of an already-existing link-specific setting from the MC. If empty or incorrect, default link setting is used. */
  linkSettingsName: string;
}

/** The response of LinkFile */
export interface LinkFileResponse {
  /** response header */
  header:
    | ResponseHeader
    | undefined;
  /** response body */
  body: LinkFileResponseBody | undefined;
}

/** The body of LinkFileResponse */
export interface LinkFileResponseBody {
  mobId: string;
}

/** The request of GetListOfJobQueues */
export interface GetListOfJobQueuesRequest {
  /** request header */
  header:
    | RequestHeader
    | undefined;
  /** request body */
  body: GetListOfJobQueuesRequestBody | undefined;
}

/** The body of GetListOfJobQueuesRequest */
export interface GetListOfJobQueuesRequestBody {
}

/** The response of GetListOfJobQueues */
export interface GetListOfJobQueuesResponse {
  /** response header */
  header:
    | ResponseHeader
    | undefined;
  /** response body */
  body: GetListOfJobQueuesResponseBody | undefined;
}

/** The body of GetListOfJobQueuesResponse */
export interface GetListOfJobQueuesResponseBody {
  jobQueues: GetListOfJobQueuesResponseBody_JobsQueue[];
}

export interface GetListOfJobQueuesResponseBody_JobsQueue {
  name: string;
  id: string;
}

/** The request of DeleteMarkers */
export interface DeleteMarkersRequest {
  /** request header */
  header:
    | RequestHeader
    | undefined;
  /** request body */
  body: DeleteMarkersRequestBody | undefined;
}

/** The body of DeleteMarkersRequest */
export interface DeleteMarkersRequestBody {
  /** mob id */
  mobId: string;
  /** marker GUID */
  guid: string[];
  timecodeRangeStart?: string | undefined;
  timecodeRangeEnd?: string | undefined;
  color?: MarkerColor | undefined;
  trackLabel?: TrackLabel | undefined;
}

/** The response of DeleteMarkers */
export interface DeleteMarkersResponse {
  /** response header */
  header:
    | ResponseHeader
    | undefined;
  /** response body */
  body: DeleteMarkersResponseBody | undefined;
}

/** The body of DeleteMarkersResponse */
export interface DeleteMarkersResponseBody {
}

function createBaseGetListOfBinItemsRequest(): GetListOfBinItemsRequest {
  return { header: undefined, body: undefined };
}

export const GetListOfBinItemsRequest: MessageFns<GetListOfBinItemsRequest> = {
  encode(message: GetListOfBinItemsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetListOfBinItemsRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetListOfBinItemsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetListOfBinItemsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetListOfBinItemsRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetListOfBinItemsRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetListOfBinItemsRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetListOfBinItemsRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetListOfBinItemsRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetListOfBinItemsRequest>, I>>(base?: I): GetListOfBinItemsRequest {
    return GetListOfBinItemsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetListOfBinItemsRequest>, I>>(object: I): GetListOfBinItemsRequest {
    const message = createBaseGetListOfBinItemsRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetListOfBinItemsRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetListOfBinItemsResponse(): GetListOfBinItemsResponse {
  return { header: undefined, body: undefined };
}

export const GetListOfBinItemsResponse: MessageFns<GetListOfBinItemsResponse> = {
  encode(message: GetListOfBinItemsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetListOfBinItemsResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetListOfBinItemsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetListOfBinItemsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetListOfBinItemsResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetListOfBinItemsResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetListOfBinItemsResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetListOfBinItemsResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetListOfBinItemsResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetListOfBinItemsResponse>, I>>(base?: I): GetListOfBinItemsResponse {
    return GetListOfBinItemsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetListOfBinItemsResponse>, I>>(object: I): GetListOfBinItemsResponse {
    const message = createBaseGetListOfBinItemsResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetListOfBinItemsResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetListOfBinItemsRequestBody(): GetListOfBinItemsRequestBody {
  return { binRelativePath: "", binFlags: [], onlyVisibleFlag: false, onlySelectedFlag: false };
}

export const GetListOfBinItemsRequestBody: MessageFns<GetListOfBinItemsRequestBody> = {
  encode(message: GetListOfBinItemsRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.binRelativePath !== "") {
      writer.uint32(10).string(message.binRelativePath);
    }
    writer.uint32(18).fork();
    for (const v of message.binFlags) {
      writer.int32(v);
    }
    writer.join();
    if (message.onlyVisibleFlag !== false) {
      writer.uint32(24).bool(message.onlyVisibleFlag);
    }
    if (message.onlySelectedFlag !== false) {
      writer.uint32(32).bool(message.onlySelectedFlag);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetListOfBinItemsRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetListOfBinItemsRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.binRelativePath = reader.string();
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.binFlags.push(reader.int32() as any);

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.binFlags.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.onlyVisibleFlag = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.onlySelectedFlag = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetListOfBinItemsRequestBody {
    return {
      binRelativePath: isSet(object.binRelativePath) ? globalThis.String(object.binRelativePath) : "",
      binFlags: globalThis.Array.isArray(object?.binFlags)
        ? object.binFlags.map((e: any) => getListOfBinItemsRequestBody_BinItemFlagsFromJSON(e))
        : [],
      onlyVisibleFlag: isSet(object.onlyVisibleFlag) ? globalThis.Boolean(object.onlyVisibleFlag) : false,
      onlySelectedFlag: isSet(object.onlySelectedFlag) ? globalThis.Boolean(object.onlySelectedFlag) : false,
    };
  },

  toJSON(message: GetListOfBinItemsRequestBody): unknown {
    const obj: any = {};
    if (message.binRelativePath !== "") {
      obj.binRelativePath = message.binRelativePath;
    }
    if (message.binFlags?.length) {
      obj.binFlags = message.binFlags.map((e) => getListOfBinItemsRequestBody_BinItemFlagsToJSON(e));
    }
    if (message.onlyVisibleFlag !== false) {
      obj.onlyVisibleFlag = message.onlyVisibleFlag;
    }
    if (message.onlySelectedFlag !== false) {
      obj.onlySelectedFlag = message.onlySelectedFlag;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetListOfBinItemsRequestBody>, I>>(base?: I): GetListOfBinItemsRequestBody {
    return GetListOfBinItemsRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetListOfBinItemsRequestBody>, I>>(object: I): GetListOfBinItemsRequestBody {
    const message = createBaseGetListOfBinItemsRequestBody();
    message.binRelativePath = object.binRelativePath ?? "";
    message.binFlags = object.binFlags?.map((e) => e) || [];
    message.onlyVisibleFlag = object.onlyVisibleFlag ?? false;
    message.onlySelectedFlag = object.onlySelectedFlag ?? false;
    return message;
  },
};

function createBaseGetListOfBinItemsResponseBody(): GetListOfBinItemsResponseBody {
  return { mobName: "", mobId: "", mobSelected: false };
}

export const GetListOfBinItemsResponseBody: MessageFns<GetListOfBinItemsResponseBody> = {
  encode(message: GetListOfBinItemsResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mobName !== "") {
      writer.uint32(10).string(message.mobName);
    }
    if (message.mobId !== "") {
      writer.uint32(18).string(message.mobId);
    }
    if (message.mobSelected !== false) {
      writer.uint32(24).bool(message.mobSelected);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetListOfBinItemsResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetListOfBinItemsResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mobName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.mobId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.mobSelected = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetListOfBinItemsResponseBody {
    return {
      mobName: isSet(object.mobName) ? globalThis.String(object.mobName) : "",
      mobId: isSet(object.mobId) ? globalThis.String(object.mobId) : "",
      mobSelected: isSet(object.mobSelected) ? globalThis.Boolean(object.mobSelected) : false,
    };
  },

  toJSON(message: GetListOfBinItemsResponseBody): unknown {
    const obj: any = {};
    if (message.mobName !== "") {
      obj.mobName = message.mobName;
    }
    if (message.mobId !== "") {
      obj.mobId = message.mobId;
    }
    if (message.mobSelected !== false) {
      obj.mobSelected = message.mobSelected;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetListOfBinItemsResponseBody>, I>>(base?: I): GetListOfBinItemsResponseBody {
    return GetListOfBinItemsResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetListOfBinItemsResponseBody>, I>>(
    object: I,
  ): GetListOfBinItemsResponseBody {
    const message = createBaseGetListOfBinItemsResponseBody();
    message.mobName = object.mobName ?? "";
    message.mobId = object.mobId ?? "";
    message.mobSelected = object.mobSelected ?? false;
    return message;
  },
};

function createBaseEchoRequest(): EchoRequest {
  return { header: undefined, body: undefined };
}

export const EchoRequest: MessageFns<EchoRequest> = {
  encode(message: EchoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      EchoRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EchoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEchoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = EchoRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EchoRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? EchoRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: EchoRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = EchoRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EchoRequest>, I>>(base?: I): EchoRequest {
    return EchoRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EchoRequest>, I>>(object: I): EchoRequest {
    const message = createBaseEchoRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? EchoRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseEchoResponse(): EchoResponse {
  return { header: undefined, body: undefined };
}

export const EchoResponse: MessageFns<EchoResponse> = {
  encode(message: EchoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      EchoResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EchoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEchoResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = EchoResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EchoResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? EchoResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: EchoResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = EchoResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EchoResponse>, I>>(base?: I): EchoResponse {
    return EchoResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EchoResponse>, I>>(object: I): EchoResponse {
    const message = createBaseEchoResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? EchoResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseEchoRequestBody(): EchoRequestBody {
  return { message: "" };
}

export const EchoRequestBody: MessageFns<EchoRequestBody> = {
  encode(message: EchoRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== "") {
      writer.uint32(10).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EchoRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEchoRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EchoRequestBody {
    return { message: isSet(object.message) ? globalThis.String(object.message) : "" };
  },

  toJSON(message: EchoRequestBody): unknown {
    const obj: any = {};
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EchoRequestBody>, I>>(base?: I): EchoRequestBody {
    return EchoRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EchoRequestBody>, I>>(object: I): EchoRequestBody {
    const message = createBaseEchoRequestBody();
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseEchoResponseBody(): EchoResponseBody {
  return { message: "" };
}

export const EchoResponseBody: MessageFns<EchoResponseBody> = {
  encode(message: EchoResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== "") {
      writer.uint32(10).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EchoResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEchoResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EchoResponseBody {
    return { message: isSet(object.message) ? globalThis.String(object.message) : "" };
  },

  toJSON(message: EchoResponseBody): unknown {
    const obj: any = {};
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EchoResponseBody>, I>>(base?: I): EchoResponseBody {
    return EchoResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EchoResponseBody>, I>>(object: I): EchoResponseBody {
    const message = createBaseEchoResponseBody();
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseGetValuesRequest(): GetValuesRequest {
  return { header: undefined, body: undefined };
}

export const GetValuesRequest: MessageFns<GetValuesRequest> = {
  encode(message: GetValuesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetValuesRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetValuesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetValuesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetValuesRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetValuesRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetValuesRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetValuesRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetValuesRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetValuesRequest>, I>>(base?: I): GetValuesRequest {
    return GetValuesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetValuesRequest>, I>>(object: I): GetValuesRequest {
    const message = createBaseGetValuesRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetValuesRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetValuesResponse(): GetValuesResponse {
  return { header: undefined, body: undefined };
}

export const GetValuesResponse: MessageFns<GetValuesResponse> = {
  encode(message: GetValuesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetValuesResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetValuesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetValuesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetValuesResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetValuesResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetValuesResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetValuesResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetValuesResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetValuesResponse>, I>>(base?: I): GetValuesResponse {
    return GetValuesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetValuesResponse>, I>>(object: I): GetValuesResponse {
    const message = createBaseGetValuesResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetValuesResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetValuesRequestBody(): GetValuesRequestBody {
  return { key: "", count: 0 };
}

export const GetValuesRequestBody: MessageFns<GetValuesRequestBody> = {
  encode(message: GetValuesRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.count !== 0) {
      writer.uint32(16).uint32(message.count);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetValuesRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetValuesRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.count = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetValuesRequestBody {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      count: isSet(object.count) ? globalThis.Number(object.count) : 0,
    };
  },

  toJSON(message: GetValuesRequestBody): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.count !== 0) {
      obj.count = Math.round(message.count);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetValuesRequestBody>, I>>(base?: I): GetValuesRequestBody {
    return GetValuesRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetValuesRequestBody>, I>>(object: I): GetValuesRequestBody {
    const message = createBaseGetValuesRequestBody();
    message.key = object.key ?? "";
    message.count = object.count ?? 0;
    return message;
  },
};

function createBaseGetValuesResponseBody(): GetValuesResponseBody {
  return { value: "" };
}

export const GetValuesResponseBody: MessageFns<GetValuesResponseBody> = {
  encode(message: GetValuesResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.value !== "") {
      writer.uint32(10).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetValuesResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetValuesResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetValuesResponseBody {
    return { value: isSet(object.value) ? globalThis.String(object.value) : "" };
  },

  toJSON(message: GetValuesResponseBody): unknown {
    const obj: any = {};
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetValuesResponseBody>, I>>(base?: I): GetValuesResponseBody {
    return GetValuesResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetValuesResponseBody>, I>>(object: I): GetValuesResponseBody {
    const message = createBaseGetValuesResponseBody();
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseGetAppInfoRequest(): GetAppInfoRequest {
  return { header: undefined, body: undefined };
}

export const GetAppInfoRequest: MessageFns<GetAppInfoRequest> = {
  encode(message: GetAppInfoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetAppInfoRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAppInfoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAppInfoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetAppInfoRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAppInfoRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetAppInfoRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetAppInfoRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetAppInfoRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAppInfoRequest>, I>>(base?: I): GetAppInfoRequest {
    return GetAppInfoRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAppInfoRequest>, I>>(object: I): GetAppInfoRequest {
    const message = createBaseGetAppInfoRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetAppInfoRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetAppInfoRequestBody(): GetAppInfoRequestBody {
  return {};
}

export const GetAppInfoRequestBody: MessageFns<GetAppInfoRequestBody> = {
  encode(_: GetAppInfoRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAppInfoRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAppInfoRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetAppInfoRequestBody {
    return {};
  },

  toJSON(_: GetAppInfoRequestBody): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAppInfoRequestBody>, I>>(base?: I): GetAppInfoRequestBody {
    return GetAppInfoRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAppInfoRequestBody>, I>>(_: I): GetAppInfoRequestBody {
    const message = createBaseGetAppInfoRequestBody();
    return message;
  },
};

function createBaseGetAppInfoResponse(): GetAppInfoResponse {
  return { header: undefined, body: undefined };
}

export const GetAppInfoResponse: MessageFns<GetAppInfoResponse> = {
  encode(message: GetAppInfoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetAppInfoResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAppInfoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAppInfoResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetAppInfoResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAppInfoResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetAppInfoResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetAppInfoResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetAppInfoResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAppInfoResponse>, I>>(base?: I): GetAppInfoResponse {
    return GetAppInfoResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAppInfoResponse>, I>>(object: I): GetAppInfoResponse {
    const message = createBaseGetAppInfoResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetAppInfoResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetAppInfoResponseBody(): GetAppInfoResponseBody {
  return { appName: "", appVersion: "", appBusyStatus: 0, sdkVersion: "" };
}

export const GetAppInfoResponseBody: MessageFns<GetAppInfoResponseBody> = {
  encode(message: GetAppInfoResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.appName !== "") {
      writer.uint32(10).string(message.appName);
    }
    if (message.appVersion !== "") {
      writer.uint32(18).string(message.appVersion);
    }
    if (message.appBusyStatus !== 0) {
      writer.uint32(24).int32(message.appBusyStatus);
    }
    if (message.sdkVersion !== "") {
      writer.uint32(34).string(message.sdkVersion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAppInfoResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAppInfoResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.appName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.appVersion = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.appBusyStatus = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.sdkVersion = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAppInfoResponseBody {
    return {
      appName: isSet(object.appName) ? globalThis.String(object.appName) : "",
      appVersion: isSet(object.appVersion) ? globalThis.String(object.appVersion) : "",
      appBusyStatus: isSet(object.appBusyStatus)
        ? getAppInfoResponseBody_AppBusyStatusFromJSON(object.appBusyStatus)
        : 0,
      sdkVersion: isSet(object.sdkVersion) ? globalThis.String(object.sdkVersion) : "",
    };
  },

  toJSON(message: GetAppInfoResponseBody): unknown {
    const obj: any = {};
    if (message.appName !== "") {
      obj.appName = message.appName;
    }
    if (message.appVersion !== "") {
      obj.appVersion = message.appVersion;
    }
    if (message.appBusyStatus !== 0) {
      obj.appBusyStatus = getAppInfoResponseBody_AppBusyStatusToJSON(message.appBusyStatus);
    }
    if (message.sdkVersion !== "") {
      obj.sdkVersion = message.sdkVersion;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAppInfoResponseBody>, I>>(base?: I): GetAppInfoResponseBody {
    return GetAppInfoResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAppInfoResponseBody>, I>>(object: I): GetAppInfoResponseBody {
    const message = createBaseGetAppInfoResponseBody();
    message.appName = object.appName ?? "";
    message.appVersion = object.appVersion ?? "";
    message.appBusyStatus = object.appBusyStatus ?? 0;
    message.sdkVersion = object.sdkVersion ?? "";
    return message;
  },
};

function createBaseGetHostInfoRequest(): GetHostInfoRequest {
  return { header: undefined, body: undefined };
}

export const GetHostInfoRequest: MessageFns<GetHostInfoRequest> = {
  encode(message: GetHostInfoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetHostInfoRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetHostInfoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetHostInfoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetHostInfoRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetHostInfoRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetHostInfoRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetHostInfoRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetHostInfoRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetHostInfoRequest>, I>>(base?: I): GetHostInfoRequest {
    return GetHostInfoRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetHostInfoRequest>, I>>(object: I): GetHostInfoRequest {
    const message = createBaseGetHostInfoRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetHostInfoRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetHostInfoRequestBody(): GetHostInfoRequestBody {
  return {};
}

export const GetHostInfoRequestBody: MessageFns<GetHostInfoRequestBody> = {
  encode(_: GetHostInfoRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetHostInfoRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetHostInfoRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetHostInfoRequestBody {
    return {};
  },

  toJSON(_: GetHostInfoRequestBody): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetHostInfoRequestBody>, I>>(base?: I): GetHostInfoRequestBody {
    return GetHostInfoRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetHostInfoRequestBody>, I>>(_: I): GetHostInfoRequestBody {
    const message = createBaseGetHostInfoRequestBody();
    return message;
  },
};

function createBaseGetHostInfoResponse(): GetHostInfoResponse {
  return { header: undefined, body: undefined };
}

export const GetHostInfoResponse: MessageFns<GetHostInfoResponse> = {
  encode(message: GetHostInfoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetHostInfoResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetHostInfoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetHostInfoResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetHostInfoResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetHostInfoResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetHostInfoResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetHostInfoResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetHostInfoResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetHostInfoResponse>, I>>(base?: I): GetHostInfoResponse {
    return GetHostInfoResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetHostInfoResponse>, I>>(object: I): GetHostInfoResponse {
    const message = createBaseGetHostInfoResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetHostInfoResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetHostInfoResponseBody(): GetHostInfoResponseBody {
  return { applName: "", userName: "", workstationName: "" };
}

export const GetHostInfoResponseBody: MessageFns<GetHostInfoResponseBody> = {
  encode(message: GetHostInfoResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.applName !== "") {
      writer.uint32(10).string(message.applName);
    }
    if (message.userName !== "") {
      writer.uint32(18).string(message.userName);
    }
    if (message.workstationName !== "") {
      writer.uint32(26).string(message.workstationName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetHostInfoResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetHostInfoResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.applName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.userName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.workstationName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetHostInfoResponseBody {
    return {
      applName: isSet(object.applName) ? globalThis.String(object.applName) : "",
      userName: isSet(object.userName) ? globalThis.String(object.userName) : "",
      workstationName: isSet(object.workstationName) ? globalThis.String(object.workstationName) : "",
    };
  },

  toJSON(message: GetHostInfoResponseBody): unknown {
    const obj: any = {};
    if (message.applName !== "") {
      obj.applName = message.applName;
    }
    if (message.userName !== "") {
      obj.userName = message.userName;
    }
    if (message.workstationName !== "") {
      obj.workstationName = message.workstationName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetHostInfoResponseBody>, I>>(base?: I): GetHostInfoResponseBody {
    return GetHostInfoResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetHostInfoResponseBody>, I>>(object: I): GetHostInfoResponseBody {
    const message = createBaseGetHostInfoResponseBody();
    message.applName = object.applName ?? "";
    message.userName = object.userName ?? "";
    message.workstationName = object.workstationName ?? "";
    return message;
  },
};

function createBaseGetBinsRequest(): GetBinsRequest {
  return { header: undefined, body: undefined };
}

export const GetBinsRequest: MessageFns<GetBinsRequest> = {
  encode(message: GetBinsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetBinsRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetBinsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBinsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetBinsRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBinsRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetBinsRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetBinsRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetBinsRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBinsRequest>, I>>(base?: I): GetBinsRequest {
    return GetBinsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBinsRequest>, I>>(object: I): GetBinsRequest {
    const message = createBaseGetBinsRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetBinsRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetBinsRequestBody(): GetBinsRequestBody {
  return { projectPath: undefined, requestFlag: [] };
}

export const GetBinsRequestBody: MessageFns<GetBinsRequestBody> = {
  encode(message: GetBinsRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.projectPath !== undefined) {
      writer.uint32(10).string(message.projectPath);
    }
    writer.uint32(18).fork();
    for (const v of message.requestFlag) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetBinsRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBinsRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.projectPath = reader.string();
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.requestFlag.push(reader.int32() as any);

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.requestFlag.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBinsRequestBody {
    return {
      projectPath: isSet(object.projectPath) ? globalThis.String(object.projectPath) : undefined,
      requestFlag: globalThis.Array.isArray(object?.requestFlag)
        ? object.requestFlag.map((e: any) => getBinsRequestBody_GetBinsFlagFromJSON(e))
        : [],
    };
  },

  toJSON(message: GetBinsRequestBody): unknown {
    const obj: any = {};
    if (message.projectPath !== undefined) {
      obj.projectPath = message.projectPath;
    }
    if (message.requestFlag?.length) {
      obj.requestFlag = message.requestFlag.map((e) => getBinsRequestBody_GetBinsFlagToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBinsRequestBody>, I>>(base?: I): GetBinsRequestBody {
    return GetBinsRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBinsRequestBody>, I>>(object: I): GetBinsRequestBody {
    const message = createBaseGetBinsRequestBody();
    message.projectPath = object.projectPath ?? undefined;
    message.requestFlag = object.requestFlag?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetBinsResponse(): GetBinsResponse {
  return { header: undefined, body: undefined };
}

export const GetBinsResponse: MessageFns<GetBinsResponse> = {
  encode(message: GetBinsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetBinsResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetBinsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBinsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetBinsResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBinsResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetBinsResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetBinsResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetBinsResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBinsResponse>, I>>(base?: I): GetBinsResponse {
    return GetBinsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBinsResponse>, I>>(object: I): GetBinsResponse {
    const message = createBaseGetBinsResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetBinsResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetBinsResponseBody(): GetBinsResponseBody {
  return { absolutePath: "" };
}

export const GetBinsResponseBody: MessageFns<GetBinsResponseBody> = {
  encode(message: GetBinsResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.absolutePath !== "") {
      writer.uint32(10).string(message.absolutePath);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetBinsResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBinsResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.absolutePath = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBinsResponseBody {
    return { absolutePath: isSet(object.absolutePath) ? globalThis.String(object.absolutePath) : "" };
  },

  toJSON(message: GetBinsResponseBody): unknown {
    const obj: any = {};
    if (message.absolutePath !== "") {
      obj.absolutePath = message.absolutePath;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBinsResponseBody>, I>>(base?: I): GetBinsResponseBody {
    return GetBinsResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBinsResponseBody>, I>>(object: I): GetBinsResponseBody {
    const message = createBaseGetBinsResponseBody();
    message.absolutePath = object.absolutePath ?? "";
    return message;
  },
};

function createBaseGetBinInfoRequest(): GetBinInfoRequest {
  return { header: undefined, body: undefined };
}

export const GetBinInfoRequest: MessageFns<GetBinInfoRequest> = {
  encode(message: GetBinInfoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetBinInfoRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetBinInfoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBinInfoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetBinInfoRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBinInfoRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetBinInfoRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetBinInfoRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetBinInfoRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBinInfoRequest>, I>>(base?: I): GetBinInfoRequest {
    return GetBinInfoRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBinInfoRequest>, I>>(object: I): GetBinInfoRequest {
    const message = createBaseGetBinInfoRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetBinInfoRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetBinInfoRequestBody(): GetBinInfoRequestBody {
  return { relativeBinPath: "" };
}

export const GetBinInfoRequestBody: MessageFns<GetBinInfoRequestBody> = {
  encode(message: GetBinInfoRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.relativeBinPath !== "") {
      writer.uint32(10).string(message.relativeBinPath);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetBinInfoRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBinInfoRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.relativeBinPath = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBinInfoRequestBody {
    return { relativeBinPath: isSet(object.relativeBinPath) ? globalThis.String(object.relativeBinPath) : "" };
  },

  toJSON(message: GetBinInfoRequestBody): unknown {
    const obj: any = {};
    if (message.relativeBinPath !== "") {
      obj.relativeBinPath = message.relativeBinPath;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBinInfoRequestBody>, I>>(base?: I): GetBinInfoRequestBody {
    return GetBinInfoRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBinInfoRequestBody>, I>>(object: I): GetBinInfoRequestBody {
    const message = createBaseGetBinInfoRequestBody();
    message.relativeBinPath = object.relativeBinPath ?? "";
    return message;
  },
};

function createBaseGetBinInfoResponse(): GetBinInfoResponse {
  return { header: undefined, body: undefined };
}

export const GetBinInfoResponse: MessageFns<GetBinInfoResponse> = {
  encode(message: GetBinInfoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetBinInfoResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetBinInfoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBinInfoResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetBinInfoResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBinInfoResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetBinInfoResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetBinInfoResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetBinInfoResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBinInfoResponse>, I>>(base?: I): GetBinInfoResponse {
    return GetBinInfoResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBinInfoResponse>, I>>(object: I): GetBinInfoResponse {
    const message = createBaseGetBinInfoResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetBinInfoResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetBinInfoResponseBody(): GetBinInfoResponseBody {
  return { lockState: false, lockOwner: "", size: 0, isOpen: false, backgroundColor: "" };
}

export const GetBinInfoResponseBody: MessageFns<GetBinInfoResponseBody> = {
  encode(message: GetBinInfoResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.lockState !== false) {
      writer.uint32(8).bool(message.lockState);
    }
    if (message.lockOwner !== "") {
      writer.uint32(18).string(message.lockOwner);
    }
    if (message.size !== 0) {
      writer.uint32(24).uint64(message.size);
    }
    if (message.isOpen !== false) {
      writer.uint32(32).bool(message.isOpen);
    }
    if (message.backgroundColor !== "") {
      writer.uint32(42).string(message.backgroundColor);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetBinInfoResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBinInfoResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.lockState = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.lockOwner = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.size = longToNumber(reader.uint64());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.isOpen = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.backgroundColor = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBinInfoResponseBody {
    return {
      lockState: isSet(object.lockState) ? globalThis.Boolean(object.lockState) : false,
      lockOwner: isSet(object.lockOwner) ? globalThis.String(object.lockOwner) : "",
      size: isSet(object.size) ? globalThis.Number(object.size) : 0,
      isOpen: isSet(object.isOpen) ? globalThis.Boolean(object.isOpen) : false,
      backgroundColor: isSet(object.backgroundColor) ? globalThis.String(object.backgroundColor) : "",
    };
  },

  toJSON(message: GetBinInfoResponseBody): unknown {
    const obj: any = {};
    if (message.lockState !== false) {
      obj.lockState = message.lockState;
    }
    if (message.lockOwner !== "") {
      obj.lockOwner = message.lockOwner;
    }
    if (message.size !== 0) {
      obj.size = Math.round(message.size);
    }
    if (message.isOpen !== false) {
      obj.isOpen = message.isOpen;
    }
    if (message.backgroundColor !== "") {
      obj.backgroundColor = message.backgroundColor;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBinInfoResponseBody>, I>>(base?: I): GetBinInfoResponseBody {
    return GetBinInfoResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBinInfoResponseBody>, I>>(object: I): GetBinInfoResponseBody {
    const message = createBaseGetBinInfoResponseBody();
    message.lockState = object.lockState ?? false;
    message.lockOwner = object.lockOwner ?? "";
    message.size = object.size ?? 0;
    message.isOpen = object.isOpen ?? false;
    message.backgroundColor = object.backgroundColor ?? "";
    return message;
  },
};

function createBaseGetBinColumnInfoRequest(): GetBinColumnInfoRequest {
  return { header: undefined, body: undefined };
}

export const GetBinColumnInfoRequest: MessageFns<GetBinColumnInfoRequest> = {
  encode(message: GetBinColumnInfoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetBinColumnInfoRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetBinColumnInfoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBinColumnInfoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetBinColumnInfoRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBinColumnInfoRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetBinColumnInfoRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetBinColumnInfoRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetBinColumnInfoRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBinColumnInfoRequest>, I>>(base?: I): GetBinColumnInfoRequest {
    return GetBinColumnInfoRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBinColumnInfoRequest>, I>>(object: I): GetBinColumnInfoRequest {
    const message = createBaseGetBinColumnInfoRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetBinColumnInfoRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetBinColumnInfoRequestBody(): GetBinColumnInfoRequestBody {
  return { binPath: "" };
}

export const GetBinColumnInfoRequestBody: MessageFns<GetBinColumnInfoRequestBody> = {
  encode(message: GetBinColumnInfoRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.binPath !== "") {
      writer.uint32(10).string(message.binPath);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetBinColumnInfoRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBinColumnInfoRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.binPath = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBinColumnInfoRequestBody {
    return { binPath: isSet(object.binPath) ? globalThis.String(object.binPath) : "" };
  },

  toJSON(message: GetBinColumnInfoRequestBody): unknown {
    const obj: any = {};
    if (message.binPath !== "") {
      obj.binPath = message.binPath;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBinColumnInfoRequestBody>, I>>(base?: I): GetBinColumnInfoRequestBody {
    return GetBinColumnInfoRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBinColumnInfoRequestBody>, I>>(object: I): GetBinColumnInfoRequestBody {
    const message = createBaseGetBinColumnInfoRequestBody();
    message.binPath = object.binPath ?? "";
    return message;
  },
};

function createBaseGetBinColumnInfoResponse(): GetBinColumnInfoResponse {
  return { header: undefined, body: undefined };
}

export const GetBinColumnInfoResponse: MessageFns<GetBinColumnInfoResponse> = {
  encode(message: GetBinColumnInfoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetBinColumnInfoResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetBinColumnInfoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBinColumnInfoResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetBinColumnInfoResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBinColumnInfoResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetBinColumnInfoResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetBinColumnInfoResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetBinColumnInfoResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBinColumnInfoResponse>, I>>(base?: I): GetBinColumnInfoResponse {
    return GetBinColumnInfoResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBinColumnInfoResponse>, I>>(object: I): GetBinColumnInfoResponse {
    const message = createBaseGetBinColumnInfoResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetBinColumnInfoResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetBinColumnInfoResponseBody(): GetBinColumnInfoResponseBody {
  return { column: [] };
}

export const GetBinColumnInfoResponseBody: MessageFns<GetBinColumnInfoResponseBody> = {
  encode(message: GetBinColumnInfoResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.column) {
      GetBinColumnInfoResponseBody_BinColumnInfo.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetBinColumnInfoResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBinColumnInfoResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.column.push(GetBinColumnInfoResponseBody_BinColumnInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBinColumnInfoResponseBody {
    return {
      column: globalThis.Array.isArray(object?.column)
        ? object.column.map((e: any) => GetBinColumnInfoResponseBody_BinColumnInfo.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetBinColumnInfoResponseBody): unknown {
    const obj: any = {};
    if (message.column?.length) {
      obj.column = message.column.map((e) => GetBinColumnInfoResponseBody_BinColumnInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBinColumnInfoResponseBody>, I>>(base?: I): GetBinColumnInfoResponseBody {
    return GetBinColumnInfoResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBinColumnInfoResponseBody>, I>>(object: I): GetBinColumnInfoResponseBody {
    const message = createBaseGetBinColumnInfoResponseBody();
    message.column = object.column?.map((e) => GetBinColumnInfoResponseBody_BinColumnInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetBinColumnInfoResponseBody_BinColumnInfo(): GetBinColumnInfoResponseBody_BinColumnInfo {
  return { columnName: "", columnValueType: "", columnHidden: false, columnIsCustom: false, columnIsReadonly: false };
}

export const GetBinColumnInfoResponseBody_BinColumnInfo: MessageFns<GetBinColumnInfoResponseBody_BinColumnInfo> = {
  encode(message: GetBinColumnInfoResponseBody_BinColumnInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.columnName !== "") {
      writer.uint32(10).string(message.columnName);
    }
    if (message.columnValueType !== "") {
      writer.uint32(18).string(message.columnValueType);
    }
    if (message.columnHidden !== false) {
      writer.uint32(24).bool(message.columnHidden);
    }
    if (message.columnIsCustom !== false) {
      writer.uint32(32).bool(message.columnIsCustom);
    }
    if (message.columnIsReadonly !== false) {
      writer.uint32(40).bool(message.columnIsReadonly);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetBinColumnInfoResponseBody_BinColumnInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBinColumnInfoResponseBody_BinColumnInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.columnName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.columnValueType = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.columnHidden = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.columnIsCustom = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.columnIsReadonly = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBinColumnInfoResponseBody_BinColumnInfo {
    return {
      columnName: isSet(object.columnName) ? globalThis.String(object.columnName) : "",
      columnValueType: isSet(object.columnValueType) ? globalThis.String(object.columnValueType) : "",
      columnHidden: isSet(object.columnHidden) ? globalThis.Boolean(object.columnHidden) : false,
      columnIsCustom: isSet(object.columnIsCustom) ? globalThis.Boolean(object.columnIsCustom) : false,
      columnIsReadonly: isSet(object.columnIsReadonly) ? globalThis.Boolean(object.columnIsReadonly) : false,
    };
  },

  toJSON(message: GetBinColumnInfoResponseBody_BinColumnInfo): unknown {
    const obj: any = {};
    if (message.columnName !== "") {
      obj.columnName = message.columnName;
    }
    if (message.columnValueType !== "") {
      obj.columnValueType = message.columnValueType;
    }
    if (message.columnHidden !== false) {
      obj.columnHidden = message.columnHidden;
    }
    if (message.columnIsCustom !== false) {
      obj.columnIsCustom = message.columnIsCustom;
    }
    if (message.columnIsReadonly !== false) {
      obj.columnIsReadonly = message.columnIsReadonly;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBinColumnInfoResponseBody_BinColumnInfo>, I>>(
    base?: I,
  ): GetBinColumnInfoResponseBody_BinColumnInfo {
    return GetBinColumnInfoResponseBody_BinColumnInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBinColumnInfoResponseBody_BinColumnInfo>, I>>(
    object: I,
  ): GetBinColumnInfoResponseBody_BinColumnInfo {
    const message = createBaseGetBinColumnInfoResponseBody_BinColumnInfo();
    message.columnName = object.columnName ?? "";
    message.columnValueType = object.columnValueType ?? "";
    message.columnHidden = object.columnHidden ?? false;
    message.columnIsCustom = object.columnIsCustom ?? false;
    message.columnIsReadonly = object.columnIsReadonly ?? false;
    return message;
  },
};

function createBaseGetMobInfoRequest(): GetMobInfoRequest {
  return { header: undefined, body: undefined };
}

export const GetMobInfoRequest: MessageFns<GetMobInfoRequest> = {
  encode(message: GetMobInfoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetMobInfoRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMobInfoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMobInfoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetMobInfoRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMobInfoRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetMobInfoRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetMobInfoRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetMobInfoRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMobInfoRequest>, I>>(base?: I): GetMobInfoRequest {
    return GetMobInfoRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMobInfoRequest>, I>>(object: I): GetMobInfoRequest {
    const message = createBaseGetMobInfoRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetMobInfoRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetMobInfoRequestBody(): GetMobInfoRequestBody {
  return { mobId: "", onlyVisibleColumns: false, includesEmptyColumns: false };
}

export const GetMobInfoRequestBody: MessageFns<GetMobInfoRequestBody> = {
  encode(message: GetMobInfoRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mobId !== "") {
      writer.uint32(10).string(message.mobId);
    }
    if (message.onlyVisibleColumns !== false) {
      writer.uint32(16).bool(message.onlyVisibleColumns);
    }
    if (message.includesEmptyColumns !== false) {
      writer.uint32(24).bool(message.includesEmptyColumns);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMobInfoRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMobInfoRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mobId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.onlyVisibleColumns = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.includesEmptyColumns = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMobInfoRequestBody {
    return {
      mobId: isSet(object.mobId) ? globalThis.String(object.mobId) : "",
      onlyVisibleColumns: isSet(object.onlyVisibleColumns) ? globalThis.Boolean(object.onlyVisibleColumns) : false,
      includesEmptyColumns: isSet(object.includesEmptyColumns)
        ? globalThis.Boolean(object.includesEmptyColumns)
        : false,
    };
  },

  toJSON(message: GetMobInfoRequestBody): unknown {
    const obj: any = {};
    if (message.mobId !== "") {
      obj.mobId = message.mobId;
    }
    if (message.onlyVisibleColumns !== false) {
      obj.onlyVisibleColumns = message.onlyVisibleColumns;
    }
    if (message.includesEmptyColumns !== false) {
      obj.includesEmptyColumns = message.includesEmptyColumns;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMobInfoRequestBody>, I>>(base?: I): GetMobInfoRequestBody {
    return GetMobInfoRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMobInfoRequestBody>, I>>(object: I): GetMobInfoRequestBody {
    const message = createBaseGetMobInfoRequestBody();
    message.mobId = object.mobId ?? "";
    message.onlyVisibleColumns = object.onlyVisibleColumns ?? false;
    message.includesEmptyColumns = object.includesEmptyColumns ?? false;
    return message;
  },
};

function createBaseGetMobInfoResponse(): GetMobInfoResponse {
  return { header: undefined, body: undefined };
}

export const GetMobInfoResponse: MessageFns<GetMobInfoResponse> = {
  encode(message: GetMobInfoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetMobInfoResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMobInfoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMobInfoResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetMobInfoResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMobInfoResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetMobInfoResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetMobInfoResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetMobInfoResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMobInfoResponse>, I>>(base?: I): GetMobInfoResponse {
    return GetMobInfoResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMobInfoResponse>, I>>(object: I): GetMobInfoResponse {
    const message = createBaseGetMobInfoResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetMobInfoResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetMobInfoResponseBody(): GetMobInfoResponseBody {
  return { columnName: "", columnValue: "", columnValueType: "", columnHidden: false, columnIsCustom: false };
}

export const GetMobInfoResponseBody: MessageFns<GetMobInfoResponseBody> = {
  encode(message: GetMobInfoResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.columnName !== "") {
      writer.uint32(10).string(message.columnName);
    }
    if (message.columnValue !== "") {
      writer.uint32(18).string(message.columnValue);
    }
    if (message.columnValueType !== "") {
      writer.uint32(26).string(message.columnValueType);
    }
    if (message.columnHidden !== false) {
      writer.uint32(32).bool(message.columnHidden);
    }
    if (message.columnIsCustom !== false) {
      writer.uint32(40).bool(message.columnIsCustom);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMobInfoResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMobInfoResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.columnName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.columnValue = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.columnValueType = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.columnHidden = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.columnIsCustom = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMobInfoResponseBody {
    return {
      columnName: isSet(object.columnName) ? globalThis.String(object.columnName) : "",
      columnValue: isSet(object.columnValue) ? globalThis.String(object.columnValue) : "",
      columnValueType: isSet(object.columnValueType) ? globalThis.String(object.columnValueType) : "",
      columnHidden: isSet(object.columnHidden) ? globalThis.Boolean(object.columnHidden) : false,
      columnIsCustom: isSet(object.columnIsCustom) ? globalThis.Boolean(object.columnIsCustom) : false,
    };
  },

  toJSON(message: GetMobInfoResponseBody): unknown {
    const obj: any = {};
    if (message.columnName !== "") {
      obj.columnName = message.columnName;
    }
    if (message.columnValue !== "") {
      obj.columnValue = message.columnValue;
    }
    if (message.columnValueType !== "") {
      obj.columnValueType = message.columnValueType;
    }
    if (message.columnHidden !== false) {
      obj.columnHidden = message.columnHidden;
    }
    if (message.columnIsCustom !== false) {
      obj.columnIsCustom = message.columnIsCustom;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMobInfoResponseBody>, I>>(base?: I): GetMobInfoResponseBody {
    return GetMobInfoResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMobInfoResponseBody>, I>>(object: I): GetMobInfoResponseBody {
    const message = createBaseGetMobInfoResponseBody();
    message.columnName = object.columnName ?? "";
    message.columnValue = object.columnValue ?? "";
    message.columnValueType = object.columnValueType ?? "";
    message.columnHidden = object.columnHidden ?? false;
    message.columnIsCustom = object.columnIsCustom ?? false;
    return message;
  },
};

function createBaseSetMobInfoRequest(): SetMobInfoRequest {
  return { header: undefined, body: undefined };
}

export const SetMobInfoRequest: MessageFns<SetMobInfoRequest> = {
  encode(message: SetMobInfoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      SetMobInfoRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetMobInfoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetMobInfoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = SetMobInfoRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetMobInfoRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? SetMobInfoRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: SetMobInfoRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = SetMobInfoRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetMobInfoRequest>, I>>(base?: I): SetMobInfoRequest {
    return SetMobInfoRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetMobInfoRequest>, I>>(object: I): SetMobInfoRequest {
    const message = createBaseSetMobInfoRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? SetMobInfoRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseSetMobInfoRequestBody(): SetMobInfoRequestBody {
  return { mobId: "", column: undefined };
}

export const SetMobInfoRequestBody: MessageFns<SetMobInfoRequestBody> = {
  encode(message: SetMobInfoRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mobId !== "") {
      writer.uint32(10).string(message.mobId);
    }
    if (message.column !== undefined) {
      ColumnInfo.encode(message.column, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetMobInfoRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetMobInfoRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mobId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.column = ColumnInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetMobInfoRequestBody {
    return {
      mobId: isSet(object.mobId) ? globalThis.String(object.mobId) : "",
      column: isSet(object.column) ? ColumnInfo.fromJSON(object.column) : undefined,
    };
  },

  toJSON(message: SetMobInfoRequestBody): unknown {
    const obj: any = {};
    if (message.mobId !== "") {
      obj.mobId = message.mobId;
    }
    if (message.column !== undefined) {
      obj.column = ColumnInfo.toJSON(message.column);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetMobInfoRequestBody>, I>>(base?: I): SetMobInfoRequestBody {
    return SetMobInfoRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetMobInfoRequestBody>, I>>(object: I): SetMobInfoRequestBody {
    const message = createBaseSetMobInfoRequestBody();
    message.mobId = object.mobId ?? "";
    message.column = (object.column !== undefined && object.column !== null)
      ? ColumnInfo.fromPartial(object.column)
      : undefined;
    return message;
  },
};

function createBaseColumnInfo(): ColumnInfo {
  return { columnName: "", columnValue: "" };
}

export const ColumnInfo: MessageFns<ColumnInfo> = {
  encode(message: ColumnInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.columnName !== "") {
      writer.uint32(10).string(message.columnName);
    }
    if (message.columnValue !== "") {
      writer.uint32(18).string(message.columnValue);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ColumnInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseColumnInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.columnName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.columnValue = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ColumnInfo {
    return {
      columnName: isSet(object.columnName) ? globalThis.String(object.columnName) : "",
      columnValue: isSet(object.columnValue) ? globalThis.String(object.columnValue) : "",
    };
  },

  toJSON(message: ColumnInfo): unknown {
    const obj: any = {};
    if (message.columnName !== "") {
      obj.columnName = message.columnName;
    }
    if (message.columnValue !== "") {
      obj.columnValue = message.columnValue;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ColumnInfo>, I>>(base?: I): ColumnInfo {
    return ColumnInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ColumnInfo>, I>>(object: I): ColumnInfo {
    const message = createBaseColumnInfo();
    message.columnName = object.columnName ?? "";
    message.columnValue = object.columnValue ?? "";
    return message;
  },
};

function createBaseSetMobInfoResponse(): SetMobInfoResponse {
  return { header: undefined, body: undefined };
}

export const SetMobInfoResponse: MessageFns<SetMobInfoResponse> = {
  encode(message: SetMobInfoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      SetMobInfoResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetMobInfoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetMobInfoResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = SetMobInfoResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetMobInfoResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? SetMobInfoResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: SetMobInfoResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = SetMobInfoResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetMobInfoResponse>, I>>(base?: I): SetMobInfoResponse {
    return SetMobInfoResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetMobInfoResponse>, I>>(object: I): SetMobInfoResponse {
    const message = createBaseSetMobInfoResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? SetMobInfoResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseSetMobInfoResponseBody(): SetMobInfoResponseBody {
  return { mobFailure: [] };
}

export const SetMobInfoResponseBody: MessageFns<SetMobInfoResponseBody> = {
  encode(message: SetMobInfoResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.mobFailure) {
      SetMobInfoResponseBody_MobFailure.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetMobInfoResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetMobInfoResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mobFailure.push(SetMobInfoResponseBody_MobFailure.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetMobInfoResponseBody {
    return {
      mobFailure: globalThis.Array.isArray(object?.mobFailure)
        ? object.mobFailure.map((e: any) => SetMobInfoResponseBody_MobFailure.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SetMobInfoResponseBody): unknown {
    const obj: any = {};
    if (message.mobFailure?.length) {
      obj.mobFailure = message.mobFailure.map((e) => SetMobInfoResponseBody_MobFailure.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetMobInfoResponseBody>, I>>(base?: I): SetMobInfoResponseBody {
    return SetMobInfoResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetMobInfoResponseBody>, I>>(object: I): SetMobInfoResponseBody {
    const message = createBaseSetMobInfoResponseBody();
    message.mobFailure = object.mobFailure?.map((e) => SetMobInfoResponseBody_MobFailure.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSetMobInfoResponseBody_MobFailure(): SetMobInfoResponseBody_MobFailure {
  return { mobId: "", failedColumns: [] };
}

export const SetMobInfoResponseBody_MobFailure: MessageFns<SetMobInfoResponseBody_MobFailure> = {
  encode(message: SetMobInfoResponseBody_MobFailure, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mobId !== "") {
      writer.uint32(10).string(message.mobId);
    }
    for (const v of message.failedColumns) {
      ColumnInfo.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetMobInfoResponseBody_MobFailure {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetMobInfoResponseBody_MobFailure();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mobId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.failedColumns.push(ColumnInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetMobInfoResponseBody_MobFailure {
    return {
      mobId: isSet(object.mobId) ? globalThis.String(object.mobId) : "",
      failedColumns: globalThis.Array.isArray(object?.failedColumns)
        ? object.failedColumns.map((e: any) => ColumnInfo.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SetMobInfoResponseBody_MobFailure): unknown {
    const obj: any = {};
    if (message.mobId !== "") {
      obj.mobId = message.mobId;
    }
    if (message.failedColumns?.length) {
      obj.failedColumns = message.failedColumns.map((e) => ColumnInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetMobInfoResponseBody_MobFailure>, I>>(
    base?: I,
  ): SetMobInfoResponseBody_MobFailure {
    return SetMobInfoResponseBody_MobFailure.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetMobInfoResponseBody_MobFailure>, I>>(
    object: I,
  ): SetMobInfoResponseBody_MobFailure {
    const message = createBaseSetMobInfoResponseBody_MobFailure();
    message.mobId = object.mobId ?? "";
    message.failedColumns = object.failedColumns?.map((e) => ColumnInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseOpenBinRequest(): OpenBinRequest {
  return { header: undefined, body: undefined };
}

export const OpenBinRequest: MessageFns<OpenBinRequest> = {
  encode(message: OpenBinRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      OpenBinRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OpenBinRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOpenBinRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = OpenBinRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OpenBinRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? OpenBinRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: OpenBinRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = OpenBinRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OpenBinRequest>, I>>(base?: I): OpenBinRequest {
    return OpenBinRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OpenBinRequest>, I>>(object: I): OpenBinRequest {
    const message = createBaseOpenBinRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? OpenBinRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseOpenBinRequestBody(): OpenBinRequestBody {
  return { binPath: "", locked: false };
}

export const OpenBinRequestBody: MessageFns<OpenBinRequestBody> = {
  encode(message: OpenBinRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.binPath !== "") {
      writer.uint32(10).string(message.binPath);
    }
    if (message.locked !== false) {
      writer.uint32(16).bool(message.locked);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OpenBinRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOpenBinRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.binPath = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.locked = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OpenBinRequestBody {
    return {
      binPath: isSet(object.binPath) ? globalThis.String(object.binPath) : "",
      locked: isSet(object.locked) ? globalThis.Boolean(object.locked) : false,
    };
  },

  toJSON(message: OpenBinRequestBody): unknown {
    const obj: any = {};
    if (message.binPath !== "") {
      obj.binPath = message.binPath;
    }
    if (message.locked !== false) {
      obj.locked = message.locked;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OpenBinRequestBody>, I>>(base?: I): OpenBinRequestBody {
    return OpenBinRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OpenBinRequestBody>, I>>(object: I): OpenBinRequestBody {
    const message = createBaseOpenBinRequestBody();
    message.binPath = object.binPath ?? "";
    message.locked = object.locked ?? false;
    return message;
  },
};

function createBaseOpenBinResponse(): OpenBinResponse {
  return { header: undefined, body: undefined };
}

export const OpenBinResponse: MessageFns<OpenBinResponse> = {
  encode(message: OpenBinResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      OpenBinResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OpenBinResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOpenBinResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = OpenBinResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OpenBinResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? OpenBinResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: OpenBinResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = OpenBinResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OpenBinResponse>, I>>(base?: I): OpenBinResponse {
    return OpenBinResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OpenBinResponse>, I>>(object: I): OpenBinResponse {
    const message = createBaseOpenBinResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? OpenBinResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseOpenBinResponseBody(): OpenBinResponseBody {
  return { isLockedByOther: false, lockOwner: "" };
}

export const OpenBinResponseBody: MessageFns<OpenBinResponseBody> = {
  encode(message: OpenBinResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.isLockedByOther !== false) {
      writer.uint32(8).bool(message.isLockedByOther);
    }
    if (message.lockOwner !== "") {
      writer.uint32(18).string(message.lockOwner);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OpenBinResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOpenBinResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.isLockedByOther = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.lockOwner = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OpenBinResponseBody {
    return {
      isLockedByOther: isSet(object.isLockedByOther) ? globalThis.Boolean(object.isLockedByOther) : false,
      lockOwner: isSet(object.lockOwner) ? globalThis.String(object.lockOwner) : "",
    };
  },

  toJSON(message: OpenBinResponseBody): unknown {
    const obj: any = {};
    if (message.isLockedByOther !== false) {
      obj.isLockedByOther = message.isLockedByOther;
    }
    if (message.lockOwner !== "") {
      obj.lockOwner = message.lockOwner;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OpenBinResponseBody>, I>>(base?: I): OpenBinResponseBody {
    return OpenBinResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OpenBinResponseBody>, I>>(object: I): OpenBinResponseBody {
    const message = createBaseOpenBinResponseBody();
    message.isLockedByOther = object.isLockedByOther ?? false;
    message.lockOwner = object.lockOwner ?? "";
    return message;
  },
};

function createBaseCreateBinRequest(): CreateBinRequest {
  return { header: undefined, body: undefined };
}

export const CreateBinRequest: MessageFns<CreateBinRequest> = {
  encode(message: CreateBinRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      CreateBinRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateBinRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateBinRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = CreateBinRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateBinRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? CreateBinRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: CreateBinRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = CreateBinRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateBinRequest>, I>>(base?: I): CreateBinRequest {
    return CreateBinRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateBinRequest>, I>>(object: I): CreateBinRequest {
    const message = createBaseCreateBinRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? CreateBinRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseCreateBinRequestBody(): CreateBinRequestBody {
  return { folderPath: "", binName: "", option: 0 };
}

export const CreateBinRequestBody: MessageFns<CreateBinRequestBody> = {
  encode(message: CreateBinRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.folderPath !== "") {
      writer.uint32(10).string(message.folderPath);
    }
    if (message.binName !== "") {
      writer.uint32(18).string(message.binName);
    }
    if (message.option !== 0) {
      writer.uint32(24).int32(message.option);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateBinRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateBinRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.folderPath = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.binName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.option = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateBinRequestBody {
    return {
      folderPath: isSet(object.folderPath) ? globalThis.String(object.folderPath) : "",
      binName: isSet(object.binName) ? globalThis.String(object.binName) : "",
      option: isSet(object.option) ? createBinRequestBody_OpenBinOptionFromJSON(object.option) : 0,
    };
  },

  toJSON(message: CreateBinRequestBody): unknown {
    const obj: any = {};
    if (message.folderPath !== "") {
      obj.folderPath = message.folderPath;
    }
    if (message.binName !== "") {
      obj.binName = message.binName;
    }
    if (message.option !== 0) {
      obj.option = createBinRequestBody_OpenBinOptionToJSON(message.option);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateBinRequestBody>, I>>(base?: I): CreateBinRequestBody {
    return CreateBinRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateBinRequestBody>, I>>(object: I): CreateBinRequestBody {
    const message = createBaseCreateBinRequestBody();
    message.folderPath = object.folderPath ?? "";
    message.binName = object.binName ?? "";
    message.option = object.option ?? 0;
    return message;
  },
};

function createBaseCreateBinResponse(): CreateBinResponse {
  return { header: undefined, body: undefined };
}

export const CreateBinResponse: MessageFns<CreateBinResponse> = {
  encode(message: CreateBinResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      CreateBinResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateBinResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateBinResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = CreateBinResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateBinResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? CreateBinResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: CreateBinResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = CreateBinResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateBinResponse>, I>>(base?: I): CreateBinResponse {
    return CreateBinResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateBinResponse>, I>>(object: I): CreateBinResponse {
    const message = createBaseCreateBinResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? CreateBinResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseCreateBinResponseBody(): CreateBinResponseBody {
  return {};
}

export const CreateBinResponseBody: MessageFns<CreateBinResponseBody> = {
  encode(_: CreateBinResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateBinResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateBinResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): CreateBinResponseBody {
    return {};
  },

  toJSON(_: CreateBinResponseBody): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateBinResponseBody>, I>>(base?: I): CreateBinResponseBody {
    return CreateBinResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateBinResponseBody>, I>>(_: I): CreateBinResponseBody {
    const message = createBaseCreateBinResponseBody();
    return message;
  },
};

function createBaseConfigureSRTStreamRequest(): ConfigureSRTStreamRequest {
  return { header: undefined, body: undefined };
}

export const ConfigureSRTStreamRequest: MessageFns<ConfigureSRTStreamRequest> = {
  encode(message: ConfigureSRTStreamRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      ConfigureSRTStreamRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfigureSRTStreamRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConfigureSRTStreamRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = ConfigureSRTStreamRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConfigureSRTStreamRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? ConfigureSRTStreamRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: ConfigureSRTStreamRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = ConfigureSRTStreamRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ConfigureSRTStreamRequest>, I>>(base?: I): ConfigureSRTStreamRequest {
    return ConfigureSRTStreamRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConfigureSRTStreamRequest>, I>>(object: I): ConfigureSRTStreamRequest {
    const message = createBaseConfigureSRTStreamRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? ConfigureSRTStreamRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseConfigureSRTStreamRequestBody(): ConfigureSRTStreamRequestBody {
  return { streamName: "", ipAddress: "", port: 0, password: "", latency: 0, qualityOption: 0, modeOption: 0 };
}

export const ConfigureSRTStreamRequestBody: MessageFns<ConfigureSRTStreamRequestBody> = {
  encode(message: ConfigureSRTStreamRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.streamName !== "") {
      writer.uint32(10).string(message.streamName);
    }
    if (message.ipAddress !== "") {
      writer.uint32(18).string(message.ipAddress);
    }
    if (message.port !== 0) {
      writer.uint32(24).int32(message.port);
    }
    if (message.password !== "") {
      writer.uint32(34).string(message.password);
    }
    if (message.latency !== 0) {
      writer.uint32(40).int32(message.latency);
    }
    if (message.qualityOption !== 0) {
      writer.uint32(48).int32(message.qualityOption);
    }
    if (message.modeOption !== 0) {
      writer.uint32(56).int32(message.modeOption);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfigureSRTStreamRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConfigureSRTStreamRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.streamName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ipAddress = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.port = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.password = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.latency = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.qualityOption = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.modeOption = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConfigureSRTStreamRequestBody {
    return {
      streamName: isSet(object.streamName) ? globalThis.String(object.streamName) : "",
      ipAddress: isSet(object.ipAddress) ? globalThis.String(object.ipAddress) : "",
      port: isSet(object.port) ? globalThis.Number(object.port) : 0,
      password: isSet(object.password) ? globalThis.String(object.password) : "",
      latency: isSet(object.latency) ? globalThis.Number(object.latency) : 0,
      qualityOption: isSet(object.qualityOption)
        ? configureSRTStreamRequestBody_QualityOptionFromJSON(object.qualityOption)
        : 0,
      modeOption: isSet(object.modeOption) ? configureSRTStreamRequestBody_ModeOptionFromJSON(object.modeOption) : 0,
    };
  },

  toJSON(message: ConfigureSRTStreamRequestBody): unknown {
    const obj: any = {};
    if (message.streamName !== "") {
      obj.streamName = message.streamName;
    }
    if (message.ipAddress !== "") {
      obj.ipAddress = message.ipAddress;
    }
    if (message.port !== 0) {
      obj.port = Math.round(message.port);
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    if (message.latency !== 0) {
      obj.latency = Math.round(message.latency);
    }
    if (message.qualityOption !== 0) {
      obj.qualityOption = configureSRTStreamRequestBody_QualityOptionToJSON(message.qualityOption);
    }
    if (message.modeOption !== 0) {
      obj.modeOption = configureSRTStreamRequestBody_ModeOptionToJSON(message.modeOption);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ConfigureSRTStreamRequestBody>, I>>(base?: I): ConfigureSRTStreamRequestBody {
    return ConfigureSRTStreamRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConfigureSRTStreamRequestBody>, I>>(
    object: I,
  ): ConfigureSRTStreamRequestBody {
    const message = createBaseConfigureSRTStreamRequestBody();
    message.streamName = object.streamName ?? "";
    message.ipAddress = object.ipAddress ?? "";
    message.port = object.port ?? 0;
    message.password = object.password ?? "";
    message.latency = object.latency ?? 0;
    message.qualityOption = object.qualityOption ?? 0;
    message.modeOption = object.modeOption ?? 0;
    return message;
  },
};

function createBaseConfigureSRTStreamResponse(): ConfigureSRTStreamResponse {
  return { header: undefined, body: undefined };
}

export const ConfigureSRTStreamResponse: MessageFns<ConfigureSRTStreamResponse> = {
  encode(message: ConfigureSRTStreamResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      ConfigureSRTStreamResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfigureSRTStreamResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConfigureSRTStreamResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = ConfigureSRTStreamResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConfigureSRTStreamResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? ConfigureSRTStreamResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: ConfigureSRTStreamResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = ConfigureSRTStreamResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ConfigureSRTStreamResponse>, I>>(base?: I): ConfigureSRTStreamResponse {
    return ConfigureSRTStreamResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConfigureSRTStreamResponse>, I>>(object: I): ConfigureSRTStreamResponse {
    const message = createBaseConfigureSRTStreamResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? ConfigureSRTStreamResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseConfigureSRTStreamResponseBody(): ConfigureSRTStreamResponseBody {
  return {};
}

export const ConfigureSRTStreamResponseBody: MessageFns<ConfigureSRTStreamResponseBody> = {
  encode(_: ConfigureSRTStreamResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfigureSRTStreamResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConfigureSRTStreamResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ConfigureSRTStreamResponseBody {
    return {};
  },

  toJSON(_: ConfigureSRTStreamResponseBody): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ConfigureSRTStreamResponseBody>, I>>(base?: I): ConfigureSRTStreamResponseBody {
    return ConfigureSRTStreamResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConfigureSRTStreamResponseBody>, I>>(_: I): ConfigureSRTStreamResponseBody {
    const message = createBaseConfigureSRTStreamResponseBody();
    return message;
  },
};

function createBaseGetSRTStreamSettingsRequest(): GetSRTStreamSettingsRequest {
  return { header: undefined, body: undefined };
}

export const GetSRTStreamSettingsRequest: MessageFns<GetSRTStreamSettingsRequest> = {
  encode(message: GetSRTStreamSettingsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetSRTStreamSettingsRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSRTStreamSettingsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSRTStreamSettingsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetSRTStreamSettingsRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSRTStreamSettingsRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetSRTStreamSettingsRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetSRTStreamSettingsRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetSRTStreamSettingsRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSRTStreamSettingsRequest>, I>>(base?: I): GetSRTStreamSettingsRequest {
    return GetSRTStreamSettingsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSRTStreamSettingsRequest>, I>>(object: I): GetSRTStreamSettingsRequest {
    const message = createBaseGetSRTStreamSettingsRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetSRTStreamSettingsRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetSRTStreamSettingsRequestBody(): GetSRTStreamSettingsRequestBody {
  return {};
}

export const GetSRTStreamSettingsRequestBody: MessageFns<GetSRTStreamSettingsRequestBody> = {
  encode(_: GetSRTStreamSettingsRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSRTStreamSettingsRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSRTStreamSettingsRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetSRTStreamSettingsRequestBody {
    return {};
  },

  toJSON(_: GetSRTStreamSettingsRequestBody): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSRTStreamSettingsRequestBody>, I>>(base?: I): GetSRTStreamSettingsRequestBody {
    return GetSRTStreamSettingsRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSRTStreamSettingsRequestBody>, I>>(_: I): GetSRTStreamSettingsRequestBody {
    const message = createBaseGetSRTStreamSettingsRequestBody();
    return message;
  },
};

function createBaseGetSRTStreamSettingsResponse(): GetSRTStreamSettingsResponse {
  return { header: undefined, body: undefined };
}

export const GetSRTStreamSettingsResponse: MessageFns<GetSRTStreamSettingsResponse> = {
  encode(message: GetSRTStreamSettingsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetSRTStreamSettingsResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSRTStreamSettingsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSRTStreamSettingsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetSRTStreamSettingsResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSRTStreamSettingsResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetSRTStreamSettingsResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetSRTStreamSettingsResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetSRTStreamSettingsResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSRTStreamSettingsResponse>, I>>(base?: I): GetSRTStreamSettingsResponse {
    return GetSRTStreamSettingsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSRTStreamSettingsResponse>, I>>(object: I): GetSRTStreamSettingsResponse {
    const message = createBaseGetSRTStreamSettingsResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetSRTStreamSettingsResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetSRTStreamSettingsResponseBody(): GetSRTStreamSettingsResponseBody {
  return { streamName: "", ipAddress: "", port: 0, password: "", latency: 0, qualityOption: 0, modeOption: 0 };
}

export const GetSRTStreamSettingsResponseBody: MessageFns<GetSRTStreamSettingsResponseBody> = {
  encode(message: GetSRTStreamSettingsResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.streamName !== "") {
      writer.uint32(10).string(message.streamName);
    }
    if (message.ipAddress !== "") {
      writer.uint32(18).string(message.ipAddress);
    }
    if (message.port !== 0) {
      writer.uint32(24).int32(message.port);
    }
    if (message.password !== "") {
      writer.uint32(34).string(message.password);
    }
    if (message.latency !== 0) {
      writer.uint32(40).int32(message.latency);
    }
    if (message.qualityOption !== 0) {
      writer.uint32(48).int32(message.qualityOption);
    }
    if (message.modeOption !== 0) {
      writer.uint32(56).int32(message.modeOption);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSRTStreamSettingsResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSRTStreamSettingsResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.streamName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ipAddress = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.port = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.password = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.latency = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.qualityOption = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.modeOption = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSRTStreamSettingsResponseBody {
    return {
      streamName: isSet(object.streamName) ? globalThis.String(object.streamName) : "",
      ipAddress: isSet(object.ipAddress) ? globalThis.String(object.ipAddress) : "",
      port: isSet(object.port) ? globalThis.Number(object.port) : 0,
      password: isSet(object.password) ? globalThis.String(object.password) : "",
      latency: isSet(object.latency) ? globalThis.Number(object.latency) : 0,
      qualityOption: isSet(object.qualityOption)
        ? getSRTStreamSettingsResponseBody_QualityOptionFromJSON(object.qualityOption)
        : 0,
      modeOption: isSet(object.modeOption) ? getSRTStreamSettingsResponseBody_ModeOptionFromJSON(object.modeOption) : 0,
    };
  },

  toJSON(message: GetSRTStreamSettingsResponseBody): unknown {
    const obj: any = {};
    if (message.streamName !== "") {
      obj.streamName = message.streamName;
    }
    if (message.ipAddress !== "") {
      obj.ipAddress = message.ipAddress;
    }
    if (message.port !== 0) {
      obj.port = Math.round(message.port);
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    if (message.latency !== 0) {
      obj.latency = Math.round(message.latency);
    }
    if (message.qualityOption !== 0) {
      obj.qualityOption = getSRTStreamSettingsResponseBody_QualityOptionToJSON(message.qualityOption);
    }
    if (message.modeOption !== 0) {
      obj.modeOption = getSRTStreamSettingsResponseBody_ModeOptionToJSON(message.modeOption);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSRTStreamSettingsResponseBody>, I>>(
    base?: I,
  ): GetSRTStreamSettingsResponseBody {
    return GetSRTStreamSettingsResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSRTStreamSettingsResponseBody>, I>>(
    object: I,
  ): GetSRTStreamSettingsResponseBody {
    const message = createBaseGetSRTStreamSettingsResponseBody();
    message.streamName = object.streamName ?? "";
    message.ipAddress = object.ipAddress ?? "";
    message.port = object.port ?? 0;
    message.password = object.password ?? "";
    message.latency = object.latency ?? 0;
    message.qualityOption = object.qualityOption ?? 0;
    message.modeOption = object.modeOption ?? 0;
    return message;
  },
};

function createBaseGetOTSSessionStatusRequest(): GetOTSSessionStatusRequest {
  return { header: undefined, body: undefined };
}

export const GetOTSSessionStatusRequest: MessageFns<GetOTSSessionStatusRequest> = {
  encode(message: GetOTSSessionStatusRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetOTSSessionStatusRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOTSSessionStatusRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOTSSessionStatusRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetOTSSessionStatusRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOTSSessionStatusRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetOTSSessionStatusRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetOTSSessionStatusRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetOTSSessionStatusRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOTSSessionStatusRequest>, I>>(base?: I): GetOTSSessionStatusRequest {
    return GetOTSSessionStatusRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOTSSessionStatusRequest>, I>>(object: I): GetOTSSessionStatusRequest {
    const message = createBaseGetOTSSessionStatusRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetOTSSessionStatusRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetOTSSessionStatusRequestBody(): GetOTSSessionStatusRequestBody {
  return {};
}

export const GetOTSSessionStatusRequestBody: MessageFns<GetOTSSessionStatusRequestBody> = {
  encode(_: GetOTSSessionStatusRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOTSSessionStatusRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOTSSessionStatusRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetOTSSessionStatusRequestBody {
    return {};
  },

  toJSON(_: GetOTSSessionStatusRequestBody): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOTSSessionStatusRequestBody>, I>>(base?: I): GetOTSSessionStatusRequestBody {
    return GetOTSSessionStatusRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOTSSessionStatusRequestBody>, I>>(_: I): GetOTSSessionStatusRequestBody {
    const message = createBaseGetOTSSessionStatusRequestBody();
    return message;
  },
};

function createBaseGetOTSSessionStatusResponse(): GetOTSSessionStatusResponse {
  return { header: undefined, body: undefined };
}

export const GetOTSSessionStatusResponse: MessageFns<GetOTSSessionStatusResponse> = {
  encode(message: GetOTSSessionStatusResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetOTSSessionStatusResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOTSSessionStatusResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOTSSessionStatusResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetOTSSessionStatusResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOTSSessionStatusResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetOTSSessionStatusResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetOTSSessionStatusResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetOTSSessionStatusResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOTSSessionStatusResponse>, I>>(base?: I): GetOTSSessionStatusResponse {
    return GetOTSSessionStatusResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOTSSessionStatusResponse>, I>>(object: I): GetOTSSessionStatusResponse {
    const message = createBaseGetOTSSessionStatusResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetOTSSessionStatusResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetOTSSessionStatusResponseBody(): GetOTSSessionStatusResponseBody {
  return {
    status: "",
    sessionId: "",
    creationDate: "",
    tenantId: "",
    streamName: "",
    ipAddress: "",
    port: 0,
    password: "",
    latency: 0,
    qualityOption: 0,
    modeOption: 0,
  };
}

export const GetOTSSessionStatusResponseBody: MessageFns<GetOTSSessionStatusResponseBody> = {
  encode(message: GetOTSSessionStatusResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== "") {
      writer.uint32(10).string(message.status);
    }
    if (message.sessionId !== "") {
      writer.uint32(18).string(message.sessionId);
    }
    if (message.creationDate !== "") {
      writer.uint32(26).string(message.creationDate);
    }
    if (message.tenantId !== "") {
      writer.uint32(34).string(message.tenantId);
    }
    if (message.streamName !== "") {
      writer.uint32(42).string(message.streamName);
    }
    if (message.ipAddress !== "") {
      writer.uint32(50).string(message.ipAddress);
    }
    if (message.port !== 0) {
      writer.uint32(56).int32(message.port);
    }
    if (message.password !== "") {
      writer.uint32(66).string(message.password);
    }
    if (message.latency !== 0) {
      writer.uint32(72).int32(message.latency);
    }
    if (message.qualityOption !== 0) {
      writer.uint32(80).int32(message.qualityOption);
    }
    if (message.modeOption !== 0) {
      writer.uint32(88).int32(message.modeOption);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOTSSessionStatusResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOTSSessionStatusResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.status = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.sessionId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.creationDate = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.tenantId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.streamName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ipAddress = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.port = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.password = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.latency = reader.int32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.qualityOption = reader.int32() as any;
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.modeOption = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOTSSessionStatusResponseBody {
    return {
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      sessionId: isSet(object.sessionId) ? globalThis.String(object.sessionId) : "",
      creationDate: isSet(object.creationDate) ? globalThis.String(object.creationDate) : "",
      tenantId: isSet(object.tenantId) ? globalThis.String(object.tenantId) : "",
      streamName: isSet(object.streamName) ? globalThis.String(object.streamName) : "",
      ipAddress: isSet(object.ipAddress) ? globalThis.String(object.ipAddress) : "",
      port: isSet(object.port) ? globalThis.Number(object.port) : 0,
      password: isSet(object.password) ? globalThis.String(object.password) : "",
      latency: isSet(object.latency) ? globalThis.Number(object.latency) : 0,
      qualityOption: isSet(object.qualityOption)
        ? getOTSSessionStatusResponseBody_QualityOptionFromJSON(object.qualityOption)
        : 0,
      modeOption: isSet(object.modeOption) ? getOTSSessionStatusResponseBody_ModeOptionFromJSON(object.modeOption) : 0,
    };
  },

  toJSON(message: GetOTSSessionStatusResponseBody): unknown {
    const obj: any = {};
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.sessionId !== "") {
      obj.sessionId = message.sessionId;
    }
    if (message.creationDate !== "") {
      obj.creationDate = message.creationDate;
    }
    if (message.tenantId !== "") {
      obj.tenantId = message.tenantId;
    }
    if (message.streamName !== "") {
      obj.streamName = message.streamName;
    }
    if (message.ipAddress !== "") {
      obj.ipAddress = message.ipAddress;
    }
    if (message.port !== 0) {
      obj.port = Math.round(message.port);
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    if (message.latency !== 0) {
      obj.latency = Math.round(message.latency);
    }
    if (message.qualityOption !== 0) {
      obj.qualityOption = getOTSSessionStatusResponseBody_QualityOptionToJSON(message.qualityOption);
    }
    if (message.modeOption !== 0) {
      obj.modeOption = getOTSSessionStatusResponseBody_ModeOptionToJSON(message.modeOption);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOTSSessionStatusResponseBody>, I>>(base?: I): GetOTSSessionStatusResponseBody {
    return GetOTSSessionStatusResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOTSSessionStatusResponseBody>, I>>(
    object: I,
  ): GetOTSSessionStatusResponseBody {
    const message = createBaseGetOTSSessionStatusResponseBody();
    message.status = object.status ?? "";
    message.sessionId = object.sessionId ?? "";
    message.creationDate = object.creationDate ?? "";
    message.tenantId = object.tenantId ?? "";
    message.streamName = object.streamName ?? "";
    message.ipAddress = object.ipAddress ?? "";
    message.port = object.port ?? 0;
    message.password = object.password ?? "";
    message.latency = object.latency ?? 0;
    message.qualityOption = object.qualityOption ?? 0;
    message.modeOption = object.modeOption ?? 0;
    return message;
  },
};

function createBaseSetOTSSessionStatusRequest(): SetOTSSessionStatusRequest {
  return { header: undefined, body: undefined };
}

export const SetOTSSessionStatusRequest: MessageFns<SetOTSSessionStatusRequest> = {
  encode(message: SetOTSSessionStatusRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      SetOTSSessionStatusRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetOTSSessionStatusRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetOTSSessionStatusRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = SetOTSSessionStatusRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetOTSSessionStatusRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? SetOTSSessionStatusRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: SetOTSSessionStatusRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = SetOTSSessionStatusRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetOTSSessionStatusRequest>, I>>(base?: I): SetOTSSessionStatusRequest {
    return SetOTSSessionStatusRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetOTSSessionStatusRequest>, I>>(object: I): SetOTSSessionStatusRequest {
    const message = createBaseSetOTSSessionStatusRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? SetOTSSessionStatusRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseSetOTSSessionStatusRequestBody(): SetOTSSessionStatusRequestBody {
  return {
    status: "",
    sessionId: "",
    tenantId: "",
    streamName: "",
    ipAddress: "",
    port: 0,
    password: "",
    latency: 0,
    qualityOption: 0,
    modeOption: 0,
  };
}

export const SetOTSSessionStatusRequestBody: MessageFns<SetOTSSessionStatusRequestBody> = {
  encode(message: SetOTSSessionStatusRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== "") {
      writer.uint32(10).string(message.status);
    }
    if (message.sessionId !== "") {
      writer.uint32(18).string(message.sessionId);
    }
    if (message.tenantId !== "") {
      writer.uint32(26).string(message.tenantId);
    }
    if (message.streamName !== "") {
      writer.uint32(34).string(message.streamName);
    }
    if (message.ipAddress !== "") {
      writer.uint32(42).string(message.ipAddress);
    }
    if (message.port !== 0) {
      writer.uint32(48).int32(message.port);
    }
    if (message.password !== "") {
      writer.uint32(58).string(message.password);
    }
    if (message.latency !== 0) {
      writer.uint32(64).int32(message.latency);
    }
    if (message.qualityOption !== 0) {
      writer.uint32(72).int32(message.qualityOption);
    }
    if (message.modeOption !== 0) {
      writer.uint32(80).int32(message.modeOption);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetOTSSessionStatusRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetOTSSessionStatusRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.status = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.sessionId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tenantId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.streamName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.ipAddress = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.port = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.password = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.latency = reader.int32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.qualityOption = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.modeOption = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetOTSSessionStatusRequestBody {
    return {
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      sessionId: isSet(object.sessionId) ? globalThis.String(object.sessionId) : "",
      tenantId: isSet(object.tenantId) ? globalThis.String(object.tenantId) : "",
      streamName: isSet(object.streamName) ? globalThis.String(object.streamName) : "",
      ipAddress: isSet(object.ipAddress) ? globalThis.String(object.ipAddress) : "",
      port: isSet(object.port) ? globalThis.Number(object.port) : 0,
      password: isSet(object.password) ? globalThis.String(object.password) : "",
      latency: isSet(object.latency) ? globalThis.Number(object.latency) : 0,
      qualityOption: isSet(object.qualityOption)
        ? setOTSSessionStatusRequestBody_QualityOptionFromJSON(object.qualityOption)
        : 0,
      modeOption: isSet(object.modeOption) ? setOTSSessionStatusRequestBody_ModeOptionFromJSON(object.modeOption) : 0,
    };
  },

  toJSON(message: SetOTSSessionStatusRequestBody): unknown {
    const obj: any = {};
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.sessionId !== "") {
      obj.sessionId = message.sessionId;
    }
    if (message.tenantId !== "") {
      obj.tenantId = message.tenantId;
    }
    if (message.streamName !== "") {
      obj.streamName = message.streamName;
    }
    if (message.ipAddress !== "") {
      obj.ipAddress = message.ipAddress;
    }
    if (message.port !== 0) {
      obj.port = Math.round(message.port);
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    if (message.latency !== 0) {
      obj.latency = Math.round(message.latency);
    }
    if (message.qualityOption !== 0) {
      obj.qualityOption = setOTSSessionStatusRequestBody_QualityOptionToJSON(message.qualityOption);
    }
    if (message.modeOption !== 0) {
      obj.modeOption = setOTSSessionStatusRequestBody_ModeOptionToJSON(message.modeOption);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetOTSSessionStatusRequestBody>, I>>(base?: I): SetOTSSessionStatusRequestBody {
    return SetOTSSessionStatusRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetOTSSessionStatusRequestBody>, I>>(
    object: I,
  ): SetOTSSessionStatusRequestBody {
    const message = createBaseSetOTSSessionStatusRequestBody();
    message.status = object.status ?? "";
    message.sessionId = object.sessionId ?? "";
    message.tenantId = object.tenantId ?? "";
    message.streamName = object.streamName ?? "";
    message.ipAddress = object.ipAddress ?? "";
    message.port = object.port ?? 0;
    message.password = object.password ?? "";
    message.latency = object.latency ?? 0;
    message.qualityOption = object.qualityOption ?? 0;
    message.modeOption = object.modeOption ?? 0;
    return message;
  },
};

function createBaseSetOTSSessionStatusResponse(): SetOTSSessionStatusResponse {
  return { header: undefined, body: undefined };
}

export const SetOTSSessionStatusResponse: MessageFns<SetOTSSessionStatusResponse> = {
  encode(message: SetOTSSessionStatusResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      SetOTSSessionStatusResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetOTSSessionStatusResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetOTSSessionStatusResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = SetOTSSessionStatusResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetOTSSessionStatusResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? SetOTSSessionStatusResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: SetOTSSessionStatusResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = SetOTSSessionStatusResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetOTSSessionStatusResponse>, I>>(base?: I): SetOTSSessionStatusResponse {
    return SetOTSSessionStatusResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetOTSSessionStatusResponse>, I>>(object: I): SetOTSSessionStatusResponse {
    const message = createBaseSetOTSSessionStatusResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? SetOTSSessionStatusResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseSetOTSSessionStatusResponseBody(): SetOTSSessionStatusResponseBody {
  return {};
}

export const SetOTSSessionStatusResponseBody: MessageFns<SetOTSSessionStatusResponseBody> = {
  encode(_: SetOTSSessionStatusResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetOTSSessionStatusResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetOTSSessionStatusResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetOTSSessionStatusResponseBody {
    return {};
  },

  toJSON(_: SetOTSSessionStatusResponseBody): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetOTSSessionStatusResponseBody>, I>>(base?: I): SetOTSSessionStatusResponseBody {
    return SetOTSSessionStatusResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetOTSSessionStatusResponseBody>, I>>(_: I): SetOTSSessionStatusResponseBody {
    const message = createBaseSetOTSSessionStatusResponseBody();
    return message;
  },
};

function createBaseGetMediaVolumeListRequest(): GetMediaVolumeListRequest {
  return { header: undefined, body: undefined };
}

export const GetMediaVolumeListRequest: MessageFns<GetMediaVolumeListRequest> = {
  encode(message: GetMediaVolumeListRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetMediaVolumeListRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMediaVolumeListRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMediaVolumeListRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetMediaVolumeListRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMediaVolumeListRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetMediaVolumeListRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetMediaVolumeListRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetMediaVolumeListRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMediaVolumeListRequest>, I>>(base?: I): GetMediaVolumeListRequest {
    return GetMediaVolumeListRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMediaVolumeListRequest>, I>>(object: I): GetMediaVolumeListRequest {
    const message = createBaseGetMediaVolumeListRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetMediaVolumeListRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetMediaVolumeListRequestBody(): GetMediaVolumeListRequestBody {
  return {};
}

export const GetMediaVolumeListRequestBody: MessageFns<GetMediaVolumeListRequestBody> = {
  encode(_: GetMediaVolumeListRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMediaVolumeListRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMediaVolumeListRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetMediaVolumeListRequestBody {
    return {};
  },

  toJSON(_: GetMediaVolumeListRequestBody): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMediaVolumeListRequestBody>, I>>(base?: I): GetMediaVolumeListRequestBody {
    return GetMediaVolumeListRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMediaVolumeListRequestBody>, I>>(_: I): GetMediaVolumeListRequestBody {
    const message = createBaseGetMediaVolumeListRequestBody();
    return message;
  },
};

function createBaseGetMediaVolumeListResponse(): GetMediaVolumeListResponse {
  return { header: undefined, body: undefined };
}

export const GetMediaVolumeListResponse: MessageFns<GetMediaVolumeListResponse> = {
  encode(message: GetMediaVolumeListResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetMediaVolumeListResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMediaVolumeListResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMediaVolumeListResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetMediaVolumeListResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMediaVolumeListResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetMediaVolumeListResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetMediaVolumeListResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetMediaVolumeListResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMediaVolumeListResponse>, I>>(base?: I): GetMediaVolumeListResponse {
    return GetMediaVolumeListResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMediaVolumeListResponse>, I>>(object: I): GetMediaVolumeListResponse {
    const message = createBaseGetMediaVolumeListResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetMediaVolumeListResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetMediaVolumeListResponseBody(): GetMediaVolumeListResponseBody {
  return { volumes: [] };
}

export const GetMediaVolumeListResponseBody: MessageFns<GetMediaVolumeListResponseBody> = {
  encode(message: GetMediaVolumeListResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.volumes) {
      GetMediaVolumeListResponseBody_MediaVolume.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMediaVolumeListResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMediaVolumeListResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.volumes.push(GetMediaVolumeListResponseBody_MediaVolume.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMediaVolumeListResponseBody {
    return {
      volumes: globalThis.Array.isArray(object?.volumes)
        ? object.volumes.map((e: any) => GetMediaVolumeListResponseBody_MediaVolume.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetMediaVolumeListResponseBody): unknown {
    const obj: any = {};
    if (message.volumes?.length) {
      obj.volumes = message.volumes.map((e) => GetMediaVolumeListResponseBody_MediaVolume.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMediaVolumeListResponseBody>, I>>(base?: I): GetMediaVolumeListResponseBody {
    return GetMediaVolumeListResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMediaVolumeListResponseBody>, I>>(
    object: I,
  ): GetMediaVolumeListResponseBody {
    const message = createBaseGetMediaVolumeListResponseBody();
    message.volumes = object.volumes?.map((e) => GetMediaVolumeListResponseBody_MediaVolume.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetMediaVolumeListResponseBody_MediaVolume(): GetMediaVolumeListResponseBody_MediaVolume {
  return { name: "", isShared: false, freeSpace: 0 };
}

export const GetMediaVolumeListResponseBody_MediaVolume: MessageFns<GetMediaVolumeListResponseBody_MediaVolume> = {
  encode(message: GetMediaVolumeListResponseBody_MediaVolume, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.isShared !== false) {
      writer.uint32(16).bool(message.isShared);
    }
    if (message.freeSpace !== 0) {
      writer.uint32(24).uint64(message.freeSpace);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMediaVolumeListResponseBody_MediaVolume {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMediaVolumeListResponseBody_MediaVolume();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.isShared = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.freeSpace = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMediaVolumeListResponseBody_MediaVolume {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      isShared: isSet(object.isShared) ? globalThis.Boolean(object.isShared) : false,
      freeSpace: isSet(object.freeSpace) ? globalThis.Number(object.freeSpace) : 0,
    };
  },

  toJSON(message: GetMediaVolumeListResponseBody_MediaVolume): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.isShared !== false) {
      obj.isShared = message.isShared;
    }
    if (message.freeSpace !== 0) {
      obj.freeSpace = Math.round(message.freeSpace);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMediaVolumeListResponseBody_MediaVolume>, I>>(
    base?: I,
  ): GetMediaVolumeListResponseBody_MediaVolume {
    return GetMediaVolumeListResponseBody_MediaVolume.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMediaVolumeListResponseBody_MediaVolume>, I>>(
    object: I,
  ): GetMediaVolumeListResponseBody_MediaVolume {
    const message = createBaseGetMediaVolumeListResponseBody_MediaVolume();
    message.name = object.name ?? "";
    message.isShared = object.isShared ?? false;
    message.freeSpace = object.freeSpace ?? 0;
    return message;
  },
};

function createBaseGetMediaVolumeItemsRequestBody(): GetMediaVolumeItemsRequestBody {
  return { volumeName: "", relativePath: "", type: 0 };
}

export const GetMediaVolumeItemsRequestBody: MessageFns<GetMediaVolumeItemsRequestBody> = {
  encode(message: GetMediaVolumeItemsRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.volumeName !== "") {
      writer.uint32(10).string(message.volumeName);
    }
    if (message.relativePath !== "") {
      writer.uint32(18).string(message.relativePath);
    }
    if (message.type !== 0) {
      writer.uint32(24).int32(message.type);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMediaVolumeItemsRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMediaVolumeItemsRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.volumeName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.relativePath = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMediaVolumeItemsRequestBody {
    return {
      volumeName: isSet(object.volumeName) ? globalThis.String(object.volumeName) : "",
      relativePath: isSet(object.relativePath) ? globalThis.String(object.relativePath) : "",
      type: isSet(object.type) ? getMediaVolumeItemsRequestBody_VolumeItemFilterFromJSON(object.type) : 0,
    };
  },

  toJSON(message: GetMediaVolumeItemsRequestBody): unknown {
    const obj: any = {};
    if (message.volumeName !== "") {
      obj.volumeName = message.volumeName;
    }
    if (message.relativePath !== "") {
      obj.relativePath = message.relativePath;
    }
    if (message.type !== 0) {
      obj.type = getMediaVolumeItemsRequestBody_VolumeItemFilterToJSON(message.type);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMediaVolumeItemsRequestBody>, I>>(base?: I): GetMediaVolumeItemsRequestBody {
    return GetMediaVolumeItemsRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMediaVolumeItemsRequestBody>, I>>(
    object: I,
  ): GetMediaVolumeItemsRequestBody {
    const message = createBaseGetMediaVolumeItemsRequestBody();
    message.volumeName = object.volumeName ?? "";
    message.relativePath = object.relativePath ?? "";
    message.type = object.type ?? 0;
    return message;
  },
};

function createBaseGetMediaVolumeItemsRequest(): GetMediaVolumeItemsRequest {
  return { header: undefined, body: undefined };
}

export const GetMediaVolumeItemsRequest: MessageFns<GetMediaVolumeItemsRequest> = {
  encode(message: GetMediaVolumeItemsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetMediaVolumeItemsRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMediaVolumeItemsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMediaVolumeItemsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetMediaVolumeItemsRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMediaVolumeItemsRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetMediaVolumeItemsRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetMediaVolumeItemsRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetMediaVolumeItemsRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMediaVolumeItemsRequest>, I>>(base?: I): GetMediaVolumeItemsRequest {
    return GetMediaVolumeItemsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMediaVolumeItemsRequest>, I>>(object: I): GetMediaVolumeItemsRequest {
    const message = createBaseGetMediaVolumeItemsRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetMediaVolumeItemsRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetMediaVolumeItemsResponse(): GetMediaVolumeItemsResponse {
  return { header: undefined, body: undefined };
}

export const GetMediaVolumeItemsResponse: MessageFns<GetMediaVolumeItemsResponse> = {
  encode(message: GetMediaVolumeItemsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetMediaVolumeItemsResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMediaVolumeItemsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMediaVolumeItemsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetMediaVolumeItemsResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMediaVolumeItemsResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetMediaVolumeItemsResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetMediaVolumeItemsResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetMediaVolumeItemsResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMediaVolumeItemsResponse>, I>>(base?: I): GetMediaVolumeItemsResponse {
    return GetMediaVolumeItemsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMediaVolumeItemsResponse>, I>>(object: I): GetMediaVolumeItemsResponse {
    const message = createBaseGetMediaVolumeItemsResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetMediaVolumeItemsResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetMediaVolumeItemsResponseBody(): GetMediaVolumeItemsResponseBody {
  return { item: [] };
}

export const GetMediaVolumeItemsResponseBody: MessageFns<GetMediaVolumeItemsResponseBody> = {
  encode(message: GetMediaVolumeItemsResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.item) {
      GetMediaVolumeItemsResponseBody_MediaVolumeItem.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMediaVolumeItemsResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMediaVolumeItemsResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.item.push(GetMediaVolumeItemsResponseBody_MediaVolumeItem.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMediaVolumeItemsResponseBody {
    return {
      item: globalThis.Array.isArray(object?.item)
        ? object.item.map((e: any) => GetMediaVolumeItemsResponseBody_MediaVolumeItem.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetMediaVolumeItemsResponseBody): unknown {
    const obj: any = {};
    if (message.item?.length) {
      obj.item = message.item.map((e) => GetMediaVolumeItemsResponseBody_MediaVolumeItem.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMediaVolumeItemsResponseBody>, I>>(base?: I): GetMediaVolumeItemsResponseBody {
    return GetMediaVolumeItemsResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMediaVolumeItemsResponseBody>, I>>(
    object: I,
  ): GetMediaVolumeItemsResponseBody {
    const message = createBaseGetMediaVolumeItemsResponseBody();
    message.item = object.item?.map((e) => GetMediaVolumeItemsResponseBody_MediaVolumeItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetMediaVolumeItemsResponseBody_MediaVolumeItem(): GetMediaVolumeItemsResponseBody_MediaVolumeItem {
  return { relativeVolumePath: "", isDirectory: false };
}

export const GetMediaVolumeItemsResponseBody_MediaVolumeItem: MessageFns<
  GetMediaVolumeItemsResponseBody_MediaVolumeItem
> = {
  encode(
    message: GetMediaVolumeItemsResponseBody_MediaVolumeItem,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.relativeVolumePath !== "") {
      writer.uint32(10).string(message.relativeVolumePath);
    }
    if (message.isDirectory !== false) {
      writer.uint32(16).bool(message.isDirectory);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMediaVolumeItemsResponseBody_MediaVolumeItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMediaVolumeItemsResponseBody_MediaVolumeItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.relativeVolumePath = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.isDirectory = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMediaVolumeItemsResponseBody_MediaVolumeItem {
    return {
      relativeVolumePath: isSet(object.relativeVolumePath) ? globalThis.String(object.relativeVolumePath) : "",
      isDirectory: isSet(object.isDirectory) ? globalThis.Boolean(object.isDirectory) : false,
    };
  },

  toJSON(message: GetMediaVolumeItemsResponseBody_MediaVolumeItem): unknown {
    const obj: any = {};
    if (message.relativeVolumePath !== "") {
      obj.relativeVolumePath = message.relativeVolumePath;
    }
    if (message.isDirectory !== false) {
      obj.isDirectory = message.isDirectory;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMediaVolumeItemsResponseBody_MediaVolumeItem>, I>>(
    base?: I,
  ): GetMediaVolumeItemsResponseBody_MediaVolumeItem {
    return GetMediaVolumeItemsResponseBody_MediaVolumeItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMediaVolumeItemsResponseBody_MediaVolumeItem>, I>>(
    object: I,
  ): GetMediaVolumeItemsResponseBody_MediaVolumeItem {
    const message = createBaseGetMediaVolumeItemsResponseBody_MediaVolumeItem();
    message.relativeVolumePath = object.relativeVolumePath ?? "";
    message.isDirectory = object.isDirectory ?? false;
    return message;
  },
};

function createBaseGetOpenProjectInfoRequest(): GetOpenProjectInfoRequest {
  return { header: undefined, body: undefined };
}

export const GetOpenProjectInfoRequest: MessageFns<GetOpenProjectInfoRequest> = {
  encode(message: GetOpenProjectInfoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetOpenProjectInfoRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOpenProjectInfoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOpenProjectInfoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetOpenProjectInfoRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOpenProjectInfoRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetOpenProjectInfoRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetOpenProjectInfoRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetOpenProjectInfoRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOpenProjectInfoRequest>, I>>(base?: I): GetOpenProjectInfoRequest {
    return GetOpenProjectInfoRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOpenProjectInfoRequest>, I>>(object: I): GetOpenProjectInfoRequest {
    const message = createBaseGetOpenProjectInfoRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetOpenProjectInfoRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetOpenProjectInfoRequestBody(): GetOpenProjectInfoRequestBody {
  return {};
}

export const GetOpenProjectInfoRequestBody: MessageFns<GetOpenProjectInfoRequestBody> = {
  encode(_: GetOpenProjectInfoRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOpenProjectInfoRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOpenProjectInfoRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetOpenProjectInfoRequestBody {
    return {};
  },

  toJSON(_: GetOpenProjectInfoRequestBody): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOpenProjectInfoRequestBody>, I>>(base?: I): GetOpenProjectInfoRequestBody {
    return GetOpenProjectInfoRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOpenProjectInfoRequestBody>, I>>(_: I): GetOpenProjectInfoRequestBody {
    const message = createBaseGetOpenProjectInfoRequestBody();
    return message;
  },
};

function createBaseGetOpenProjectInfoResponse(): GetOpenProjectInfoResponse {
  return { header: undefined, body: undefined };
}

export const GetOpenProjectInfoResponse: MessageFns<GetOpenProjectInfoResponse> = {
  encode(message: GetOpenProjectInfoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetOpenProjectInfoResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOpenProjectInfoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOpenProjectInfoResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetOpenProjectInfoResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOpenProjectInfoResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetOpenProjectInfoResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetOpenProjectInfoResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetOpenProjectInfoResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOpenProjectInfoResponse>, I>>(base?: I): GetOpenProjectInfoResponse {
    return GetOpenProjectInfoResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOpenProjectInfoResponse>, I>>(object: I): GetOpenProjectInfoResponse {
    const message = createBaseGetOpenProjectInfoResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetOpenProjectInfoResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetOpenProjectInfoResponseBody(): GetOpenProjectInfoResponseBody {
  return {
    path: "",
    projectType: "",
    frameRate: undefined,
    colorSpace: "",
    rasterWidth: 0,
    rasterHeight: 0,
    stereoscopic: 0,
    dropFrame: false,
    creationDate: undefined,
    modifyDate: undefined,
    film: false,
    filmPerf: "",
  };
}

export const GetOpenProjectInfoResponseBody: MessageFns<GetOpenProjectInfoResponseBody> = {
  encode(message: GetOpenProjectInfoResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.path !== "") {
      writer.uint32(10).string(message.path);
    }
    if (message.projectType !== "") {
      writer.uint32(18).string(message.projectType);
    }
    if (message.frameRate !== undefined) {
      FrameRate.encode(message.frameRate, writer.uint32(26).fork()).join();
    }
    if (message.colorSpace !== "") {
      writer.uint32(34).string(message.colorSpace);
    }
    if (message.rasterWidth !== 0) {
      writer.uint32(40).int32(message.rasterWidth);
    }
    if (message.rasterHeight !== 0) {
      writer.uint32(48).int32(message.rasterHeight);
    }
    if (message.stereoscopic !== 0) {
      writer.uint32(56).int32(message.stereoscopic);
    }
    if (message.dropFrame !== false) {
      writer.uint32(64).bool(message.dropFrame);
    }
    if (message.creationDate !== undefined) {
      Timestamp.encode(message.creationDate, writer.uint32(74).fork()).join();
    }
    if (message.modifyDate !== undefined) {
      Timestamp.encode(message.modifyDate, writer.uint32(82).fork()).join();
    }
    if (message.film !== false) {
      writer.uint32(88).bool(message.film);
    }
    if (message.filmPerf !== "") {
      writer.uint32(98).string(message.filmPerf);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOpenProjectInfoResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOpenProjectInfoResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.path = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.projectType = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.frameRate = FrameRate.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.colorSpace = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.rasterWidth = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.rasterHeight = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.stereoscopic = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.dropFrame = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.creationDate = Timestamp.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.modifyDate = Timestamp.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.film = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.filmPerf = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOpenProjectInfoResponseBody {
    return {
      path: isSet(object.path) ? globalThis.String(object.path) : "",
      projectType: isSet(object.projectType) ? globalThis.String(object.projectType) : "",
      frameRate: isSet(object.frameRate) ? FrameRate.fromJSON(object.frameRate) : undefined,
      colorSpace: isSet(object.colorSpace) ? globalThis.String(object.colorSpace) : "",
      rasterWidth: isSet(object.rasterWidth) ? globalThis.Number(object.rasterWidth) : 0,
      rasterHeight: isSet(object.rasterHeight) ? globalThis.Number(object.rasterHeight) : 0,
      stereoscopic: isSet(object.stereoscopic) ? stereoscopicFromJSON(object.stereoscopic) : 0,
      dropFrame: isSet(object.dropFrame) ? globalThis.Boolean(object.dropFrame) : false,
      creationDate: isSet(object.creationDate) ? Timestamp.fromJSON(object.creationDate) : undefined,
      modifyDate: isSet(object.modifyDate) ? Timestamp.fromJSON(object.modifyDate) : undefined,
      film: isSet(object.film) ? globalThis.Boolean(object.film) : false,
      filmPerf: isSet(object.filmPerf) ? globalThis.String(object.filmPerf) : "",
    };
  },

  toJSON(message: GetOpenProjectInfoResponseBody): unknown {
    const obj: any = {};
    if (message.path !== "") {
      obj.path = message.path;
    }
    if (message.projectType !== "") {
      obj.projectType = message.projectType;
    }
    if (message.frameRate !== undefined) {
      obj.frameRate = FrameRate.toJSON(message.frameRate);
    }
    if (message.colorSpace !== "") {
      obj.colorSpace = message.colorSpace;
    }
    if (message.rasterWidth !== 0) {
      obj.rasterWidth = Math.round(message.rasterWidth);
    }
    if (message.rasterHeight !== 0) {
      obj.rasterHeight = Math.round(message.rasterHeight);
    }
    if (message.stereoscopic !== 0) {
      obj.stereoscopic = stereoscopicToJSON(message.stereoscopic);
    }
    if (message.dropFrame !== false) {
      obj.dropFrame = message.dropFrame;
    }
    if (message.creationDate !== undefined) {
      obj.creationDate = Timestamp.toJSON(message.creationDate);
    }
    if (message.modifyDate !== undefined) {
      obj.modifyDate = Timestamp.toJSON(message.modifyDate);
    }
    if (message.film !== false) {
      obj.film = message.film;
    }
    if (message.filmPerf !== "") {
      obj.filmPerf = message.filmPerf;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOpenProjectInfoResponseBody>, I>>(base?: I): GetOpenProjectInfoResponseBody {
    return GetOpenProjectInfoResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOpenProjectInfoResponseBody>, I>>(
    object: I,
  ): GetOpenProjectInfoResponseBody {
    const message = createBaseGetOpenProjectInfoResponseBody();
    message.path = object.path ?? "";
    message.projectType = object.projectType ?? "";
    message.frameRate = (object.frameRate !== undefined && object.frameRate !== null)
      ? FrameRate.fromPartial(object.frameRate)
      : undefined;
    message.colorSpace = object.colorSpace ?? "";
    message.rasterWidth = object.rasterWidth ?? 0;
    message.rasterHeight = object.rasterHeight ?? 0;
    message.stereoscopic = object.stereoscopic ?? 0;
    message.dropFrame = object.dropFrame ?? false;
    message.creationDate = (object.creationDate !== undefined && object.creationDate !== null)
      ? Timestamp.fromPartial(object.creationDate)
      : undefined;
    message.modifyDate = (object.modifyDate !== undefined && object.modifyDate !== null)
      ? Timestamp.fromPartial(object.modifyDate)
      : undefined;
    message.film = object.film ?? false;
    message.filmPerf = object.filmPerf ?? "";
    return message;
  },
};

function createBaseGetCustomProjectDataRequest(): GetCustomProjectDataRequest {
  return { header: undefined, body: undefined };
}

export const GetCustomProjectDataRequest: MessageFns<GetCustomProjectDataRequest> = {
  encode(message: GetCustomProjectDataRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetCustomProjectDataRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCustomProjectDataRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCustomProjectDataRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetCustomProjectDataRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCustomProjectDataRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetCustomProjectDataRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetCustomProjectDataRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetCustomProjectDataRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCustomProjectDataRequest>, I>>(base?: I): GetCustomProjectDataRequest {
    return GetCustomProjectDataRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCustomProjectDataRequest>, I>>(object: I): GetCustomProjectDataRequest {
    const message = createBaseGetCustomProjectDataRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetCustomProjectDataRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetCustomProjectDataRequestBody(): GetCustomProjectDataRequestBody {
  return { dataId: "", dataKey: "" };
}

export const GetCustomProjectDataRequestBody: MessageFns<GetCustomProjectDataRequestBody> = {
  encode(message: GetCustomProjectDataRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dataId !== "") {
      writer.uint32(10).string(message.dataId);
    }
    if (message.dataKey !== "") {
      writer.uint32(18).string(message.dataKey);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCustomProjectDataRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCustomProjectDataRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.dataId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.dataKey = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCustomProjectDataRequestBody {
    return {
      dataId: isSet(object.dataId) ? globalThis.String(object.dataId) : "",
      dataKey: isSet(object.dataKey) ? globalThis.String(object.dataKey) : "",
    };
  },

  toJSON(message: GetCustomProjectDataRequestBody): unknown {
    const obj: any = {};
    if (message.dataId !== "") {
      obj.dataId = message.dataId;
    }
    if (message.dataKey !== "") {
      obj.dataKey = message.dataKey;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCustomProjectDataRequestBody>, I>>(base?: I): GetCustomProjectDataRequestBody {
    return GetCustomProjectDataRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCustomProjectDataRequestBody>, I>>(
    object: I,
  ): GetCustomProjectDataRequestBody {
    const message = createBaseGetCustomProjectDataRequestBody();
    message.dataId = object.dataId ?? "";
    message.dataKey = object.dataKey ?? "";
    return message;
  },
};

function createBaseGetCustomProjectDataResponse(): GetCustomProjectDataResponse {
  return { header: undefined, body: undefined };
}

export const GetCustomProjectDataResponse: MessageFns<GetCustomProjectDataResponse> = {
  encode(message: GetCustomProjectDataResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetCustomProjectDataResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCustomProjectDataResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCustomProjectDataResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetCustomProjectDataResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCustomProjectDataResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetCustomProjectDataResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetCustomProjectDataResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetCustomProjectDataResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCustomProjectDataResponse>, I>>(base?: I): GetCustomProjectDataResponse {
    return GetCustomProjectDataResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCustomProjectDataResponse>, I>>(object: I): GetCustomProjectDataResponse {
    const message = createBaseGetCustomProjectDataResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetCustomProjectDataResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetCustomProjectDataResponseBody(): GetCustomProjectDataResponseBody {
  return { dataValue: "" };
}

export const GetCustomProjectDataResponseBody: MessageFns<GetCustomProjectDataResponseBody> = {
  encode(message: GetCustomProjectDataResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dataValue !== "") {
      writer.uint32(10).string(message.dataValue);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCustomProjectDataResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCustomProjectDataResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.dataValue = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCustomProjectDataResponseBody {
    return { dataValue: isSet(object.dataValue) ? globalThis.String(object.dataValue) : "" };
  },

  toJSON(message: GetCustomProjectDataResponseBody): unknown {
    const obj: any = {};
    if (message.dataValue !== "") {
      obj.dataValue = message.dataValue;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCustomProjectDataResponseBody>, I>>(
    base?: I,
  ): GetCustomProjectDataResponseBody {
    return GetCustomProjectDataResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCustomProjectDataResponseBody>, I>>(
    object: I,
  ): GetCustomProjectDataResponseBody {
    const message = createBaseGetCustomProjectDataResponseBody();
    message.dataValue = object.dataValue ?? "";
    return message;
  },
};

function createBaseSetCustomProjectDataRequest(): SetCustomProjectDataRequest {
  return { header: undefined, body: undefined };
}

export const SetCustomProjectDataRequest: MessageFns<SetCustomProjectDataRequest> = {
  encode(message: SetCustomProjectDataRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      SetCustomProjectDataRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetCustomProjectDataRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetCustomProjectDataRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = SetCustomProjectDataRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetCustomProjectDataRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? SetCustomProjectDataRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: SetCustomProjectDataRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = SetCustomProjectDataRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetCustomProjectDataRequest>, I>>(base?: I): SetCustomProjectDataRequest {
    return SetCustomProjectDataRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetCustomProjectDataRequest>, I>>(object: I): SetCustomProjectDataRequest {
    const message = createBaseSetCustomProjectDataRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? SetCustomProjectDataRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseSetCustomProjectDataRequestBody(): SetCustomProjectDataRequestBody {
  return { dataId: "", dataKey: "", dataValue: "" };
}

export const SetCustomProjectDataRequestBody: MessageFns<SetCustomProjectDataRequestBody> = {
  encode(message: SetCustomProjectDataRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dataId !== "") {
      writer.uint32(10).string(message.dataId);
    }
    if (message.dataKey !== "") {
      writer.uint32(18).string(message.dataKey);
    }
    if (message.dataValue !== "") {
      writer.uint32(26).string(message.dataValue);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetCustomProjectDataRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetCustomProjectDataRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.dataId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.dataKey = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.dataValue = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetCustomProjectDataRequestBody {
    return {
      dataId: isSet(object.dataId) ? globalThis.String(object.dataId) : "",
      dataKey: isSet(object.dataKey) ? globalThis.String(object.dataKey) : "",
      dataValue: isSet(object.dataValue) ? globalThis.String(object.dataValue) : "",
    };
  },

  toJSON(message: SetCustomProjectDataRequestBody): unknown {
    const obj: any = {};
    if (message.dataId !== "") {
      obj.dataId = message.dataId;
    }
    if (message.dataKey !== "") {
      obj.dataKey = message.dataKey;
    }
    if (message.dataValue !== "") {
      obj.dataValue = message.dataValue;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetCustomProjectDataRequestBody>, I>>(base?: I): SetCustomProjectDataRequestBody {
    return SetCustomProjectDataRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetCustomProjectDataRequestBody>, I>>(
    object: I,
  ): SetCustomProjectDataRequestBody {
    const message = createBaseSetCustomProjectDataRequestBody();
    message.dataId = object.dataId ?? "";
    message.dataKey = object.dataKey ?? "";
    message.dataValue = object.dataValue ?? "";
    return message;
  },
};

function createBaseSetCustomProjectDataResponse(): SetCustomProjectDataResponse {
  return { header: undefined, body: undefined };
}

export const SetCustomProjectDataResponse: MessageFns<SetCustomProjectDataResponse> = {
  encode(message: SetCustomProjectDataResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      SetCustomProjectDataResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetCustomProjectDataResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetCustomProjectDataResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = SetCustomProjectDataResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetCustomProjectDataResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? SetCustomProjectDataResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: SetCustomProjectDataResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = SetCustomProjectDataResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetCustomProjectDataResponse>, I>>(base?: I): SetCustomProjectDataResponse {
    return SetCustomProjectDataResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetCustomProjectDataResponse>, I>>(object: I): SetCustomProjectDataResponse {
    const message = createBaseSetCustomProjectDataResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? SetCustomProjectDataResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseSetCustomProjectDataResponseBody(): SetCustomProjectDataResponseBody {
  return {};
}

export const SetCustomProjectDataResponseBody: MessageFns<SetCustomProjectDataResponseBody> = {
  encode(_: SetCustomProjectDataResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetCustomProjectDataResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetCustomProjectDataResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetCustomProjectDataResponseBody {
    return {};
  },

  toJSON(_: SetCustomProjectDataResponseBody): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetCustomProjectDataResponseBody>, I>>(
    base?: I,
  ): SetCustomProjectDataResponseBody {
    return SetCustomProjectDataResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetCustomProjectDataResponseBody>, I>>(
    _: I,
  ): SetCustomProjectDataResponseBody {
    const message = createBaseSetCustomProjectDataResponseBody();
    return message;
  },
};

function createBaseFrameRate(): FrameRate {
  return { num: 0, den: 0 };
}

export const FrameRate: MessageFns<FrameRate> = {
  encode(message: FrameRate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.num !== 0) {
      writer.uint32(8).int32(message.num);
    }
    if (message.den !== 0) {
      writer.uint32(16).int32(message.den);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FrameRate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFrameRate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.num = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.den = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FrameRate {
    return {
      num: isSet(object.num) ? globalThis.Number(object.num) : 0,
      den: isSet(object.den) ? globalThis.Number(object.den) : 0,
    };
  },

  toJSON(message: FrameRate): unknown {
    const obj: any = {};
    if (message.num !== 0) {
      obj.num = Math.round(message.num);
    }
    if (message.den !== 0) {
      obj.den = Math.round(message.den);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FrameRate>, I>>(base?: I): FrameRate {
    return FrameRate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FrameRate>, I>>(object: I): FrameRate {
    const message = createBaseFrameRate();
    message.num = object.num ?? 0;
    message.den = object.den ?? 0;
    return message;
  },
};

function createBaseScanAvidMediaFilesFolderRequest(): ScanAvidMediaFilesFolderRequest {
  return { header: undefined, body: undefined };
}

export const ScanAvidMediaFilesFolderRequest: MessageFns<ScanAvidMediaFilesFolderRequest> = {
  encode(message: ScanAvidMediaFilesFolderRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      ScanAvidMediaFilesFolderRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScanAvidMediaFilesFolderRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScanAvidMediaFilesFolderRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = ScanAvidMediaFilesFolderRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScanAvidMediaFilesFolderRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? ScanAvidMediaFilesFolderRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: ScanAvidMediaFilesFolderRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = ScanAvidMediaFilesFolderRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScanAvidMediaFilesFolderRequest>, I>>(base?: I): ScanAvidMediaFilesFolderRequest {
    return ScanAvidMediaFilesFolderRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScanAvidMediaFilesFolderRequest>, I>>(
    object: I,
  ): ScanAvidMediaFilesFolderRequest {
    const message = createBaseScanAvidMediaFilesFolderRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? ScanAvidMediaFilesFolderRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseScanAvidMediaFilesFolderRequestBody(): ScanAvidMediaFilesFolderRequestBody {
  return { destinationPath: "" };
}

export const ScanAvidMediaFilesFolderRequestBody: MessageFns<ScanAvidMediaFilesFolderRequestBody> = {
  encode(message: ScanAvidMediaFilesFolderRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.destinationPath !== "") {
      writer.uint32(10).string(message.destinationPath);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScanAvidMediaFilesFolderRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScanAvidMediaFilesFolderRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.destinationPath = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScanAvidMediaFilesFolderRequestBody {
    return { destinationPath: isSet(object.destinationPath) ? globalThis.String(object.destinationPath) : "" };
  },

  toJSON(message: ScanAvidMediaFilesFolderRequestBody): unknown {
    const obj: any = {};
    if (message.destinationPath !== "") {
      obj.destinationPath = message.destinationPath;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScanAvidMediaFilesFolderRequestBody>, I>>(
    base?: I,
  ): ScanAvidMediaFilesFolderRequestBody {
    return ScanAvidMediaFilesFolderRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScanAvidMediaFilesFolderRequestBody>, I>>(
    object: I,
  ): ScanAvidMediaFilesFolderRequestBody {
    const message = createBaseScanAvidMediaFilesFolderRequestBody();
    message.destinationPath = object.destinationPath ?? "";
    return message;
  },
};

function createBaseScanAvidMediaFilesFolderResponse(): ScanAvidMediaFilesFolderResponse {
  return { header: undefined, body: undefined };
}

export const ScanAvidMediaFilesFolderResponse: MessageFns<ScanAvidMediaFilesFolderResponse> = {
  encode(message: ScanAvidMediaFilesFolderResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      ScanAvidMediaFilesFolderResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScanAvidMediaFilesFolderResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScanAvidMediaFilesFolderResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = ScanAvidMediaFilesFolderResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScanAvidMediaFilesFolderResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? ScanAvidMediaFilesFolderResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: ScanAvidMediaFilesFolderResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = ScanAvidMediaFilesFolderResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScanAvidMediaFilesFolderResponse>, I>>(
    base?: I,
  ): ScanAvidMediaFilesFolderResponse {
    return ScanAvidMediaFilesFolderResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScanAvidMediaFilesFolderResponse>, I>>(
    object: I,
  ): ScanAvidMediaFilesFolderResponse {
    const message = createBaseScanAvidMediaFilesFolderResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? ScanAvidMediaFilesFolderResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseScanAvidMediaFilesFolderResponseBody(): ScanAvidMediaFilesFolderResponseBody {
  return {};
}

export const ScanAvidMediaFilesFolderResponseBody: MessageFns<ScanAvidMediaFilesFolderResponseBody> = {
  encode(_: ScanAvidMediaFilesFolderResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScanAvidMediaFilesFolderResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScanAvidMediaFilesFolderResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ScanAvidMediaFilesFolderResponseBody {
    return {};
  },

  toJSON(_: ScanAvidMediaFilesFolderResponseBody): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ScanAvidMediaFilesFolderResponseBody>, I>>(
    base?: I,
  ): ScanAvidMediaFilesFolderResponseBody {
    return ScanAvidMediaFilesFolderResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScanAvidMediaFilesFolderResponseBody>, I>>(
    _: I,
  ): ScanAvidMediaFilesFolderResponseBody {
    const message = createBaseScanAvidMediaFilesFolderResponseBody();
    return message;
  },
};

function createBaseCreateClipsFromAvidMediaFilesFolderRequest(): CreateClipsFromAvidMediaFilesFolderRequest {
  return { header: undefined, body: undefined };
}

export const CreateClipsFromAvidMediaFilesFolderRequest: MessageFns<CreateClipsFromAvidMediaFilesFolderRequest> = {
  encode(message: CreateClipsFromAvidMediaFilesFolderRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      CreateClipsFromAvidMediaFilesFolderRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateClipsFromAvidMediaFilesFolderRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateClipsFromAvidMediaFilesFolderRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = CreateClipsFromAvidMediaFilesFolderRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateClipsFromAvidMediaFilesFolderRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? CreateClipsFromAvidMediaFilesFolderRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: CreateClipsFromAvidMediaFilesFolderRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = CreateClipsFromAvidMediaFilesFolderRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateClipsFromAvidMediaFilesFolderRequest>, I>>(
    base?: I,
  ): CreateClipsFromAvidMediaFilesFolderRequest {
    return CreateClipsFromAvidMediaFilesFolderRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateClipsFromAvidMediaFilesFolderRequest>, I>>(
    object: I,
  ): CreateClipsFromAvidMediaFilesFolderRequest {
    const message = createBaseCreateClipsFromAvidMediaFilesFolderRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? CreateClipsFromAvidMediaFilesFolderRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseCreateClipsFromAvidMediaFilesFolderRequestBody(): CreateClipsFromAvidMediaFilesFolderRequestBody {
  return { binPath: "", mediaFolderPath: "", mediaFilePath: [] };
}

export const CreateClipsFromAvidMediaFilesFolderRequestBody: MessageFns<
  CreateClipsFromAvidMediaFilesFolderRequestBody
> = {
  encode(
    message: CreateClipsFromAvidMediaFilesFolderRequestBody,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.binPath !== "") {
      writer.uint32(10).string(message.binPath);
    }
    if (message.mediaFolderPath !== "") {
      writer.uint32(18).string(message.mediaFolderPath);
    }
    for (const v of message.mediaFilePath) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateClipsFromAvidMediaFilesFolderRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateClipsFromAvidMediaFilesFolderRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.binPath = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.mediaFolderPath = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.mediaFilePath.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateClipsFromAvidMediaFilesFolderRequestBody {
    return {
      binPath: isSet(object.binPath) ? globalThis.String(object.binPath) : "",
      mediaFolderPath: isSet(object.mediaFolderPath) ? globalThis.String(object.mediaFolderPath) : "",
      mediaFilePath: globalThis.Array.isArray(object?.mediaFilePath)
        ? object.mediaFilePath.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: CreateClipsFromAvidMediaFilesFolderRequestBody): unknown {
    const obj: any = {};
    if (message.binPath !== "") {
      obj.binPath = message.binPath;
    }
    if (message.mediaFolderPath !== "") {
      obj.mediaFolderPath = message.mediaFolderPath;
    }
    if (message.mediaFilePath?.length) {
      obj.mediaFilePath = message.mediaFilePath;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateClipsFromAvidMediaFilesFolderRequestBody>, I>>(
    base?: I,
  ): CreateClipsFromAvidMediaFilesFolderRequestBody {
    return CreateClipsFromAvidMediaFilesFolderRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateClipsFromAvidMediaFilesFolderRequestBody>, I>>(
    object: I,
  ): CreateClipsFromAvidMediaFilesFolderRequestBody {
    const message = createBaseCreateClipsFromAvidMediaFilesFolderRequestBody();
    message.binPath = object.binPath ?? "";
    message.mediaFolderPath = object.mediaFolderPath ?? "";
    message.mediaFilePath = object.mediaFilePath?.map((e) => e) || [];
    return message;
  },
};

function createBaseCreateClipsFromAvidMediaFilesFolderResponse(): CreateClipsFromAvidMediaFilesFolderResponse {
  return { header: undefined, body: undefined };
}

export const CreateClipsFromAvidMediaFilesFolderResponse: MessageFns<CreateClipsFromAvidMediaFilesFolderResponse> = {
  encode(
    message: CreateClipsFromAvidMediaFilesFolderResponse,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      CreateClipsFromAvidMediaFilesFolderResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateClipsFromAvidMediaFilesFolderResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateClipsFromAvidMediaFilesFolderResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = CreateClipsFromAvidMediaFilesFolderResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateClipsFromAvidMediaFilesFolderResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? CreateClipsFromAvidMediaFilesFolderResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: CreateClipsFromAvidMediaFilesFolderResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = CreateClipsFromAvidMediaFilesFolderResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateClipsFromAvidMediaFilesFolderResponse>, I>>(
    base?: I,
  ): CreateClipsFromAvidMediaFilesFolderResponse {
    return CreateClipsFromAvidMediaFilesFolderResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateClipsFromAvidMediaFilesFolderResponse>, I>>(
    object: I,
  ): CreateClipsFromAvidMediaFilesFolderResponse {
    const message = createBaseCreateClipsFromAvidMediaFilesFolderResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? CreateClipsFromAvidMediaFilesFolderResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseCreateClipsFromAvidMediaFilesFolderResponseBody(): CreateClipsFromAvidMediaFilesFolderResponseBody {
  return {};
}

export const CreateClipsFromAvidMediaFilesFolderResponseBody: MessageFns<
  CreateClipsFromAvidMediaFilesFolderResponseBody
> = {
  encode(_: CreateClipsFromAvidMediaFilesFolderResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateClipsFromAvidMediaFilesFolderResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateClipsFromAvidMediaFilesFolderResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): CreateClipsFromAvidMediaFilesFolderResponseBody {
    return {};
  },

  toJSON(_: CreateClipsFromAvidMediaFilesFolderResponseBody): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateClipsFromAvidMediaFilesFolderResponseBody>, I>>(
    base?: I,
  ): CreateClipsFromAvidMediaFilesFolderResponseBody {
    return CreateClipsFromAvidMediaFilesFolderResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateClipsFromAvidMediaFilesFolderResponseBody>, I>>(
    _: I,
  ): CreateClipsFromAvidMediaFilesFolderResponseBody {
    const message = createBaseCreateClipsFromAvidMediaFilesFolderResponseBody();
    return message;
  },
};

function createBaseCreateCustomColumnRequest(): CreateCustomColumnRequest {
  return { header: undefined, body: undefined };
}

export const CreateCustomColumnRequest: MessageFns<CreateCustomColumnRequest> = {
  encode(message: CreateCustomColumnRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      CreateCustomColumnRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateCustomColumnRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateCustomColumnRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = CreateCustomColumnRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateCustomColumnRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? CreateCustomColumnRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: CreateCustomColumnRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = CreateCustomColumnRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateCustomColumnRequest>, I>>(base?: I): CreateCustomColumnRequest {
    return CreateCustomColumnRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateCustomColumnRequest>, I>>(object: I): CreateCustomColumnRequest {
    const message = createBaseCreateCustomColumnRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? CreateCustomColumnRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseCreateCustomColumnRequestBody(): CreateCustomColumnRequestBody {
  return { absoluteBinPath: "", newColumnName: "", afterColumnName: "", columnHidden: false };
}

export const CreateCustomColumnRequestBody: MessageFns<CreateCustomColumnRequestBody> = {
  encode(message: CreateCustomColumnRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.absoluteBinPath !== "") {
      writer.uint32(10).string(message.absoluteBinPath);
    }
    if (message.newColumnName !== "") {
      writer.uint32(18).string(message.newColumnName);
    }
    if (message.afterColumnName !== "") {
      writer.uint32(26).string(message.afterColumnName);
    }
    if (message.columnHidden !== false) {
      writer.uint32(32).bool(message.columnHidden);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateCustomColumnRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateCustomColumnRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.absoluteBinPath = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.newColumnName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.afterColumnName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.columnHidden = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateCustomColumnRequestBody {
    return {
      absoluteBinPath: isSet(object.absoluteBinPath) ? globalThis.String(object.absoluteBinPath) : "",
      newColumnName: isSet(object.newColumnName) ? globalThis.String(object.newColumnName) : "",
      afterColumnName: isSet(object.afterColumnName) ? globalThis.String(object.afterColumnName) : "",
      columnHidden: isSet(object.columnHidden) ? globalThis.Boolean(object.columnHidden) : false,
    };
  },

  toJSON(message: CreateCustomColumnRequestBody): unknown {
    const obj: any = {};
    if (message.absoluteBinPath !== "") {
      obj.absoluteBinPath = message.absoluteBinPath;
    }
    if (message.newColumnName !== "") {
      obj.newColumnName = message.newColumnName;
    }
    if (message.afterColumnName !== "") {
      obj.afterColumnName = message.afterColumnName;
    }
    if (message.columnHidden !== false) {
      obj.columnHidden = message.columnHidden;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateCustomColumnRequestBody>, I>>(base?: I): CreateCustomColumnRequestBody {
    return CreateCustomColumnRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateCustomColumnRequestBody>, I>>(
    object: I,
  ): CreateCustomColumnRequestBody {
    const message = createBaseCreateCustomColumnRequestBody();
    message.absoluteBinPath = object.absoluteBinPath ?? "";
    message.newColumnName = object.newColumnName ?? "";
    message.afterColumnName = object.afterColumnName ?? "";
    message.columnHidden = object.columnHidden ?? false;
    return message;
  },
};

function createBaseCreateCustomColumnResponse(): CreateCustomColumnResponse {
  return { header: undefined, body: undefined };
}

export const CreateCustomColumnResponse: MessageFns<CreateCustomColumnResponse> = {
  encode(message: CreateCustomColumnResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      CreateCustomColumnResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateCustomColumnResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateCustomColumnResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = CreateCustomColumnResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateCustomColumnResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? CreateCustomColumnResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: CreateCustomColumnResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = CreateCustomColumnResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateCustomColumnResponse>, I>>(base?: I): CreateCustomColumnResponse {
    return CreateCustomColumnResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateCustomColumnResponse>, I>>(object: I): CreateCustomColumnResponse {
    const message = createBaseCreateCustomColumnResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? CreateCustomColumnResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseCreateCustomColumnResponseBody(): CreateCustomColumnResponseBody {
  return {};
}

export const CreateCustomColumnResponseBody: MessageFns<CreateCustomColumnResponseBody> = {
  encode(_: CreateCustomColumnResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateCustomColumnResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateCustomColumnResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): CreateCustomColumnResponseBody {
    return {};
  },

  toJSON(_: CreateCustomColumnResponseBody): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateCustomColumnResponseBody>, I>>(base?: I): CreateCustomColumnResponseBody {
    return CreateCustomColumnResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateCustomColumnResponseBody>, I>>(_: I): CreateCustomColumnResponseBody {
    const message = createBaseCreateCustomColumnResponseBody();
    return message;
  },
};

function createBaseGetListOfExportEDLSettingsRequest(): GetListOfExportEDLSettingsRequest {
  return { header: undefined, body: undefined };
}

export const GetListOfExportEDLSettingsRequest: MessageFns<GetListOfExportEDLSettingsRequest> = {
  encode(message: GetListOfExportEDLSettingsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetListOfExportEDLSettingsRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetListOfExportEDLSettingsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetListOfExportEDLSettingsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetListOfExportEDLSettingsRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetListOfExportEDLSettingsRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetListOfExportEDLSettingsRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetListOfExportEDLSettingsRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetListOfExportEDLSettingsRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetListOfExportEDLSettingsRequest>, I>>(
    base?: I,
  ): GetListOfExportEDLSettingsRequest {
    return GetListOfExportEDLSettingsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetListOfExportEDLSettingsRequest>, I>>(
    object: I,
  ): GetListOfExportEDLSettingsRequest {
    const message = createBaseGetListOfExportEDLSettingsRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetListOfExportEDLSettingsRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetListOfExportEDLSettingsRequestBody(): GetListOfExportEDLSettingsRequestBody {
  return {};
}

export const GetListOfExportEDLSettingsRequestBody: MessageFns<GetListOfExportEDLSettingsRequestBody> = {
  encode(_: GetListOfExportEDLSettingsRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetListOfExportEDLSettingsRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetListOfExportEDLSettingsRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetListOfExportEDLSettingsRequestBody {
    return {};
  },

  toJSON(_: GetListOfExportEDLSettingsRequestBody): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetListOfExportEDLSettingsRequestBody>, I>>(
    base?: I,
  ): GetListOfExportEDLSettingsRequestBody {
    return GetListOfExportEDLSettingsRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetListOfExportEDLSettingsRequestBody>, I>>(
    _: I,
  ): GetListOfExportEDLSettingsRequestBody {
    const message = createBaseGetListOfExportEDLSettingsRequestBody();
    return message;
  },
};

function createBaseGetListOfExportEDLSettingsResponse(): GetListOfExportEDLSettingsResponse {
  return { header: undefined, body: undefined };
}

export const GetListOfExportEDLSettingsResponse: MessageFns<GetListOfExportEDLSettingsResponse> = {
  encode(message: GetListOfExportEDLSettingsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetListOfExportEDLSettingsResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetListOfExportEDLSettingsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetListOfExportEDLSettingsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetListOfExportEDLSettingsResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetListOfExportEDLSettingsResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetListOfExportEDLSettingsResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetListOfExportEDLSettingsResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetListOfExportEDLSettingsResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetListOfExportEDLSettingsResponse>, I>>(
    base?: I,
  ): GetListOfExportEDLSettingsResponse {
    return GetListOfExportEDLSettingsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetListOfExportEDLSettingsResponse>, I>>(
    object: I,
  ): GetListOfExportEDLSettingsResponse {
    const message = createBaseGetListOfExportEDLSettingsResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetListOfExportEDLSettingsResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetListOfExportEDLSettingsResponseBody(): GetListOfExportEDLSettingsResponseBody {
  return { settingNames: [] };
}

export const GetListOfExportEDLSettingsResponseBody: MessageFns<GetListOfExportEDLSettingsResponseBody> = {
  encode(message: GetListOfExportEDLSettingsResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.settingNames) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetListOfExportEDLSettingsResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetListOfExportEDLSettingsResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.settingNames.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetListOfExportEDLSettingsResponseBody {
    return {
      settingNames: globalThis.Array.isArray(object?.settingNames)
        ? object.settingNames.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: GetListOfExportEDLSettingsResponseBody): unknown {
    const obj: any = {};
    if (message.settingNames?.length) {
      obj.settingNames = message.settingNames;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetListOfExportEDLSettingsResponseBody>, I>>(
    base?: I,
  ): GetListOfExportEDLSettingsResponseBody {
    return GetListOfExportEDLSettingsResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetListOfExportEDLSettingsResponseBody>, I>>(
    object: I,
  ): GetListOfExportEDLSettingsResponseBody {
    const message = createBaseGetListOfExportEDLSettingsResponseBody();
    message.settingNames = object.settingNames?.map((e) => e) || [];
    return message;
  },
};

function createBaseExportEDLRequest(): ExportEDLRequest {
  return { header: undefined, body: undefined };
}

export const ExportEDLRequest: MessageFns<ExportEDLRequest> = {
  encode(message: ExportEDLRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      ExportEDLRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExportEDLRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExportEDLRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = ExportEDLRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExportEDLRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? ExportEDLRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: ExportEDLRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = ExportEDLRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExportEDLRequest>, I>>(base?: I): ExportEDLRequest {
    return ExportEDLRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExportEDLRequest>, I>>(object: I): ExportEDLRequest {
    const message = createBaseExportEDLRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? ExportEDLRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseExportEDLRequestBody(): ExportEDLRequestBody {
  return { mobId: "", edlSettingsName: "", trackList: undefined };
}

export const ExportEDLRequestBody: MessageFns<ExportEDLRequestBody> = {
  encode(message: ExportEDLRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mobId !== "") {
      writer.uint32(10).string(message.mobId);
    }
    if (message.edlSettingsName !== "") {
      writer.uint32(18).string(message.edlSettingsName);
    }
    if (message.trackList !== undefined) {
      TrackList.encode(message.trackList, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExportEDLRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExportEDLRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mobId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.edlSettingsName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.trackList = TrackList.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExportEDLRequestBody {
    return {
      mobId: isSet(object.mobId) ? globalThis.String(object.mobId) : "",
      edlSettingsName: isSet(object.edlSettingsName) ? globalThis.String(object.edlSettingsName) : "",
      trackList: isSet(object.trackList) ? TrackList.fromJSON(object.trackList) : undefined,
    };
  },

  toJSON(message: ExportEDLRequestBody): unknown {
    const obj: any = {};
    if (message.mobId !== "") {
      obj.mobId = message.mobId;
    }
    if (message.edlSettingsName !== "") {
      obj.edlSettingsName = message.edlSettingsName;
    }
    if (message.trackList !== undefined) {
      obj.trackList = TrackList.toJSON(message.trackList);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExportEDLRequestBody>, I>>(base?: I): ExportEDLRequestBody {
    return ExportEDLRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExportEDLRequestBody>, I>>(object: I): ExportEDLRequestBody {
    const message = createBaseExportEDLRequestBody();
    message.mobId = object.mobId ?? "";
    message.edlSettingsName = object.edlSettingsName ?? "";
    message.trackList = (object.trackList !== undefined && object.trackList !== null)
      ? TrackList.fromPartial(object.trackList)
      : undefined;
    return message;
  },
};

function createBaseTrackList(): TrackList {
  return { trackLabels: [] };
}

export const TrackList: MessageFns<TrackList> = {
  encode(message: TrackList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.trackLabels) {
      TrackLabel.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TrackList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrackList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.trackLabels.push(TrackLabel.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TrackList {
    return {
      trackLabels: globalThis.Array.isArray(object?.trackLabels)
        ? object.trackLabels.map((e: any) => TrackLabel.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TrackList): unknown {
    const obj: any = {};
    if (message.trackLabels?.length) {
      obj.trackLabels = message.trackLabels.map((e) => TrackLabel.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TrackList>, I>>(base?: I): TrackList {
    return TrackList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrackList>, I>>(object: I): TrackList {
    const message = createBaseTrackList();
    message.trackLabels = object.trackLabels?.map((e) => TrackLabel.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTrackLabel(): TrackLabel {
  return { type: 0, number: 0 };
}

export const TrackLabel: MessageFns<TrackLabel> = {
  encode(message: TrackLabel, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.number !== 0) {
      writer.uint32(16).uint32(message.number);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TrackLabel {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrackLabel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.number = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TrackLabel {
    return {
      type: isSet(object.type) ? trackTypeFromJSON(object.type) : 0,
      number: isSet(object.number) ? globalThis.Number(object.number) : 0,
    };
  },

  toJSON(message: TrackLabel): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = trackTypeToJSON(message.type);
    }
    if (message.number !== 0) {
      obj.number = Math.round(message.number);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TrackLabel>, I>>(base?: I): TrackLabel {
    return TrackLabel.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrackLabel>, I>>(object: I): TrackLabel {
    const message = createBaseTrackLabel();
    message.type = object.type ?? 0;
    message.number = object.number ?? 0;
    return message;
  },
};

function createBaseExportEDLResponse(): ExportEDLResponse {
  return { header: undefined, body: undefined };
}

export const ExportEDLResponse: MessageFns<ExportEDLResponse> = {
  encode(message: ExportEDLResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      ExportEDLResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExportEDLResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExportEDLResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = ExportEDLResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExportEDLResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? ExportEDLResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: ExportEDLResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = ExportEDLResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExportEDLResponse>, I>>(base?: I): ExportEDLResponse {
    return ExportEDLResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExportEDLResponse>, I>>(object: I): ExportEDLResponse {
    const message = createBaseExportEDLResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? ExportEDLResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseExportEDLResponseBody(): ExportEDLResponseBody {
  return { path: "", dialogContents: [] };
}

export const ExportEDLResponseBody: MessageFns<ExportEDLResponseBody> = {
  encode(message: ExportEDLResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.path !== "") {
      writer.uint32(10).string(message.path);
    }
    for (const v of message.dialogContents) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExportEDLResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExportEDLResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.path = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.dialogContents.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExportEDLResponseBody {
    return {
      path: isSet(object.path) ? globalThis.String(object.path) : "",
      dialogContents: globalThis.Array.isArray(object?.dialogContents)
        ? object.dialogContents.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ExportEDLResponseBody): unknown {
    const obj: any = {};
    if (message.path !== "") {
      obj.path = message.path;
    }
    if (message.dialogContents?.length) {
      obj.dialogContents = message.dialogContents;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExportEDLResponseBody>, I>>(base?: I): ExportEDLResponseBody {
    return ExportEDLResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExportEDLResponseBody>, I>>(object: I): ExportEDLResponseBody {
    const message = createBaseExportEDLResponseBody();
    message.path = object.path ?? "";
    message.dialogContents = object.dialogContents?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetMobTrackInfoRequest(): GetMobTrackInfoRequest {
  return { header: undefined, body: undefined };
}

export const GetMobTrackInfoRequest: MessageFns<GetMobTrackInfoRequest> = {
  encode(message: GetMobTrackInfoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetMobTrackInfoRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMobTrackInfoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMobTrackInfoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetMobTrackInfoRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMobTrackInfoRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetMobTrackInfoRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetMobTrackInfoRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetMobTrackInfoRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMobTrackInfoRequest>, I>>(base?: I): GetMobTrackInfoRequest {
    return GetMobTrackInfoRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMobTrackInfoRequest>, I>>(object: I): GetMobTrackInfoRequest {
    const message = createBaseGetMobTrackInfoRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetMobTrackInfoRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetMobTrackInfoRequestBody(): GetMobTrackInfoRequestBody {
  return { mobId: "" };
}

export const GetMobTrackInfoRequestBody: MessageFns<GetMobTrackInfoRequestBody> = {
  encode(message: GetMobTrackInfoRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mobId !== "") {
      writer.uint32(10).string(message.mobId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMobTrackInfoRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMobTrackInfoRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mobId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMobTrackInfoRequestBody {
    return { mobId: isSet(object.mobId) ? globalThis.String(object.mobId) : "" };
  },

  toJSON(message: GetMobTrackInfoRequestBody): unknown {
    const obj: any = {};
    if (message.mobId !== "") {
      obj.mobId = message.mobId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMobTrackInfoRequestBody>, I>>(base?: I): GetMobTrackInfoRequestBody {
    return GetMobTrackInfoRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMobTrackInfoRequestBody>, I>>(object: I): GetMobTrackInfoRequestBody {
    const message = createBaseGetMobTrackInfoRequestBody();
    message.mobId = object.mobId ?? "";
    return message;
  },
};

function createBaseGetMobTrackInfoResponse(): GetMobTrackInfoResponse {
  return { header: undefined, body: undefined };
}

export const GetMobTrackInfoResponse: MessageFns<GetMobTrackInfoResponse> = {
  encode(message: GetMobTrackInfoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetMobTrackInfoResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMobTrackInfoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMobTrackInfoResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetMobTrackInfoResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMobTrackInfoResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetMobTrackInfoResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetMobTrackInfoResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetMobTrackInfoResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMobTrackInfoResponse>, I>>(base?: I): GetMobTrackInfoResponse {
    return GetMobTrackInfoResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMobTrackInfoResponse>, I>>(object: I): GetMobTrackInfoResponse {
    const message = createBaseGetMobTrackInfoResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetMobTrackInfoResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseTrackInfo(): TrackInfo {
  return {
    label: undefined,
    customName: "",
    selected: false,
    monitored: false,
    enabled: false,
    solo: false,
    mute: false,
    locked: false,
    syncLocked: false,
    numSegments: 0,
    audioType: 0,
  };
}

export const TrackInfo: MessageFns<TrackInfo> = {
  encode(message: TrackInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.label !== undefined) {
      TrackLabel.encode(message.label, writer.uint32(10).fork()).join();
    }
    if (message.customName !== "") {
      writer.uint32(18).string(message.customName);
    }
    if (message.selected !== false) {
      writer.uint32(24).bool(message.selected);
    }
    if (message.monitored !== false) {
      writer.uint32(32).bool(message.monitored);
    }
    if (message.enabled !== false) {
      writer.uint32(40).bool(message.enabled);
    }
    if (message.solo !== false) {
      writer.uint32(48).bool(message.solo);
    }
    if (message.mute !== false) {
      writer.uint32(56).bool(message.mute);
    }
    if (message.locked !== false) {
      writer.uint32(64).bool(message.locked);
    }
    if (message.syncLocked !== false) {
      writer.uint32(72).bool(message.syncLocked);
    }
    if (message.numSegments !== 0) {
      writer.uint32(80).int32(message.numSegments);
    }
    if (message.audioType !== 0) {
      writer.uint32(88).int32(message.audioType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TrackInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrackInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.label = TrackLabel.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.customName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.selected = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.monitored = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.solo = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.mute = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.locked = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.syncLocked = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.numSegments = reader.int32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.audioType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TrackInfo {
    return {
      label: isSet(object.label) ? TrackLabel.fromJSON(object.label) : undefined,
      customName: isSet(object.customName) ? globalThis.String(object.customName) : "",
      selected: isSet(object.selected) ? globalThis.Boolean(object.selected) : false,
      monitored: isSet(object.monitored) ? globalThis.Boolean(object.monitored) : false,
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      solo: isSet(object.solo) ? globalThis.Boolean(object.solo) : false,
      mute: isSet(object.mute) ? globalThis.Boolean(object.mute) : false,
      locked: isSet(object.locked) ? globalThis.Boolean(object.locked) : false,
      syncLocked: isSet(object.syncLocked) ? globalThis.Boolean(object.syncLocked) : false,
      numSegments: isSet(object.numSegments) ? globalThis.Number(object.numSegments) : 0,
      audioType: isSet(object.audioType) ? audioTrackTypeFromJSON(object.audioType) : 0,
    };
  },

  toJSON(message: TrackInfo): unknown {
    const obj: any = {};
    if (message.label !== undefined) {
      obj.label = TrackLabel.toJSON(message.label);
    }
    if (message.customName !== "") {
      obj.customName = message.customName;
    }
    if (message.selected !== false) {
      obj.selected = message.selected;
    }
    if (message.monitored !== false) {
      obj.monitored = message.monitored;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.solo !== false) {
      obj.solo = message.solo;
    }
    if (message.mute !== false) {
      obj.mute = message.mute;
    }
    if (message.locked !== false) {
      obj.locked = message.locked;
    }
    if (message.syncLocked !== false) {
      obj.syncLocked = message.syncLocked;
    }
    if (message.numSegments !== 0) {
      obj.numSegments = Math.round(message.numSegments);
    }
    if (message.audioType !== 0) {
      obj.audioType = audioTrackTypeToJSON(message.audioType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TrackInfo>, I>>(base?: I): TrackInfo {
    return TrackInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrackInfo>, I>>(object: I): TrackInfo {
    const message = createBaseTrackInfo();
    message.label = (object.label !== undefined && object.label !== null)
      ? TrackLabel.fromPartial(object.label)
      : undefined;
    message.customName = object.customName ?? "";
    message.selected = object.selected ?? false;
    message.monitored = object.monitored ?? false;
    message.enabled = object.enabled ?? false;
    message.solo = object.solo ?? false;
    message.mute = object.mute ?? false;
    message.locked = object.locked ?? false;
    message.syncLocked = object.syncLocked ?? false;
    message.numSegments = object.numSegments ?? 0;
    message.audioType = object.audioType ?? 0;
    return message;
  },
};

function createBaseTrackInfoList(): TrackInfoList {
  return { trackInfo: [] };
}

export const TrackInfoList: MessageFns<TrackInfoList> = {
  encode(message: TrackInfoList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.trackInfo) {
      TrackInfo.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TrackInfoList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrackInfoList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.trackInfo.push(TrackInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TrackInfoList {
    return {
      trackInfo: globalThis.Array.isArray(object?.trackInfo)
        ? object.trackInfo.map((e: any) => TrackInfo.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TrackInfoList): unknown {
    const obj: any = {};
    if (message.trackInfo?.length) {
      obj.trackInfo = message.trackInfo.map((e) => TrackInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TrackInfoList>, I>>(base?: I): TrackInfoList {
    return TrackInfoList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrackInfoList>, I>>(object: I): TrackInfoList {
    const message = createBaseTrackInfoList();
    message.trackInfo = object.trackInfo?.map((e) => TrackInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetMobTrackInfoResponseBody(): GetMobTrackInfoResponseBody {
  return { trackInfoList: undefined };
}

export const GetMobTrackInfoResponseBody: MessageFns<GetMobTrackInfoResponseBody> = {
  encode(message: GetMobTrackInfoResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.trackInfoList !== undefined) {
      TrackInfoList.encode(message.trackInfoList, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMobTrackInfoResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMobTrackInfoResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.trackInfoList = TrackInfoList.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMobTrackInfoResponseBody {
    return { trackInfoList: isSet(object.trackInfoList) ? TrackInfoList.fromJSON(object.trackInfoList) : undefined };
  },

  toJSON(message: GetMobTrackInfoResponseBody): unknown {
    const obj: any = {};
    if (message.trackInfoList !== undefined) {
      obj.trackInfoList = TrackInfoList.toJSON(message.trackInfoList);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMobTrackInfoResponseBody>, I>>(base?: I): GetMobTrackInfoResponseBody {
    return GetMobTrackInfoResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMobTrackInfoResponseBody>, I>>(object: I): GetMobTrackInfoResponseBody {
    const message = createBaseGetMobTrackInfoResponseBody();
    message.trackInfoList = (object.trackInfoList !== undefined && object.trackInfoList !== null)
      ? TrackInfoList.fromPartial(object.trackInfoList)
      : undefined;
    return message;
  },
};

function createBaseRequestHeader(): RequestHeader {
  return { companyId: "", accessToken: "" };
}

export const RequestHeader: MessageFns<RequestHeader> = {
  encode(message: RequestHeader, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.companyId !== "") {
      writer.uint32(10).string(message.companyId);
    }
    if (message.accessToken !== "") {
      writer.uint32(18).string(message.accessToken);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RequestHeader {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestHeader();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.companyId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.accessToken = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RequestHeader {
    return {
      companyId: isSet(object.companyId) ? globalThis.String(object.companyId) : "",
      accessToken: isSet(object.accessToken) ? globalThis.String(object.accessToken) : "",
    };
  },

  toJSON(message: RequestHeader): unknown {
    const obj: any = {};
    if (message.companyId !== "") {
      obj.companyId = message.companyId;
    }
    if (message.accessToken !== "") {
      obj.accessToken = message.accessToken;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RequestHeader>, I>>(base?: I): RequestHeader {
    return RequestHeader.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RequestHeader>, I>>(object: I): RequestHeader {
    const message = createBaseRequestHeader();
    message.companyId = object.companyId ?? "";
    message.accessToken = object.accessToken ?? "";
    return message;
  },
};

function createBaseResponseHeader(): ResponseHeader {
  return { taskId: "", status: 0, progress: 0, error: undefined, warnings: [] };
}

export const ResponseHeader: MessageFns<ResponseHeader> = {
  encode(message: ResponseHeader, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.taskId !== "") {
      writer.uint32(10).string(message.taskId);
    }
    if (message.status !== 0) {
      writer.uint32(24).int32(message.status);
    }
    if (message.progress !== 0) {
      writer.uint32(32).int32(message.progress);
    }
    if (message.error !== undefined) {
      CommandError.encode(message.error, writer.uint32(42).fork()).join();
    }
    for (const v of message.warnings) {
      writer.uint32(50).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResponseHeader {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResponseHeader();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.taskId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.progress = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.error = CommandError.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.warnings.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ResponseHeader {
    return {
      taskId: isSet(object.taskId) ? globalThis.String(object.taskId) : "",
      status: isSet(object.status) ? taskStatusFromJSON(object.status) : 0,
      progress: isSet(object.progress) ? globalThis.Number(object.progress) : 0,
      error: isSet(object.error) ? CommandError.fromJSON(object.error) : undefined,
      warnings: globalThis.Array.isArray(object?.warnings) ? object.warnings.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: ResponseHeader): unknown {
    const obj: any = {};
    if (message.taskId !== "") {
      obj.taskId = message.taskId;
    }
    if (message.status !== 0) {
      obj.status = taskStatusToJSON(message.status);
    }
    if (message.progress !== 0) {
      obj.progress = Math.round(message.progress);
    }
    if (message.error !== undefined) {
      obj.error = CommandError.toJSON(message.error);
    }
    if (message.warnings?.length) {
      obj.warnings = message.warnings;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ResponseHeader>, I>>(base?: I): ResponseHeader {
    return ResponseHeader.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ResponseHeader>, I>>(object: I): ResponseHeader {
    const message = createBaseResponseHeader();
    message.taskId = object.taskId ?? "";
    message.status = object.status ?? 0;
    message.progress = object.progress ?? 0;
    message.error = (object.error !== undefined && object.error !== null)
      ? CommandError.fromPartial(object.error)
      : undefined;
    message.warnings = object.warnings?.map((e) => e) || [];
    return message;
  },
};

function createBaseTimestamp(): Timestamp {
  return { seconds: 0, nanos: 0 };
}

export const Timestamp: MessageFns<Timestamp> = {
  encode(message: Timestamp, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.seconds !== 0) {
      writer.uint32(8).int64(message.seconds);
    }
    if (message.nanos !== 0) {
      writer.uint32(16).int32(message.nanos);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Timestamp {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTimestamp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.seconds = longToNumber(reader.int64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.nanos = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Timestamp {
    return {
      seconds: isSet(object.seconds) ? globalThis.Number(object.seconds) : 0,
      nanos: isSet(object.nanos) ? globalThis.Number(object.nanos) : 0,
    };
  },

  toJSON(message: Timestamp): unknown {
    const obj: any = {};
    if (message.seconds !== 0) {
      obj.seconds = Math.round(message.seconds);
    }
    if (message.nanos !== 0) {
      obj.nanos = Math.round(message.nanos);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Timestamp>, I>>(base?: I): Timestamp {
    return Timestamp.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Timestamp>, I>>(object: I): Timestamp {
    const message = createBaseTimestamp();
    message.seconds = object.seconds ?? 0;
    message.nanos = object.nanos ?? 0;
    return message;
  },
};

function createBaseCommandError(): CommandError {
  return { commandErrorType: 0, commandErrorMessage: "", isWarning: false };
}

export const CommandError: MessageFns<CommandError> = {
  encode(message: CommandError, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.commandErrorType !== 0) {
      writer.uint32(8).int32(message.commandErrorType);
    }
    if (message.commandErrorMessage !== "") {
      writer.uint32(18).string(message.commandErrorMessage);
    }
    if (message.isWarning !== false) {
      writer.uint32(24).bool(message.isWarning);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CommandError {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommandError();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.commandErrorType = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.commandErrorMessage = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.isWarning = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CommandError {
    return {
      commandErrorType: isSet(object.commandErrorType) ? commandErrorTypeFromJSON(object.commandErrorType) : 0,
      commandErrorMessage: isSet(object.commandErrorMessage) ? globalThis.String(object.commandErrorMessage) : "",
      isWarning: isSet(object.isWarning) ? globalThis.Boolean(object.isWarning) : false,
    };
  },

  toJSON(message: CommandError): unknown {
    const obj: any = {};
    if (message.commandErrorType !== 0) {
      obj.commandErrorType = commandErrorTypeToJSON(message.commandErrorType);
    }
    if (message.commandErrorMessage !== "") {
      obj.commandErrorMessage = message.commandErrorMessage;
    }
    if (message.isWarning !== false) {
      obj.isWarning = message.isWarning;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CommandError>, I>>(base?: I): CommandError {
    return CommandError.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CommandError>, I>>(object: I): CommandError {
    const message = createBaseCommandError();
    message.commandErrorType = object.commandErrorType ?? 0;
    message.commandErrorMessage = object.commandErrorMessage ?? "";
    message.isWarning = object.isWarning ?? false;
    return message;
  },
};

function createBaseExportFileRequest(): ExportFileRequest {
  return { header: undefined, body: undefined };
}

export const ExportFileRequest: MessageFns<ExportFileRequest> = {
  encode(message: ExportFileRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      ExportFileRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExportFileRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExportFileRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = ExportFileRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExportFileRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? ExportFileRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: ExportFileRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = ExportFileRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExportFileRequest>, I>>(base?: I): ExportFileRequest {
    return ExportFileRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExportFileRequest>, I>>(object: I): ExportFileRequest {
    const message = createBaseExportFileRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? ExportFileRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseExportFileRequestBody(): ExportFileRequestBody {
  return { mobId: "", fileName: "", exportSettingsName: "", destinationPath: "", inDirectory: "", optionFlags: [] };
}

export const ExportFileRequestBody: MessageFns<ExportFileRequestBody> = {
  encode(message: ExportFileRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mobId !== "") {
      writer.uint32(10).string(message.mobId);
    }
    if (message.fileName !== "") {
      writer.uint32(18).string(message.fileName);
    }
    if (message.exportSettingsName !== "") {
      writer.uint32(26).string(message.exportSettingsName);
    }
    if (message.destinationPath !== "") {
      writer.uint32(34).string(message.destinationPath);
    }
    if (message.inDirectory !== "") {
      writer.uint32(42).string(message.inDirectory);
    }
    writer.uint32(50).fork();
    for (const v of message.optionFlags) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExportFileRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExportFileRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mobId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fileName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.exportSettingsName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.destinationPath = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.inDirectory = reader.string();
          continue;
        }
        case 6: {
          if (tag === 48) {
            message.optionFlags.push(reader.int32() as any);

            continue;
          }

          if (tag === 50) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.optionFlags.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExportFileRequestBody {
    return {
      mobId: isSet(object.mobId) ? globalThis.String(object.mobId) : "",
      fileName: isSet(object.fileName) ? globalThis.String(object.fileName) : "",
      exportSettingsName: isSet(object.exportSettingsName) ? globalThis.String(object.exportSettingsName) : "",
      destinationPath: isSet(object.destinationPath) ? globalThis.String(object.destinationPath) : "",
      inDirectory: isSet(object.inDirectory) ? globalThis.String(object.inDirectory) : "",
      optionFlags: globalThis.Array.isArray(object?.optionFlags)
        ? object.optionFlags.map((e: any) => exportFileOptionFromJSON(e))
        : [],
    };
  },

  toJSON(message: ExportFileRequestBody): unknown {
    const obj: any = {};
    if (message.mobId !== "") {
      obj.mobId = message.mobId;
    }
    if (message.fileName !== "") {
      obj.fileName = message.fileName;
    }
    if (message.exportSettingsName !== "") {
      obj.exportSettingsName = message.exportSettingsName;
    }
    if (message.destinationPath !== "") {
      obj.destinationPath = message.destinationPath;
    }
    if (message.inDirectory !== "") {
      obj.inDirectory = message.inDirectory;
    }
    if (message.optionFlags?.length) {
      obj.optionFlags = message.optionFlags.map((e) => exportFileOptionToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExportFileRequestBody>, I>>(base?: I): ExportFileRequestBody {
    return ExportFileRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExportFileRequestBody>, I>>(object: I): ExportFileRequestBody {
    const message = createBaseExportFileRequestBody();
    message.mobId = object.mobId ?? "";
    message.fileName = object.fileName ?? "";
    message.exportSettingsName = object.exportSettingsName ?? "";
    message.destinationPath = object.destinationPath ?? "";
    message.inDirectory = object.inDirectory ?? "";
    message.optionFlags = object.optionFlags?.map((e) => e) || [];
    return message;
  },
};

function createBaseExportFileResponse(): ExportFileResponse {
  return { header: undefined, body: undefined };
}

export const ExportFileResponse: MessageFns<ExportFileResponse> = {
  encode(message: ExportFileResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      ExportFileResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExportFileResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExportFileResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = ExportFileResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExportFileResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? ExportFileResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: ExportFileResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = ExportFileResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExportFileResponse>, I>>(base?: I): ExportFileResponse {
    return ExportFileResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExportFileResponse>, I>>(object: I): ExportFileResponse {
    const message = createBaseExportFileResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? ExportFileResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseExportFileResponseBody(): ExportFileResponseBody {
  return { path: "" };
}

export const ExportFileResponseBody: MessageFns<ExportFileResponseBody> = {
  encode(message: ExportFileResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.path !== "") {
      writer.uint32(10).string(message.path);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExportFileResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExportFileResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.path = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExportFileResponseBody {
    return { path: isSet(object.path) ? globalThis.String(object.path) : "" };
  },

  toJSON(message: ExportFileResponseBody): unknown {
    const obj: any = {};
    if (message.path !== "") {
      obj.path = message.path;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExportFileResponseBody>, I>>(base?: I): ExportFileResponseBody {
    return ExportFileResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExportFileResponseBody>, I>>(object: I): ExportFileResponseBody {
    const message = createBaseExportFileResponseBody();
    message.path = object.path ?? "";
    return message;
  },
};

function createBaseImportFileRequest(): ImportFileRequest {
  return { header: undefined, body: undefined };
}

export const ImportFileRequest: MessageFns<ImportFileRequest> = {
  encode(message: ImportFileRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      ImportFileRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImportFileRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImportFileRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = ImportFileRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImportFileRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? ImportFileRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: ImportFileRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = ImportFileRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ImportFileRequest>, I>>(base?: I): ImportFileRequest {
    return ImportFileRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ImportFileRequest>, I>>(object: I): ImportFileRequest {
    const message = createBaseImportFileRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? ImportFileRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseImportFileRequestBody(): ImportFileRequestBody {
  return {
    filePath: "",
    importSettingsName: "",
    destinationVideoDrive: "",
    destinationAudioDrive: "",
    compression: "",
    videoWrapperFormat: "",
    audioWrapperFormat: "",
    destinationBin: "",
    optionFlags: [],
  };
}

export const ImportFileRequestBody: MessageFns<ImportFileRequestBody> = {
  encode(message: ImportFileRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.filePath !== "") {
      writer.uint32(10).string(message.filePath);
    }
    if (message.importSettingsName !== "") {
      writer.uint32(18).string(message.importSettingsName);
    }
    if (message.destinationVideoDrive !== "") {
      writer.uint32(26).string(message.destinationVideoDrive);
    }
    if (message.destinationAudioDrive !== "") {
      writer.uint32(34).string(message.destinationAudioDrive);
    }
    if (message.compression !== "") {
      writer.uint32(42).string(message.compression);
    }
    if (message.videoWrapperFormat !== "") {
      writer.uint32(50).string(message.videoWrapperFormat);
    }
    if (message.audioWrapperFormat !== "") {
      writer.uint32(58).string(message.audioWrapperFormat);
    }
    if (message.destinationBin !== "") {
      writer.uint32(66).string(message.destinationBin);
    }
    writer.uint32(74).fork();
    for (const v of message.optionFlags) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImportFileRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImportFileRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.filePath = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.importSettingsName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.destinationVideoDrive = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.destinationAudioDrive = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.compression = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.videoWrapperFormat = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.audioWrapperFormat = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.destinationBin = reader.string();
          continue;
        }
        case 9: {
          if (tag === 72) {
            message.optionFlags.push(reader.int32() as any);

            continue;
          }

          if (tag === 74) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.optionFlags.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImportFileRequestBody {
    return {
      filePath: isSet(object.filePath) ? globalThis.String(object.filePath) : "",
      importSettingsName: isSet(object.importSettingsName) ? globalThis.String(object.importSettingsName) : "",
      destinationVideoDrive: isSet(object.destinationVideoDrive) ? globalThis.String(object.destinationVideoDrive) : "",
      destinationAudioDrive: isSet(object.destinationAudioDrive) ? globalThis.String(object.destinationAudioDrive) : "",
      compression: isSet(object.compression) ? globalThis.String(object.compression) : "",
      videoWrapperFormat: isSet(object.videoWrapperFormat) ? globalThis.String(object.videoWrapperFormat) : "",
      audioWrapperFormat: isSet(object.audioWrapperFormat) ? globalThis.String(object.audioWrapperFormat) : "",
      destinationBin: isSet(object.destinationBin) ? globalThis.String(object.destinationBin) : "",
      optionFlags: globalThis.Array.isArray(object?.optionFlags)
        ? object.optionFlags.map((e: any) => importFileOptionFromJSON(e))
        : [],
    };
  },

  toJSON(message: ImportFileRequestBody): unknown {
    const obj: any = {};
    if (message.filePath !== "") {
      obj.filePath = message.filePath;
    }
    if (message.importSettingsName !== "") {
      obj.importSettingsName = message.importSettingsName;
    }
    if (message.destinationVideoDrive !== "") {
      obj.destinationVideoDrive = message.destinationVideoDrive;
    }
    if (message.destinationAudioDrive !== "") {
      obj.destinationAudioDrive = message.destinationAudioDrive;
    }
    if (message.compression !== "") {
      obj.compression = message.compression;
    }
    if (message.videoWrapperFormat !== "") {
      obj.videoWrapperFormat = message.videoWrapperFormat;
    }
    if (message.audioWrapperFormat !== "") {
      obj.audioWrapperFormat = message.audioWrapperFormat;
    }
    if (message.destinationBin !== "") {
      obj.destinationBin = message.destinationBin;
    }
    if (message.optionFlags?.length) {
      obj.optionFlags = message.optionFlags.map((e) => importFileOptionToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ImportFileRequestBody>, I>>(base?: I): ImportFileRequestBody {
    return ImportFileRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ImportFileRequestBody>, I>>(object: I): ImportFileRequestBody {
    const message = createBaseImportFileRequestBody();
    message.filePath = object.filePath ?? "";
    message.importSettingsName = object.importSettingsName ?? "";
    message.destinationVideoDrive = object.destinationVideoDrive ?? "";
    message.destinationAudioDrive = object.destinationAudioDrive ?? "";
    message.compression = object.compression ?? "";
    message.videoWrapperFormat = object.videoWrapperFormat ?? "";
    message.audioWrapperFormat = object.audioWrapperFormat ?? "";
    message.destinationBin = object.destinationBin ?? "";
    message.optionFlags = object.optionFlags?.map((e) => e) || [];
    return message;
  },
};

function createBaseImportFileResponse(): ImportFileResponse {
  return { header: undefined, body: undefined };
}

export const ImportFileResponse: MessageFns<ImportFileResponse> = {
  encode(message: ImportFileResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      ImportFileResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImportFileResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImportFileResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = ImportFileResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImportFileResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? ImportFileResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: ImportFileResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = ImportFileResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ImportFileResponse>, I>>(base?: I): ImportFileResponse {
    return ImportFileResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ImportFileResponse>, I>>(object: I): ImportFileResponse {
    const message = createBaseImportFileResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? ImportFileResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseImportFileResponseBody(): ImportFileResponseBody {
  return { mobId: "" };
}

export const ImportFileResponseBody: MessageFns<ImportFileResponseBody> = {
  encode(message: ImportFileResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mobId !== "") {
      writer.uint32(10).string(message.mobId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImportFileResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImportFileResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mobId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImportFileResponseBody {
    return { mobId: isSet(object.mobId) ? globalThis.String(object.mobId) : "" };
  },

  toJSON(message: ImportFileResponseBody): unknown {
    const obj: any = {};
    if (message.mobId !== "") {
      obj.mobId = message.mobId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ImportFileResponseBody>, I>>(base?: I): ImportFileResponseBody {
    return ImportFileResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ImportFileResponseBody>, I>>(object: I): ImportFileResponseBody {
    const message = createBaseImportFileResponseBody();
    message.mobId = object.mobId ?? "";
    return message;
  },
};

function createBaseLoadSettingRequest(): LoadSettingRequest {
  return { header: undefined, body: undefined };
}

export const LoadSettingRequest: MessageFns<LoadSettingRequest> = {
  encode(message: LoadSettingRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      LoadSettingRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LoadSettingRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoadSettingRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = LoadSettingRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LoadSettingRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? LoadSettingRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: LoadSettingRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = LoadSettingRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LoadSettingRequest>, I>>(base?: I): LoadSettingRequest {
    return LoadSettingRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LoadSettingRequest>, I>>(object: I): LoadSettingRequest {
    const message = createBaseLoadSettingRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? LoadSettingRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseLoadSettingRequestBody(): LoadSettingRequestBody {
  return { uniqueId: "", xmlSetting: "" };
}

export const LoadSettingRequestBody: MessageFns<LoadSettingRequestBody> = {
  encode(message: LoadSettingRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.uniqueId !== "") {
      writer.uint32(10).string(message.uniqueId);
    }
    if (message.xmlSetting !== "") {
      writer.uint32(18).string(message.xmlSetting);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LoadSettingRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoadSettingRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.uniqueId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.xmlSetting = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LoadSettingRequestBody {
    return {
      uniqueId: isSet(object.uniqueId) ? globalThis.String(object.uniqueId) : "",
      xmlSetting: isSet(object.xmlSetting) ? globalThis.String(object.xmlSetting) : "",
    };
  },

  toJSON(message: LoadSettingRequestBody): unknown {
    const obj: any = {};
    if (message.uniqueId !== "") {
      obj.uniqueId = message.uniqueId;
    }
    if (message.xmlSetting !== "") {
      obj.xmlSetting = message.xmlSetting;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LoadSettingRequestBody>, I>>(base?: I): LoadSettingRequestBody {
    return LoadSettingRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LoadSettingRequestBody>, I>>(object: I): LoadSettingRequestBody {
    const message = createBaseLoadSettingRequestBody();
    message.uniqueId = object.uniqueId ?? "";
    message.xmlSetting = object.xmlSetting ?? "";
    return message;
  },
};

function createBaseLoadSettingResponse(): LoadSettingResponse {
  return { header: undefined };
}

export const LoadSettingResponse: MessageFns<LoadSettingResponse> = {
  encode(message: LoadSettingResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LoadSettingResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoadSettingResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LoadSettingResponse {
    return { header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined };
  },

  toJSON(message: LoadSettingResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LoadSettingResponse>, I>>(base?: I): LoadSettingResponse {
    return LoadSettingResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LoadSettingResponse>, I>>(object: I): LoadSettingResponse {
    const message = createBaseLoadSettingResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    return message;
  },
};

function createBaseGetListOfExportSettingsRequest(): GetListOfExportSettingsRequest {
  return { header: undefined, body: undefined };
}

export const GetListOfExportSettingsRequest: MessageFns<GetListOfExportSettingsRequest> = {
  encode(message: GetListOfExportSettingsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetListOfExportSettingsRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetListOfExportSettingsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetListOfExportSettingsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetListOfExportSettingsRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetListOfExportSettingsRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetListOfExportSettingsRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetListOfExportSettingsRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetListOfExportSettingsRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetListOfExportSettingsRequest>, I>>(base?: I): GetListOfExportSettingsRequest {
    return GetListOfExportSettingsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetListOfExportSettingsRequest>, I>>(
    object: I,
  ): GetListOfExportSettingsRequest {
    const message = createBaseGetListOfExportSettingsRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetListOfExportSettingsRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetListOfExportSettingsRequestBody(): GetListOfExportSettingsRequestBody {
  return {};
}

export const GetListOfExportSettingsRequestBody: MessageFns<GetListOfExportSettingsRequestBody> = {
  encode(_: GetListOfExportSettingsRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetListOfExportSettingsRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetListOfExportSettingsRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetListOfExportSettingsRequestBody {
    return {};
  },

  toJSON(_: GetListOfExportSettingsRequestBody): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetListOfExportSettingsRequestBody>, I>>(
    base?: I,
  ): GetListOfExportSettingsRequestBody {
    return GetListOfExportSettingsRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetListOfExportSettingsRequestBody>, I>>(
    _: I,
  ): GetListOfExportSettingsRequestBody {
    const message = createBaseGetListOfExportSettingsRequestBody();
    return message;
  },
};

function createBaseGetListOfExportSettingsResponse(): GetListOfExportSettingsResponse {
  return { header: undefined, body: undefined };
}

export const GetListOfExportSettingsResponse: MessageFns<GetListOfExportSettingsResponse> = {
  encode(message: GetListOfExportSettingsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetListOfExportSettingsResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetListOfExportSettingsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetListOfExportSettingsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetListOfExportSettingsResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetListOfExportSettingsResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetListOfExportSettingsResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetListOfExportSettingsResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetListOfExportSettingsResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetListOfExportSettingsResponse>, I>>(base?: I): GetListOfExportSettingsResponse {
    return GetListOfExportSettingsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetListOfExportSettingsResponse>, I>>(
    object: I,
  ): GetListOfExportSettingsResponse {
    const message = createBaseGetListOfExportSettingsResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetListOfExportSettingsResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetListOfExportSettingsResponseBody(): GetListOfExportSettingsResponseBody {
  return { settingNames: [] };
}

export const GetListOfExportSettingsResponseBody: MessageFns<GetListOfExportSettingsResponseBody> = {
  encode(message: GetListOfExportSettingsResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.settingNames) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetListOfExportSettingsResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetListOfExportSettingsResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.settingNames.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetListOfExportSettingsResponseBody {
    return {
      settingNames: globalThis.Array.isArray(object?.settingNames)
        ? object.settingNames.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: GetListOfExportSettingsResponseBody): unknown {
    const obj: any = {};
    if (message.settingNames?.length) {
      obj.settingNames = message.settingNames;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetListOfExportSettingsResponseBody>, I>>(
    base?: I,
  ): GetListOfExportSettingsResponseBody {
    return GetListOfExportSettingsResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetListOfExportSettingsResponseBody>, I>>(
    object: I,
  ): GetListOfExportSettingsResponseBody {
    const message = createBaseGetListOfExportSettingsResponseBody();
    message.settingNames = object.settingNames?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetListOfImportSettingsRequest(): GetListOfImportSettingsRequest {
  return { header: undefined, body: undefined };
}

export const GetListOfImportSettingsRequest: MessageFns<GetListOfImportSettingsRequest> = {
  encode(message: GetListOfImportSettingsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetListOfImportSettingsRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetListOfImportSettingsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetListOfImportSettingsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetListOfImportSettingsRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetListOfImportSettingsRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetListOfImportSettingsRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetListOfImportSettingsRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetListOfImportSettingsRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetListOfImportSettingsRequest>, I>>(base?: I): GetListOfImportSettingsRequest {
    return GetListOfImportSettingsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetListOfImportSettingsRequest>, I>>(
    object: I,
  ): GetListOfImportSettingsRequest {
    const message = createBaseGetListOfImportSettingsRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetListOfImportSettingsRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetListOfImportSettingsRequestBody(): GetListOfImportSettingsRequestBody {
  return {};
}

export const GetListOfImportSettingsRequestBody: MessageFns<GetListOfImportSettingsRequestBody> = {
  encode(_: GetListOfImportSettingsRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetListOfImportSettingsRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetListOfImportSettingsRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetListOfImportSettingsRequestBody {
    return {};
  },

  toJSON(_: GetListOfImportSettingsRequestBody): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetListOfImportSettingsRequestBody>, I>>(
    base?: I,
  ): GetListOfImportSettingsRequestBody {
    return GetListOfImportSettingsRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetListOfImportSettingsRequestBody>, I>>(
    _: I,
  ): GetListOfImportSettingsRequestBody {
    const message = createBaseGetListOfImportSettingsRequestBody();
    return message;
  },
};

function createBaseGetListOfImportSettingsResponse(): GetListOfImportSettingsResponse {
  return { header: undefined, body: undefined };
}

export const GetListOfImportSettingsResponse: MessageFns<GetListOfImportSettingsResponse> = {
  encode(message: GetListOfImportSettingsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetListOfImportSettingsResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetListOfImportSettingsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetListOfImportSettingsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetListOfImportSettingsResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetListOfImportSettingsResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetListOfImportSettingsResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetListOfImportSettingsResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetListOfImportSettingsResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetListOfImportSettingsResponse>, I>>(base?: I): GetListOfImportSettingsResponse {
    return GetListOfImportSettingsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetListOfImportSettingsResponse>, I>>(
    object: I,
  ): GetListOfImportSettingsResponse {
    const message = createBaseGetListOfImportSettingsResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetListOfImportSettingsResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetListOfImportSettingsResponseBody(): GetListOfImportSettingsResponseBody {
  return { settingNames: [] };
}

export const GetListOfImportSettingsResponseBody: MessageFns<GetListOfImportSettingsResponseBody> = {
  encode(message: GetListOfImportSettingsResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.settingNames) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetListOfImportSettingsResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetListOfImportSettingsResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.settingNames.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetListOfImportSettingsResponseBody {
    return {
      settingNames: globalThis.Array.isArray(object?.settingNames)
        ? object.settingNames.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: GetListOfImportSettingsResponseBody): unknown {
    const obj: any = {};
    if (message.settingNames?.length) {
      obj.settingNames = message.settingNames;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetListOfImportSettingsResponseBody>, I>>(
    base?: I,
  ): GetListOfImportSettingsResponseBody {
    return GetListOfImportSettingsResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetListOfImportSettingsResponseBody>, I>>(
    object: I,
  ): GetListOfImportSettingsResponseBody {
    const message = createBaseGetListOfImportSettingsResponseBody();
    message.settingNames = object.settingNames?.map((e) => e) || [];
    return message;
  },
};

function createBaseAddMarkerRequest(): AddMarkerRequest {
  return { header: undefined, body: undefined };
}

export const AddMarkerRequest: MessageFns<AddMarkerRequest> = {
  encode(message: AddMarkerRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      AddMarkerRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddMarkerRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddMarkerRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = AddMarkerRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddMarkerRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? AddMarkerRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: AddMarkerRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = AddMarkerRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddMarkerRequest>, I>>(base?: I): AddMarkerRequest {
    return AddMarkerRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddMarkerRequest>, I>>(object: I): AddMarkerRequest {
    const message = createBaseAddMarkerRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? AddMarkerRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseAddMarkerRequestBody(): AddMarkerRequestBody {
  return {
    mobId: "",
    trackLabel: undefined,
    offset: 0,
    timecode: "",
    length: 0,
    comment: "",
    color: 0,
    name: "",
    guid: "",
    user: "",
  };
}

export const AddMarkerRequestBody: MessageFns<AddMarkerRequestBody> = {
  encode(message: AddMarkerRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mobId !== "") {
      writer.uint32(10).string(message.mobId);
    }
    if (message.trackLabel !== undefined) {
      TrackLabel.encode(message.trackLabel, writer.uint32(18).fork()).join();
    }
    if (message.offset !== 0) {
      writer.uint32(24).int32(message.offset);
    }
    if (message.timecode !== "") {
      writer.uint32(34).string(message.timecode);
    }
    if (message.length !== 0) {
      writer.uint32(40).int32(message.length);
    }
    if (message.comment !== "") {
      writer.uint32(50).string(message.comment);
    }
    if (message.color !== 0) {
      writer.uint32(56).int32(message.color);
    }
    if (message.name !== "") {
      writer.uint32(66).string(message.name);
    }
    if (message.guid !== "") {
      writer.uint32(74).string(message.guid);
    }
    if (message.user !== "") {
      writer.uint32(82).string(message.user);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddMarkerRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddMarkerRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mobId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.trackLabel = TrackLabel.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.offset = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.timecode = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.length = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.comment = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.color = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.guid = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.user = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddMarkerRequestBody {
    return {
      mobId: isSet(object.mobId) ? globalThis.String(object.mobId) : "",
      trackLabel: isSet(object.trackLabel) ? TrackLabel.fromJSON(object.trackLabel) : undefined,
      offset: isSet(object.offset) ? globalThis.Number(object.offset) : 0,
      timecode: isSet(object.timecode) ? globalThis.String(object.timecode) : "",
      length: isSet(object.length) ? globalThis.Number(object.length) : 0,
      comment: isSet(object.comment) ? globalThis.String(object.comment) : "",
      color: isSet(object.color) ? markerColorFromJSON(object.color) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      guid: isSet(object.guid) ? globalThis.String(object.guid) : "",
      user: isSet(object.user) ? globalThis.String(object.user) : "",
    };
  },

  toJSON(message: AddMarkerRequestBody): unknown {
    const obj: any = {};
    if (message.mobId !== "") {
      obj.mobId = message.mobId;
    }
    if (message.trackLabel !== undefined) {
      obj.trackLabel = TrackLabel.toJSON(message.trackLabel);
    }
    if (message.offset !== 0) {
      obj.offset = Math.round(message.offset);
    }
    if (message.timecode !== "") {
      obj.timecode = message.timecode;
    }
    if (message.length !== 0) {
      obj.length = Math.round(message.length);
    }
    if (message.comment !== "") {
      obj.comment = message.comment;
    }
    if (message.color !== 0) {
      obj.color = markerColorToJSON(message.color);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.guid !== "") {
      obj.guid = message.guid;
    }
    if (message.user !== "") {
      obj.user = message.user;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddMarkerRequestBody>, I>>(base?: I): AddMarkerRequestBody {
    return AddMarkerRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddMarkerRequestBody>, I>>(object: I): AddMarkerRequestBody {
    const message = createBaseAddMarkerRequestBody();
    message.mobId = object.mobId ?? "";
    message.trackLabel = (object.trackLabel !== undefined && object.trackLabel !== null)
      ? TrackLabel.fromPartial(object.trackLabel)
      : undefined;
    message.offset = object.offset ?? 0;
    message.timecode = object.timecode ?? "";
    message.length = object.length ?? 0;
    message.comment = object.comment ?? "";
    message.color = object.color ?? 0;
    message.name = object.name ?? "";
    message.guid = object.guid ?? "";
    message.user = object.user ?? "";
    return message;
  },
};

function createBaseAddMarkerResponse(): AddMarkerResponse {
  return { header: undefined, body: undefined };
}

export const AddMarkerResponse: MessageFns<AddMarkerResponse> = {
  encode(message: AddMarkerResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      AddMarkerResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddMarkerResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddMarkerResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = AddMarkerResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddMarkerResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? AddMarkerResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: AddMarkerResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = AddMarkerResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddMarkerResponse>, I>>(base?: I): AddMarkerResponse {
    return AddMarkerResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddMarkerResponse>, I>>(object: I): AddMarkerResponse {
    const message = createBaseAddMarkerResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? AddMarkerResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseAddMarkerResponseBody(): AddMarkerResponseBody {
  return { guid: "" };
}

export const AddMarkerResponseBody: MessageFns<AddMarkerResponseBody> = {
  encode(message: AddMarkerResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.guid !== "") {
      writer.uint32(10).string(message.guid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddMarkerResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddMarkerResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.guid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddMarkerResponseBody {
    return { guid: isSet(object.guid) ? globalThis.String(object.guid) : "" };
  },

  toJSON(message: AddMarkerResponseBody): unknown {
    const obj: any = {};
    if (message.guid !== "") {
      obj.guid = message.guid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddMarkerResponseBody>, I>>(base?: I): AddMarkerResponseBody {
    return AddMarkerResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddMarkerResponseBody>, I>>(object: I): AddMarkerResponseBody {
    const message = createBaseAddMarkerResponseBody();
    message.guid = object.guid ?? "";
    return message;
  },
};

function createBaseLoadMobsIntoViewerRequest(): LoadMobsIntoViewerRequest {
  return { header: undefined, body: undefined };
}

export const LoadMobsIntoViewerRequest: MessageFns<LoadMobsIntoViewerRequest> = {
  encode(message: LoadMobsIntoViewerRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      LoadMobsIntoViewerRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LoadMobsIntoViewerRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoadMobsIntoViewerRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = LoadMobsIntoViewerRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LoadMobsIntoViewerRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? LoadMobsIntoViewerRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: LoadMobsIntoViewerRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = LoadMobsIntoViewerRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LoadMobsIntoViewerRequest>, I>>(base?: I): LoadMobsIntoViewerRequest {
    return LoadMobsIntoViewerRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LoadMobsIntoViewerRequest>, I>>(object: I): LoadMobsIntoViewerRequest {
    const message = createBaseLoadMobsIntoViewerRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? LoadMobsIntoViewerRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseLoadMobsIntoViewerRequestBody(): LoadMobsIntoViewerRequestBody {
  return { mobIds: [], viewType: 0 };
}

export const LoadMobsIntoViewerRequestBody: MessageFns<LoadMobsIntoViewerRequestBody> = {
  encode(message: LoadMobsIntoViewerRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.mobIds) {
      writer.uint32(10).string(v!);
    }
    if (message.viewType !== 0) {
      writer.uint32(16).int32(message.viewType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LoadMobsIntoViewerRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoadMobsIntoViewerRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mobIds.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.viewType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LoadMobsIntoViewerRequestBody {
    return {
      mobIds: globalThis.Array.isArray(object?.mobIds) ? object.mobIds.map((e: any) => globalThis.String(e)) : [],
      viewType: isSet(object.viewType) ? viewerTypeFromJSON(object.viewType) : 0,
    };
  },

  toJSON(message: LoadMobsIntoViewerRequestBody): unknown {
    const obj: any = {};
    if (message.mobIds?.length) {
      obj.mobIds = message.mobIds;
    }
    if (message.viewType !== 0) {
      obj.viewType = viewerTypeToJSON(message.viewType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LoadMobsIntoViewerRequestBody>, I>>(base?: I): LoadMobsIntoViewerRequestBody {
    return LoadMobsIntoViewerRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LoadMobsIntoViewerRequestBody>, I>>(
    object: I,
  ): LoadMobsIntoViewerRequestBody {
    const message = createBaseLoadMobsIntoViewerRequestBody();
    message.mobIds = object.mobIds?.map((e) => e) || [];
    message.viewType = object.viewType ?? 0;
    return message;
  },
};

function createBaseLoadMobsIntoViewerResponse(): LoadMobsIntoViewerResponse {
  return { header: undefined, body: undefined };
}

export const LoadMobsIntoViewerResponse: MessageFns<LoadMobsIntoViewerResponse> = {
  encode(message: LoadMobsIntoViewerResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      LoadMobsIntoViewerResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LoadMobsIntoViewerResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoadMobsIntoViewerResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = LoadMobsIntoViewerResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LoadMobsIntoViewerResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? LoadMobsIntoViewerResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: LoadMobsIntoViewerResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = LoadMobsIntoViewerResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LoadMobsIntoViewerResponse>, I>>(base?: I): LoadMobsIntoViewerResponse {
    return LoadMobsIntoViewerResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LoadMobsIntoViewerResponse>, I>>(object: I): LoadMobsIntoViewerResponse {
    const message = createBaseLoadMobsIntoViewerResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? LoadMobsIntoViewerResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseLoadMobsIntoViewerResponseBody(): LoadMobsIntoViewerResponseBody {
  return {};
}

export const LoadMobsIntoViewerResponseBody: MessageFns<LoadMobsIntoViewerResponseBody> = {
  encode(_: LoadMobsIntoViewerResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LoadMobsIntoViewerResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoadMobsIntoViewerResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): LoadMobsIntoViewerResponseBody {
    return {};
  },

  toJSON(_: LoadMobsIntoViewerResponseBody): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<LoadMobsIntoViewerResponseBody>, I>>(base?: I): LoadMobsIntoViewerResponseBody {
    return LoadMobsIntoViewerResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LoadMobsIntoViewerResponseBody>, I>>(_: I): LoadMobsIntoViewerResponseBody {
    const message = createBaseLoadMobsIntoViewerResponseBody();
    return message;
  },
};

function createBaseSelectMobsInBinRequest(): SelectMobsInBinRequest {
  return { header: undefined, body: undefined };
}

export const SelectMobsInBinRequest: MessageFns<SelectMobsInBinRequest> = {
  encode(message: SelectMobsInBinRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      SelectMobsInBinRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SelectMobsInBinRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSelectMobsInBinRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = SelectMobsInBinRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SelectMobsInBinRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? SelectMobsInBinRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: SelectMobsInBinRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = SelectMobsInBinRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SelectMobsInBinRequest>, I>>(base?: I): SelectMobsInBinRequest {
    return SelectMobsInBinRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SelectMobsInBinRequest>, I>>(object: I): SelectMobsInBinRequest {
    const message = createBaseSelectMobsInBinRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? SelectMobsInBinRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseSelectMobsInBinRequestBody(): SelectMobsInBinRequestBody {
  return { binPath: "", mobIds: [], addToSelection: false };
}

export const SelectMobsInBinRequestBody: MessageFns<SelectMobsInBinRequestBody> = {
  encode(message: SelectMobsInBinRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.binPath !== "") {
      writer.uint32(10).string(message.binPath);
    }
    for (const v of message.mobIds) {
      writer.uint32(18).string(v!);
    }
    if (message.addToSelection !== false) {
      writer.uint32(24).bool(message.addToSelection);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SelectMobsInBinRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSelectMobsInBinRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.binPath = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.mobIds.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.addToSelection = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SelectMobsInBinRequestBody {
    return {
      binPath: isSet(object.binPath) ? globalThis.String(object.binPath) : "",
      mobIds: globalThis.Array.isArray(object?.mobIds) ? object.mobIds.map((e: any) => globalThis.String(e)) : [],
      addToSelection: isSet(object.addToSelection) ? globalThis.Boolean(object.addToSelection) : false,
    };
  },

  toJSON(message: SelectMobsInBinRequestBody): unknown {
    const obj: any = {};
    if (message.binPath !== "") {
      obj.binPath = message.binPath;
    }
    if (message.mobIds?.length) {
      obj.mobIds = message.mobIds;
    }
    if (message.addToSelection !== false) {
      obj.addToSelection = message.addToSelection;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SelectMobsInBinRequestBody>, I>>(base?: I): SelectMobsInBinRequestBody {
    return SelectMobsInBinRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SelectMobsInBinRequestBody>, I>>(object: I): SelectMobsInBinRequestBody {
    const message = createBaseSelectMobsInBinRequestBody();
    message.binPath = object.binPath ?? "";
    message.mobIds = object.mobIds?.map((e) => e) || [];
    message.addToSelection = object.addToSelection ?? false;
    return message;
  },
};

function createBaseSelectMobsInBinResponse(): SelectMobsInBinResponse {
  return { header: undefined, body: undefined };
}

export const SelectMobsInBinResponse: MessageFns<SelectMobsInBinResponse> = {
  encode(message: SelectMobsInBinResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      SelectMobsInBinResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SelectMobsInBinResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSelectMobsInBinResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = SelectMobsInBinResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SelectMobsInBinResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? SelectMobsInBinResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: SelectMobsInBinResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = SelectMobsInBinResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SelectMobsInBinResponse>, I>>(base?: I): SelectMobsInBinResponse {
    return SelectMobsInBinResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SelectMobsInBinResponse>, I>>(object: I): SelectMobsInBinResponse {
    const message = createBaseSelectMobsInBinResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? SelectMobsInBinResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseSelectMobsInBinResponseBody(): SelectMobsInBinResponseBody {
  return { selectedMobIds: [] };
}

export const SelectMobsInBinResponseBody: MessageFns<SelectMobsInBinResponseBody> = {
  encode(message: SelectMobsInBinResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.selectedMobIds) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SelectMobsInBinResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSelectMobsInBinResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.selectedMobIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SelectMobsInBinResponseBody {
    return {
      selectedMobIds: globalThis.Array.isArray(object?.selectedMobIds)
        ? object.selectedMobIds.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: SelectMobsInBinResponseBody): unknown {
    const obj: any = {};
    if (message.selectedMobIds?.length) {
      obj.selectedMobIds = message.selectedMobIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SelectMobsInBinResponseBody>, I>>(base?: I): SelectMobsInBinResponseBody {
    return SelectMobsInBinResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SelectMobsInBinResponseBody>, I>>(object: I): SelectMobsInBinResponseBody {
    const message = createBaseSelectMobsInBinResponseBody();
    message.selectedMobIds = object.selectedMobIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetViewerMobsRequest(): GetViewerMobsRequest {
  return { header: undefined, body: undefined };
}

export const GetViewerMobsRequest: MessageFns<GetViewerMobsRequest> = {
  encode(message: GetViewerMobsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetViewerMobsRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetViewerMobsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetViewerMobsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetViewerMobsRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetViewerMobsRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetViewerMobsRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetViewerMobsRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetViewerMobsRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetViewerMobsRequest>, I>>(base?: I): GetViewerMobsRequest {
    return GetViewerMobsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetViewerMobsRequest>, I>>(object: I): GetViewerMobsRequest {
    const message = createBaseGetViewerMobsRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetViewerMobsRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetViewerMobsRequestBody(): GetViewerMobsRequestBody {
  return {};
}

export const GetViewerMobsRequestBody: MessageFns<GetViewerMobsRequestBody> = {
  encode(_: GetViewerMobsRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetViewerMobsRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetViewerMobsRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetViewerMobsRequestBody {
    return {};
  },

  toJSON(_: GetViewerMobsRequestBody): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetViewerMobsRequestBody>, I>>(base?: I): GetViewerMobsRequestBody {
    return GetViewerMobsRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetViewerMobsRequestBody>, I>>(_: I): GetViewerMobsRequestBody {
    const message = createBaseGetViewerMobsRequestBody();
    return message;
  },
};

function createBaseGetViewerMobsResponse(): GetViewerMobsResponse {
  return { header: undefined, body: undefined };
}

export const GetViewerMobsResponse: MessageFns<GetViewerMobsResponse> = {
  encode(message: GetViewerMobsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetViewerMobsResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetViewerMobsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetViewerMobsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetViewerMobsResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetViewerMobsResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetViewerMobsResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetViewerMobsResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetViewerMobsResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetViewerMobsResponse>, I>>(base?: I): GetViewerMobsResponse {
    return GetViewerMobsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetViewerMobsResponse>, I>>(object: I): GetViewerMobsResponse {
    const message = createBaseGetViewerMobsResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetViewerMobsResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseMobInViewer(): MobInViewer {
  return { mobId: "", viewType: 0, currentFrame: 0, currentTimecode: "" };
}

export const MobInViewer: MessageFns<MobInViewer> = {
  encode(message: MobInViewer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mobId !== "") {
      writer.uint32(10).string(message.mobId);
    }
    if (message.viewType !== 0) {
      writer.uint32(16).int32(message.viewType);
    }
    if (message.currentFrame !== 0) {
      writer.uint32(24).int32(message.currentFrame);
    }
    if (message.currentTimecode !== "") {
      writer.uint32(34).string(message.currentTimecode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MobInViewer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMobInViewer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mobId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.viewType = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.currentFrame = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.currentTimecode = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MobInViewer {
    return {
      mobId: isSet(object.mobId) ? globalThis.String(object.mobId) : "",
      viewType: isSet(object.viewType) ? viewerTypeFromJSON(object.viewType) : 0,
      currentFrame: isSet(object.currentFrame) ? globalThis.Number(object.currentFrame) : 0,
      currentTimecode: isSet(object.currentTimecode) ? globalThis.String(object.currentTimecode) : "",
    };
  },

  toJSON(message: MobInViewer): unknown {
    const obj: any = {};
    if (message.mobId !== "") {
      obj.mobId = message.mobId;
    }
    if (message.viewType !== 0) {
      obj.viewType = viewerTypeToJSON(message.viewType);
    }
    if (message.currentFrame !== 0) {
      obj.currentFrame = Math.round(message.currentFrame);
    }
    if (message.currentTimecode !== "") {
      obj.currentTimecode = message.currentTimecode;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MobInViewer>, I>>(base?: I): MobInViewer {
    return MobInViewer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MobInViewer>, I>>(object: I): MobInViewer {
    const message = createBaseMobInViewer();
    message.mobId = object.mobId ?? "";
    message.viewType = object.viewType ?? 0;
    message.currentFrame = object.currentFrame ?? 0;
    message.currentTimecode = object.currentTimecode ?? "";
    return message;
  },
};

function createBaseGetViewerMobsResponseBody(): GetViewerMobsResponseBody {
  return { mobs: [] };
}

export const GetViewerMobsResponseBody: MessageFns<GetViewerMobsResponseBody> = {
  encode(message: GetViewerMobsResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.mobs) {
      MobInViewer.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetViewerMobsResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetViewerMobsResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mobs.push(MobInViewer.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetViewerMobsResponseBody {
    return { mobs: globalThis.Array.isArray(object?.mobs) ? object.mobs.map((e: any) => MobInViewer.fromJSON(e)) : [] };
  },

  toJSON(message: GetViewerMobsResponseBody): unknown {
    const obj: any = {};
    if (message.mobs?.length) {
      obj.mobs = message.mobs.map((e) => MobInViewer.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetViewerMobsResponseBody>, I>>(base?: I): GetViewerMobsResponseBody {
    return GetViewerMobsResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetViewerMobsResponseBody>, I>>(object: I): GetViewerMobsResponseBody {
    const message = createBaseGetViewerMobsResponseBody();
    message.mobs = object.mobs?.map((e) => MobInViewer.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetBinFromMobRequest(): GetBinFromMobRequest {
  return { header: undefined, body: undefined };
}

export const GetBinFromMobRequest: MessageFns<GetBinFromMobRequest> = {
  encode(message: GetBinFromMobRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetBinFromMobRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetBinFromMobRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBinFromMobRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetBinFromMobRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBinFromMobRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetBinFromMobRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetBinFromMobRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetBinFromMobRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBinFromMobRequest>, I>>(base?: I): GetBinFromMobRequest {
    return GetBinFromMobRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBinFromMobRequest>, I>>(object: I): GetBinFromMobRequest {
    const message = createBaseGetBinFromMobRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetBinFromMobRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetBinFromMobRequestBody(): GetBinFromMobRequestBody {
  return { mobId: "" };
}

export const GetBinFromMobRequestBody: MessageFns<GetBinFromMobRequestBody> = {
  encode(message: GetBinFromMobRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mobId !== "") {
      writer.uint32(10).string(message.mobId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetBinFromMobRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBinFromMobRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mobId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBinFromMobRequestBody {
    return { mobId: isSet(object.mobId) ? globalThis.String(object.mobId) : "" };
  },

  toJSON(message: GetBinFromMobRequestBody): unknown {
    const obj: any = {};
    if (message.mobId !== "") {
      obj.mobId = message.mobId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBinFromMobRequestBody>, I>>(base?: I): GetBinFromMobRequestBody {
    return GetBinFromMobRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBinFromMobRequestBody>, I>>(object: I): GetBinFromMobRequestBody {
    const message = createBaseGetBinFromMobRequestBody();
    message.mobId = object.mobId ?? "";
    return message;
  },
};

function createBaseGetBinFromMobResponse(): GetBinFromMobResponse {
  return { header: undefined, body: undefined };
}

export const GetBinFromMobResponse: MessageFns<GetBinFromMobResponse> = {
  encode(message: GetBinFromMobResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetBinFromMobResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetBinFromMobResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBinFromMobResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetBinFromMobResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBinFromMobResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetBinFromMobResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetBinFromMobResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetBinFromMobResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBinFromMobResponse>, I>>(base?: I): GetBinFromMobResponse {
    return GetBinFromMobResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBinFromMobResponse>, I>>(object: I): GetBinFromMobResponse {
    const message = createBaseGetBinFromMobResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetBinFromMobResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetBinFromMobResponseBody(): GetBinFromMobResponseBody {
  return { absolutePath: "" };
}

export const GetBinFromMobResponseBody: MessageFns<GetBinFromMobResponseBody> = {
  encode(message: GetBinFromMobResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.absolutePath !== "") {
      writer.uint32(10).string(message.absolutePath);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetBinFromMobResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBinFromMobResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.absolutePath = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBinFromMobResponseBody {
    return { absolutePath: isSet(object.absolutePath) ? globalThis.String(object.absolutePath) : "" };
  },

  toJSON(message: GetBinFromMobResponseBody): unknown {
    const obj: any = {};
    if (message.absolutePath !== "") {
      obj.absolutePath = message.absolutePath;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBinFromMobResponseBody>, I>>(base?: I): GetBinFromMobResponseBody {
    return GetBinFromMobResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBinFromMobResponseBody>, I>>(object: I): GetBinFromMobResponseBody {
    const message = createBaseGetBinFromMobResponseBody();
    message.absolutePath = object.absolutePath ?? "";
    return message;
  },
};

function createBaseAddMarkersRequest(): AddMarkersRequest {
  return { header: undefined, body: undefined };
}

export const AddMarkersRequest: MessageFns<AddMarkersRequest> = {
  encode(message: AddMarkersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      AddMarkersRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddMarkersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddMarkersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = AddMarkersRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddMarkersRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? AddMarkersRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: AddMarkersRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = AddMarkersRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddMarkersRequest>, I>>(base?: I): AddMarkersRequest {
    return AddMarkersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddMarkersRequest>, I>>(object: I): AddMarkersRequest {
    const message = createBaseAddMarkersRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? AddMarkersRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseRequestMarkerInfo(): RequestMarkerInfo {
  return {
    name: "",
    trackLabel: undefined,
    offset: 0,
    timecode: "",
    length: 0,
    comment: "",
    color: 0,
    guid: "",
    user: "",
  };
}

export const RequestMarkerInfo: MessageFns<RequestMarkerInfo> = {
  encode(message: RequestMarkerInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.trackLabel !== undefined) {
      TrackLabel.encode(message.trackLabel, writer.uint32(18).fork()).join();
    }
    if (message.offset !== 0) {
      writer.uint32(24).int32(message.offset);
    }
    if (message.timecode !== "") {
      writer.uint32(34).string(message.timecode);
    }
    if (message.length !== 0) {
      writer.uint32(40).int32(message.length);
    }
    if (message.comment !== "") {
      writer.uint32(50).string(message.comment);
    }
    if (message.color !== 0) {
      writer.uint32(56).int32(message.color);
    }
    if (message.guid !== "") {
      writer.uint32(66).string(message.guid);
    }
    if (message.user !== "") {
      writer.uint32(74).string(message.user);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RequestMarkerInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestMarkerInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.trackLabel = TrackLabel.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.offset = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.timecode = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.length = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.comment = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.color = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.guid = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.user = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RequestMarkerInfo {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      trackLabel: isSet(object.trackLabel) ? TrackLabel.fromJSON(object.trackLabel) : undefined,
      offset: isSet(object.offset) ? globalThis.Number(object.offset) : 0,
      timecode: isSet(object.timecode) ? globalThis.String(object.timecode) : "",
      length: isSet(object.length) ? globalThis.Number(object.length) : 0,
      comment: isSet(object.comment) ? globalThis.String(object.comment) : "",
      color: isSet(object.color) ? markerColorFromJSON(object.color) : 0,
      guid: isSet(object.guid) ? globalThis.String(object.guid) : "",
      user: isSet(object.user) ? globalThis.String(object.user) : "",
    };
  },

  toJSON(message: RequestMarkerInfo): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.trackLabel !== undefined) {
      obj.trackLabel = TrackLabel.toJSON(message.trackLabel);
    }
    if (message.offset !== 0) {
      obj.offset = Math.round(message.offset);
    }
    if (message.timecode !== "") {
      obj.timecode = message.timecode;
    }
    if (message.length !== 0) {
      obj.length = Math.round(message.length);
    }
    if (message.comment !== "") {
      obj.comment = message.comment;
    }
    if (message.color !== 0) {
      obj.color = markerColorToJSON(message.color);
    }
    if (message.guid !== "") {
      obj.guid = message.guid;
    }
    if (message.user !== "") {
      obj.user = message.user;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RequestMarkerInfo>, I>>(base?: I): RequestMarkerInfo {
    return RequestMarkerInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RequestMarkerInfo>, I>>(object: I): RequestMarkerInfo {
    const message = createBaseRequestMarkerInfo();
    message.name = object.name ?? "";
    message.trackLabel = (object.trackLabel !== undefined && object.trackLabel !== null)
      ? TrackLabel.fromPartial(object.trackLabel)
      : undefined;
    message.offset = object.offset ?? 0;
    message.timecode = object.timecode ?? "";
    message.length = object.length ?? 0;
    message.comment = object.comment ?? "";
    message.color = object.color ?? 0;
    message.guid = object.guid ?? "";
    message.user = object.user ?? "";
    return message;
  },
};

function createBaseAddMarkersRequestBody(): AddMarkersRequestBody {
  return { mobId: "", info: [] };
}

export const AddMarkersRequestBody: MessageFns<AddMarkersRequestBody> = {
  encode(message: AddMarkersRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mobId !== "") {
      writer.uint32(10).string(message.mobId);
    }
    for (const v of message.info) {
      RequestMarkerInfo.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddMarkersRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddMarkersRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mobId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.info.push(RequestMarkerInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddMarkersRequestBody {
    return {
      mobId: isSet(object.mobId) ? globalThis.String(object.mobId) : "",
      info: globalThis.Array.isArray(object?.info) ? object.info.map((e: any) => RequestMarkerInfo.fromJSON(e)) : [],
    };
  },

  toJSON(message: AddMarkersRequestBody): unknown {
    const obj: any = {};
    if (message.mobId !== "") {
      obj.mobId = message.mobId;
    }
    if (message.info?.length) {
      obj.info = message.info.map((e) => RequestMarkerInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddMarkersRequestBody>, I>>(base?: I): AddMarkersRequestBody {
    return AddMarkersRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddMarkersRequestBody>, I>>(object: I): AddMarkersRequestBody {
    const message = createBaseAddMarkersRequestBody();
    message.mobId = object.mobId ?? "";
    message.info = object.info?.map((e) => RequestMarkerInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAddMarkersResponse(): AddMarkersResponse {
  return { header: undefined, body: undefined };
}

export const AddMarkersResponse: MessageFns<AddMarkersResponse> = {
  encode(message: AddMarkersResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      AddMarkersResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddMarkersResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddMarkersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = AddMarkersResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddMarkersResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? AddMarkersResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: AddMarkersResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = AddMarkersResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddMarkersResponse>, I>>(base?: I): AddMarkersResponse {
    return AddMarkersResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddMarkersResponse>, I>>(object: I): AddMarkersResponse {
    const message = createBaseAddMarkersResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? AddMarkersResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseAddMarkersResponseBody(): AddMarkersResponseBody {
  return {};
}

export const AddMarkersResponseBody: MessageFns<AddMarkersResponseBody> = {
  encode(_: AddMarkersResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddMarkersResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddMarkersResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): AddMarkersResponseBody {
    return {};
  },

  toJSON(_: AddMarkersResponseBody): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<AddMarkersResponseBody>, I>>(base?: I): AddMarkersResponseBody {
    return AddMarkersResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddMarkersResponseBody>, I>>(_: I): AddMarkersResponseBody {
    const message = createBaseAddMarkersResponseBody();
    return message;
  },
};

function createBaseGetMarkersRequest(): GetMarkersRequest {
  return { header: undefined, body: undefined };
}

export const GetMarkersRequest: MessageFns<GetMarkersRequest> = {
  encode(message: GetMarkersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetMarkersRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMarkersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMarkersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetMarkersRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMarkersRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetMarkersRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetMarkersRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetMarkersRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMarkersRequest>, I>>(base?: I): GetMarkersRequest {
    return GetMarkersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMarkersRequest>, I>>(object: I): GetMarkersRequest {
    const message = createBaseGetMarkersRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetMarkersRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetMarkersRequestBody(): GetMarkersRequestBody {
  return { mobId: "", guid: "", offset: undefined, timecode: undefined, track: undefined };
}

export const GetMarkersRequestBody: MessageFns<GetMarkersRequestBody> = {
  encode(message: GetMarkersRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mobId !== "") {
      writer.uint32(10).string(message.mobId);
    }
    if (message.guid !== "") {
      writer.uint32(18).string(message.guid);
    }
    if (message.offset !== undefined) {
      GetMarkersRequestBody_offsetFilter.encode(message.offset, writer.uint32(26).fork()).join();
    }
    if (message.timecode !== undefined) {
      GetMarkersRequestBody_tcFilter.encode(message.timecode, writer.uint32(34).fork()).join();
    }
    if (message.track !== undefined) {
      TrackLabel.encode(message.track, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMarkersRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMarkersRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mobId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.guid = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.offset = GetMarkersRequestBody_offsetFilter.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.timecode = GetMarkersRequestBody_tcFilter.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.track = TrackLabel.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMarkersRequestBody {
    return {
      mobId: isSet(object.mobId) ? globalThis.String(object.mobId) : "",
      guid: isSet(object.guid) ? globalThis.String(object.guid) : "",
      offset: isSet(object.offset) ? GetMarkersRequestBody_offsetFilter.fromJSON(object.offset) : undefined,
      timecode: isSet(object.timecode) ? GetMarkersRequestBody_tcFilter.fromJSON(object.timecode) : undefined,
      track: isSet(object.track) ? TrackLabel.fromJSON(object.track) : undefined,
    };
  },

  toJSON(message: GetMarkersRequestBody): unknown {
    const obj: any = {};
    if (message.mobId !== "") {
      obj.mobId = message.mobId;
    }
    if (message.guid !== "") {
      obj.guid = message.guid;
    }
    if (message.offset !== undefined) {
      obj.offset = GetMarkersRequestBody_offsetFilter.toJSON(message.offset);
    }
    if (message.timecode !== undefined) {
      obj.timecode = GetMarkersRequestBody_tcFilter.toJSON(message.timecode);
    }
    if (message.track !== undefined) {
      obj.track = TrackLabel.toJSON(message.track);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMarkersRequestBody>, I>>(base?: I): GetMarkersRequestBody {
    return GetMarkersRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMarkersRequestBody>, I>>(object: I): GetMarkersRequestBody {
    const message = createBaseGetMarkersRequestBody();
    message.mobId = object.mobId ?? "";
    message.guid = object.guid ?? "";
    message.offset = (object.offset !== undefined && object.offset !== null)
      ? GetMarkersRequestBody_offsetFilter.fromPartial(object.offset)
      : undefined;
    message.timecode = (object.timecode !== undefined && object.timecode !== null)
      ? GetMarkersRequestBody_tcFilter.fromPartial(object.timecode)
      : undefined;
    message.track = (object.track !== undefined && object.track !== null)
      ? TrackLabel.fromPartial(object.track)
      : undefined;
    return message;
  },
};

function createBaseGetMarkersRequestBody_offsetFilter(): GetMarkersRequestBody_offsetFilter {
  return { frame: 0, length: 0 };
}

export const GetMarkersRequestBody_offsetFilter: MessageFns<GetMarkersRequestBody_offsetFilter> = {
  encode(message: GetMarkersRequestBody_offsetFilter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.frame !== 0) {
      writer.uint32(8).int32(message.frame);
    }
    if (message.length !== 0) {
      writer.uint32(16).int32(message.length);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMarkersRequestBody_offsetFilter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMarkersRequestBody_offsetFilter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.frame = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.length = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMarkersRequestBody_offsetFilter {
    return {
      frame: isSet(object.frame) ? globalThis.Number(object.frame) : 0,
      length: isSet(object.length) ? globalThis.Number(object.length) : 0,
    };
  },

  toJSON(message: GetMarkersRequestBody_offsetFilter): unknown {
    const obj: any = {};
    if (message.frame !== 0) {
      obj.frame = Math.round(message.frame);
    }
    if (message.length !== 0) {
      obj.length = Math.round(message.length);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMarkersRequestBody_offsetFilter>, I>>(
    base?: I,
  ): GetMarkersRequestBody_offsetFilter {
    return GetMarkersRequestBody_offsetFilter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMarkersRequestBody_offsetFilter>, I>>(
    object: I,
  ): GetMarkersRequestBody_offsetFilter {
    const message = createBaseGetMarkersRequestBody_offsetFilter();
    message.frame = object.frame ?? 0;
    message.length = object.length ?? 0;
    return message;
  },
};

function createBaseGetMarkersRequestBody_tcFilter(): GetMarkersRequestBody_tcFilter {
  return { start: "", duration: "" };
}

export const GetMarkersRequestBody_tcFilter: MessageFns<GetMarkersRequestBody_tcFilter> = {
  encode(message: GetMarkersRequestBody_tcFilter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.start !== "") {
      writer.uint32(10).string(message.start);
    }
    if (message.duration !== "") {
      writer.uint32(18).string(message.duration);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMarkersRequestBody_tcFilter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMarkersRequestBody_tcFilter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.start = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.duration = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMarkersRequestBody_tcFilter {
    return {
      start: isSet(object.start) ? globalThis.String(object.start) : "",
      duration: isSet(object.duration) ? globalThis.String(object.duration) : "",
    };
  },

  toJSON(message: GetMarkersRequestBody_tcFilter): unknown {
    const obj: any = {};
    if (message.start !== "") {
      obj.start = message.start;
    }
    if (message.duration !== "") {
      obj.duration = message.duration;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMarkersRequestBody_tcFilter>, I>>(base?: I): GetMarkersRequestBody_tcFilter {
    return GetMarkersRequestBody_tcFilter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMarkersRequestBody_tcFilter>, I>>(
    object: I,
  ): GetMarkersRequestBody_tcFilter {
    const message = createBaseGetMarkersRequestBody_tcFilter();
    message.start = object.start ?? "";
    message.duration = object.duration ?? "";
    return message;
  },
};

function createBaseGetMarkersResponse(): GetMarkersResponse {
  return { header: undefined, body: undefined };
}

export const GetMarkersResponse: MessageFns<GetMarkersResponse> = {
  encode(message: GetMarkersResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetMarkersResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMarkersResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMarkersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetMarkersResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMarkersResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetMarkersResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetMarkersResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetMarkersResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMarkersResponse>, I>>(base?: I): GetMarkersResponse {
    return GetMarkersResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMarkersResponse>, I>>(object: I): GetMarkersResponse {
    const message = createBaseGetMarkersResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetMarkersResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseResponseMarkerInfo(): ResponseMarkerInfo {
  return {
    name: "",
    trackLabel: undefined,
    offset: 0,
    timecode: "",
    length: 0,
    comment: "",
    color: 0,
    creationDate: undefined,
    guid: "",
    user: "",
  };
}

export const ResponseMarkerInfo: MessageFns<ResponseMarkerInfo> = {
  encode(message: ResponseMarkerInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.trackLabel !== undefined) {
      TrackLabel.encode(message.trackLabel, writer.uint32(18).fork()).join();
    }
    if (message.offset !== 0) {
      writer.uint32(24).int32(message.offset);
    }
    if (message.timecode !== "") {
      writer.uint32(34).string(message.timecode);
    }
    if (message.length !== 0) {
      writer.uint32(40).int32(message.length);
    }
    if (message.comment !== "") {
      writer.uint32(50).string(message.comment);
    }
    if (message.color !== 0) {
      writer.uint32(56).int32(message.color);
    }
    if (message.creationDate !== undefined) {
      Timestamp.encode(message.creationDate, writer.uint32(66).fork()).join();
    }
    if (message.guid !== "") {
      writer.uint32(74).string(message.guid);
    }
    if (message.user !== "") {
      writer.uint32(82).string(message.user);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResponseMarkerInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResponseMarkerInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.trackLabel = TrackLabel.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.offset = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.timecode = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.length = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.comment = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.color = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.creationDate = Timestamp.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.guid = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.user = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ResponseMarkerInfo {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      trackLabel: isSet(object.trackLabel) ? TrackLabel.fromJSON(object.trackLabel) : undefined,
      offset: isSet(object.offset) ? globalThis.Number(object.offset) : 0,
      timecode: isSet(object.timecode) ? globalThis.String(object.timecode) : "",
      length: isSet(object.length) ? globalThis.Number(object.length) : 0,
      comment: isSet(object.comment) ? globalThis.String(object.comment) : "",
      color: isSet(object.color) ? markerColorFromJSON(object.color) : 0,
      creationDate: isSet(object.creationDate) ? Timestamp.fromJSON(object.creationDate) : undefined,
      guid: isSet(object.guid) ? globalThis.String(object.guid) : "",
      user: isSet(object.user) ? globalThis.String(object.user) : "",
    };
  },

  toJSON(message: ResponseMarkerInfo): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.trackLabel !== undefined) {
      obj.trackLabel = TrackLabel.toJSON(message.trackLabel);
    }
    if (message.offset !== 0) {
      obj.offset = Math.round(message.offset);
    }
    if (message.timecode !== "") {
      obj.timecode = message.timecode;
    }
    if (message.length !== 0) {
      obj.length = Math.round(message.length);
    }
    if (message.comment !== "") {
      obj.comment = message.comment;
    }
    if (message.color !== 0) {
      obj.color = markerColorToJSON(message.color);
    }
    if (message.creationDate !== undefined) {
      obj.creationDate = Timestamp.toJSON(message.creationDate);
    }
    if (message.guid !== "") {
      obj.guid = message.guid;
    }
    if (message.user !== "") {
      obj.user = message.user;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ResponseMarkerInfo>, I>>(base?: I): ResponseMarkerInfo {
    return ResponseMarkerInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ResponseMarkerInfo>, I>>(object: I): ResponseMarkerInfo {
    const message = createBaseResponseMarkerInfo();
    message.name = object.name ?? "";
    message.trackLabel = (object.trackLabel !== undefined && object.trackLabel !== null)
      ? TrackLabel.fromPartial(object.trackLabel)
      : undefined;
    message.offset = object.offset ?? 0;
    message.timecode = object.timecode ?? "";
    message.length = object.length ?? 0;
    message.comment = object.comment ?? "";
    message.color = object.color ?? 0;
    message.creationDate = (object.creationDate !== undefined && object.creationDate !== null)
      ? Timestamp.fromPartial(object.creationDate)
      : undefined;
    message.guid = object.guid ?? "";
    message.user = object.user ?? "";
    return message;
  },
};

function createBaseGetMarkersResponseBody(): GetMarkersResponseBody {
  return { info: [] };
}

export const GetMarkersResponseBody: MessageFns<GetMarkersResponseBody> = {
  encode(message: GetMarkersResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.info) {
      ResponseMarkerInfo.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMarkersResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMarkersResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.info.push(ResponseMarkerInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMarkersResponseBody {
    return {
      info: globalThis.Array.isArray(object?.info) ? object.info.map((e: any) => ResponseMarkerInfo.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetMarkersResponseBody): unknown {
    const obj: any = {};
    if (message.info?.length) {
      obj.info = message.info.map((e) => ResponseMarkerInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMarkersResponseBody>, I>>(base?: I): GetMarkersResponseBody {
    return GetMarkersResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMarkersResponseBody>, I>>(object: I): GetMarkersResponseBody {
    const message = createBaseGetMarkersResponseBody();
    message.info = object.info?.map((e) => ResponseMarkerInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseChangeMarkerRequest(): ChangeMarkerRequest {
  return { header: undefined, body: undefined };
}

export const ChangeMarkerRequest: MessageFns<ChangeMarkerRequest> = {
  encode(message: ChangeMarkerRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      ChangeMarkerRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChangeMarkerRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChangeMarkerRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = ChangeMarkerRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChangeMarkerRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? ChangeMarkerRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: ChangeMarkerRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = ChangeMarkerRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChangeMarkerRequest>, I>>(base?: I): ChangeMarkerRequest {
    return ChangeMarkerRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChangeMarkerRequest>, I>>(object: I): ChangeMarkerRequest {
    const message = createBaseChangeMarkerRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? ChangeMarkerRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseChangeMarkerRequestBody(): ChangeMarkerRequestBody {
  return { mobId: "", guid: "", info: undefined };
}

export const ChangeMarkerRequestBody: MessageFns<ChangeMarkerRequestBody> = {
  encode(message: ChangeMarkerRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mobId !== "") {
      writer.uint32(10).string(message.mobId);
    }
    if (message.guid !== "") {
      writer.uint32(18).string(message.guid);
    }
    if (message.info !== undefined) {
      ChangeMarkerRequestBody_MarkerInfo.encode(message.info, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChangeMarkerRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChangeMarkerRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mobId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.guid = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.info = ChangeMarkerRequestBody_MarkerInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChangeMarkerRequestBody {
    return {
      mobId: isSet(object.mobId) ? globalThis.String(object.mobId) : "",
      guid: isSet(object.guid) ? globalThis.String(object.guid) : "",
      info: isSet(object.info) ? ChangeMarkerRequestBody_MarkerInfo.fromJSON(object.info) : undefined,
    };
  },

  toJSON(message: ChangeMarkerRequestBody): unknown {
    const obj: any = {};
    if (message.mobId !== "") {
      obj.mobId = message.mobId;
    }
    if (message.guid !== "") {
      obj.guid = message.guid;
    }
    if (message.info !== undefined) {
      obj.info = ChangeMarkerRequestBody_MarkerInfo.toJSON(message.info);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChangeMarkerRequestBody>, I>>(base?: I): ChangeMarkerRequestBody {
    return ChangeMarkerRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChangeMarkerRequestBody>, I>>(object: I): ChangeMarkerRequestBody {
    const message = createBaseChangeMarkerRequestBody();
    message.mobId = object.mobId ?? "";
    message.guid = object.guid ?? "";
    message.info = (object.info !== undefined && object.info !== null)
      ? ChangeMarkerRequestBody_MarkerInfo.fromPartial(object.info)
      : undefined;
    return message;
  },
};

function createBaseChangeMarkerRequestBody_MarkerInfo(): ChangeMarkerRequestBody_MarkerInfo {
  return { name: "", comment: "", color: 0, trackLabel: undefined, user: "" };
}

export const ChangeMarkerRequestBody_MarkerInfo: MessageFns<ChangeMarkerRequestBody_MarkerInfo> = {
  encode(message: ChangeMarkerRequestBody_MarkerInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.comment !== "") {
      writer.uint32(18).string(message.comment);
    }
    if (message.color !== 0) {
      writer.uint32(24).int32(message.color);
    }
    if (message.trackLabel !== undefined) {
      TrackLabel.encode(message.trackLabel, writer.uint32(34).fork()).join();
    }
    if (message.user !== "") {
      writer.uint32(42).string(message.user);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChangeMarkerRequestBody_MarkerInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChangeMarkerRequestBody_MarkerInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.comment = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.color = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.trackLabel = TrackLabel.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.user = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChangeMarkerRequestBody_MarkerInfo {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      comment: isSet(object.comment) ? globalThis.String(object.comment) : "",
      color: isSet(object.color) ? markerColorFromJSON(object.color) : 0,
      trackLabel: isSet(object.trackLabel) ? TrackLabel.fromJSON(object.trackLabel) : undefined,
      user: isSet(object.user) ? globalThis.String(object.user) : "",
    };
  },

  toJSON(message: ChangeMarkerRequestBody_MarkerInfo): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.comment !== "") {
      obj.comment = message.comment;
    }
    if (message.color !== 0) {
      obj.color = markerColorToJSON(message.color);
    }
    if (message.trackLabel !== undefined) {
      obj.trackLabel = TrackLabel.toJSON(message.trackLabel);
    }
    if (message.user !== "") {
      obj.user = message.user;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChangeMarkerRequestBody_MarkerInfo>, I>>(
    base?: I,
  ): ChangeMarkerRequestBody_MarkerInfo {
    return ChangeMarkerRequestBody_MarkerInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChangeMarkerRequestBody_MarkerInfo>, I>>(
    object: I,
  ): ChangeMarkerRequestBody_MarkerInfo {
    const message = createBaseChangeMarkerRequestBody_MarkerInfo();
    message.name = object.name ?? "";
    message.comment = object.comment ?? "";
    message.color = object.color ?? 0;
    message.trackLabel = (object.trackLabel !== undefined && object.trackLabel !== null)
      ? TrackLabel.fromPartial(object.trackLabel)
      : undefined;
    message.user = object.user ?? "";
    return message;
  },
};

function createBaseChangeMarkerResponse(): ChangeMarkerResponse {
  return { header: undefined, body: undefined };
}

export const ChangeMarkerResponse: MessageFns<ChangeMarkerResponse> = {
  encode(message: ChangeMarkerResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      ChangeMarkerResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChangeMarkerResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChangeMarkerResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = ChangeMarkerResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChangeMarkerResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? ChangeMarkerResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: ChangeMarkerResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = ChangeMarkerResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChangeMarkerResponse>, I>>(base?: I): ChangeMarkerResponse {
    return ChangeMarkerResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChangeMarkerResponse>, I>>(object: I): ChangeMarkerResponse {
    const message = createBaseChangeMarkerResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? ChangeMarkerResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseChangeMarkerResponseBody(): ChangeMarkerResponseBody {
  return {};
}

export const ChangeMarkerResponseBody: MessageFns<ChangeMarkerResponseBody> = {
  encode(_: ChangeMarkerResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChangeMarkerResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChangeMarkerResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ChangeMarkerResponseBody {
    return {};
  },

  toJSON(_: ChangeMarkerResponseBody): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ChangeMarkerResponseBody>, I>>(base?: I): ChangeMarkerResponseBody {
    return ChangeMarkerResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChangeMarkerResponseBody>, I>>(_: I): ChangeMarkerResponseBody {
    const message = createBaseChangeMarkerResponseBody();
    return message;
  },
};

function createBaseCreateSubClipRequest(): CreateSubClipRequest {
  return { header: undefined, body: undefined };
}

export const CreateSubClipRequest: MessageFns<CreateSubClipRequest> = {
  encode(message: CreateSubClipRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      CreateSubClipRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateSubClipRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateSubClipRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = CreateSubClipRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateSubClipRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? CreateSubClipRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: CreateSubClipRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = CreateSubClipRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateSubClipRequest>, I>>(base?: I): CreateSubClipRequest {
    return CreateSubClipRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateSubClipRequest>, I>>(object: I): CreateSubClipRequest {
    const message = createBaseCreateSubClipRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? CreateSubClipRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseCreateSubClipRequestBody(): CreateSubClipRequestBody {
  return {
    destinationBinPath: "",
    mobId: "",
    trackList: undefined,
    useClipBounds: false,
    useMarksBounds: false,
    headFrame: 0,
    headTimecode: "",
    endFrame: 0,
    endTimecode: "",
    addFramesAtHead: 0,
    addFramesAtEnd: 0,
    retainMarks: false,
    retainMarkers: false,
    createNewSequence: false,
    enabledTracksOnly: false,
  };
}

export const CreateSubClipRequestBody: MessageFns<CreateSubClipRequestBody> = {
  encode(message: CreateSubClipRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.destinationBinPath !== "") {
      writer.uint32(10).string(message.destinationBinPath);
    }
    if (message.mobId !== "") {
      writer.uint32(18).string(message.mobId);
    }
    if (message.trackList !== undefined) {
      TrackList.encode(message.trackList, writer.uint32(26).fork()).join();
    }
    if (message.useClipBounds !== false) {
      writer.uint32(32).bool(message.useClipBounds);
    }
    if (message.useMarksBounds !== false) {
      writer.uint32(40).bool(message.useMarksBounds);
    }
    if (message.headFrame !== 0) {
      writer.uint32(48).int32(message.headFrame);
    }
    if (message.headTimecode !== "") {
      writer.uint32(58).string(message.headTimecode);
    }
    if (message.endFrame !== 0) {
      writer.uint32(64).int32(message.endFrame);
    }
    if (message.endTimecode !== "") {
      writer.uint32(74).string(message.endTimecode);
    }
    if (message.addFramesAtHead !== 0) {
      writer.uint32(80).int32(message.addFramesAtHead);
    }
    if (message.addFramesAtEnd !== 0) {
      writer.uint32(88).int32(message.addFramesAtEnd);
    }
    if (message.retainMarks !== false) {
      writer.uint32(96).bool(message.retainMarks);
    }
    if (message.retainMarkers !== false) {
      writer.uint32(104).bool(message.retainMarkers);
    }
    if (message.createNewSequence !== false) {
      writer.uint32(112).bool(message.createNewSequence);
    }
    if (message.enabledTracksOnly !== false) {
      writer.uint32(120).bool(message.enabledTracksOnly);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateSubClipRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateSubClipRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.destinationBinPath = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.mobId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.trackList = TrackList.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.useClipBounds = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.useMarksBounds = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.headFrame = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.headTimecode = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.endFrame = reader.int32();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.endTimecode = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.addFramesAtHead = reader.int32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.addFramesAtEnd = reader.int32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.retainMarks = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.retainMarkers = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.createNewSequence = reader.bool();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.enabledTracksOnly = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateSubClipRequestBody {
    return {
      destinationBinPath: isSet(object.destinationBinPath) ? globalThis.String(object.destinationBinPath) : "",
      mobId: isSet(object.mobId) ? globalThis.String(object.mobId) : "",
      trackList: isSet(object.trackList) ? TrackList.fromJSON(object.trackList) : undefined,
      useClipBounds: isSet(object.useClipBounds) ? globalThis.Boolean(object.useClipBounds) : false,
      useMarksBounds: isSet(object.useMarksBounds) ? globalThis.Boolean(object.useMarksBounds) : false,
      headFrame: isSet(object.headFrame) ? globalThis.Number(object.headFrame) : 0,
      headTimecode: isSet(object.headTimecode) ? globalThis.String(object.headTimecode) : "",
      endFrame: isSet(object.endFrame) ? globalThis.Number(object.endFrame) : 0,
      endTimecode: isSet(object.endTimecode) ? globalThis.String(object.endTimecode) : "",
      addFramesAtHead: isSet(object.addFramesAtHead) ? globalThis.Number(object.addFramesAtHead) : 0,
      addFramesAtEnd: isSet(object.addFramesAtEnd) ? globalThis.Number(object.addFramesAtEnd) : 0,
      retainMarks: isSet(object.retainMarks) ? globalThis.Boolean(object.retainMarks) : false,
      retainMarkers: isSet(object.retainMarkers) ? globalThis.Boolean(object.retainMarkers) : false,
      createNewSequence: isSet(object.createNewSequence) ? globalThis.Boolean(object.createNewSequence) : false,
      enabledTracksOnly: isSet(object.enabledTracksOnly) ? globalThis.Boolean(object.enabledTracksOnly) : false,
    };
  },

  toJSON(message: CreateSubClipRequestBody): unknown {
    const obj: any = {};
    if (message.destinationBinPath !== "") {
      obj.destinationBinPath = message.destinationBinPath;
    }
    if (message.mobId !== "") {
      obj.mobId = message.mobId;
    }
    if (message.trackList !== undefined) {
      obj.trackList = TrackList.toJSON(message.trackList);
    }
    if (message.useClipBounds !== false) {
      obj.useClipBounds = message.useClipBounds;
    }
    if (message.useMarksBounds !== false) {
      obj.useMarksBounds = message.useMarksBounds;
    }
    if (message.headFrame !== 0) {
      obj.headFrame = Math.round(message.headFrame);
    }
    if (message.headTimecode !== "") {
      obj.headTimecode = message.headTimecode;
    }
    if (message.endFrame !== 0) {
      obj.endFrame = Math.round(message.endFrame);
    }
    if (message.endTimecode !== "") {
      obj.endTimecode = message.endTimecode;
    }
    if (message.addFramesAtHead !== 0) {
      obj.addFramesAtHead = Math.round(message.addFramesAtHead);
    }
    if (message.addFramesAtEnd !== 0) {
      obj.addFramesAtEnd = Math.round(message.addFramesAtEnd);
    }
    if (message.retainMarks !== false) {
      obj.retainMarks = message.retainMarks;
    }
    if (message.retainMarkers !== false) {
      obj.retainMarkers = message.retainMarkers;
    }
    if (message.createNewSequence !== false) {
      obj.createNewSequence = message.createNewSequence;
    }
    if (message.enabledTracksOnly !== false) {
      obj.enabledTracksOnly = message.enabledTracksOnly;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateSubClipRequestBody>, I>>(base?: I): CreateSubClipRequestBody {
    return CreateSubClipRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateSubClipRequestBody>, I>>(object: I): CreateSubClipRequestBody {
    const message = createBaseCreateSubClipRequestBody();
    message.destinationBinPath = object.destinationBinPath ?? "";
    message.mobId = object.mobId ?? "";
    message.trackList = (object.trackList !== undefined && object.trackList !== null)
      ? TrackList.fromPartial(object.trackList)
      : undefined;
    message.useClipBounds = object.useClipBounds ?? false;
    message.useMarksBounds = object.useMarksBounds ?? false;
    message.headFrame = object.headFrame ?? 0;
    message.headTimecode = object.headTimecode ?? "";
    message.endFrame = object.endFrame ?? 0;
    message.endTimecode = object.endTimecode ?? "";
    message.addFramesAtHead = object.addFramesAtHead ?? 0;
    message.addFramesAtEnd = object.addFramesAtEnd ?? 0;
    message.retainMarks = object.retainMarks ?? false;
    message.retainMarkers = object.retainMarkers ?? false;
    message.createNewSequence = object.createNewSequence ?? false;
    message.enabledTracksOnly = object.enabledTracksOnly ?? false;
    return message;
  },
};

function createBaseCreateSubClipResponse(): CreateSubClipResponse {
  return { header: undefined, body: undefined };
}

export const CreateSubClipResponse: MessageFns<CreateSubClipResponse> = {
  encode(message: CreateSubClipResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      CreateSubClipResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateSubClipResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateSubClipResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = CreateSubClipResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateSubClipResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? CreateSubClipResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: CreateSubClipResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = CreateSubClipResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateSubClipResponse>, I>>(base?: I): CreateSubClipResponse {
    return CreateSubClipResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateSubClipResponse>, I>>(object: I): CreateSubClipResponse {
    const message = createBaseCreateSubClipResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? CreateSubClipResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseCreateSubClipResponseBody(): CreateSubClipResponseBody {
  return {};
}

export const CreateSubClipResponseBody: MessageFns<CreateSubClipResponseBody> = {
  encode(_: CreateSubClipResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateSubClipResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateSubClipResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): CreateSubClipResponseBody {
    return {};
  },

  toJSON(_: CreateSubClipResponseBody): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateSubClipResponseBody>, I>>(base?: I): CreateSubClipResponseBody {
    return CreateSubClipResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateSubClipResponseBody>, I>>(_: I): CreateSubClipResponseBody {
    const message = createBaseCreateSubClipResponseBody();
    return message;
  },
};

function createBaseCloseBinRequest(): CloseBinRequest {
  return { header: undefined, body: undefined };
}

export const CloseBinRequest: MessageFns<CloseBinRequest> = {
  encode(message: CloseBinRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      CloseBinRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CloseBinRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCloseBinRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = CloseBinRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CloseBinRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? CloseBinRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: CloseBinRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = CloseBinRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CloseBinRequest>, I>>(base?: I): CloseBinRequest {
    return CloseBinRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CloseBinRequest>, I>>(object: I): CloseBinRequest {
    const message = createBaseCloseBinRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? CloseBinRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseCloseBinRequestBody(): CloseBinRequestBody {
  return { binPath: "" };
}

export const CloseBinRequestBody: MessageFns<CloseBinRequestBody> = {
  encode(message: CloseBinRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.binPath !== "") {
      writer.uint32(10).string(message.binPath);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CloseBinRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCloseBinRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.binPath = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CloseBinRequestBody {
    return { binPath: isSet(object.binPath) ? globalThis.String(object.binPath) : "" };
  },

  toJSON(message: CloseBinRequestBody): unknown {
    const obj: any = {};
    if (message.binPath !== "") {
      obj.binPath = message.binPath;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CloseBinRequestBody>, I>>(base?: I): CloseBinRequestBody {
    return CloseBinRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CloseBinRequestBody>, I>>(object: I): CloseBinRequestBody {
    const message = createBaseCloseBinRequestBody();
    message.binPath = object.binPath ?? "";
    return message;
  },
};

function createBaseCloseBinResponse(): CloseBinResponse {
  return { header: undefined, body: undefined };
}

export const CloseBinResponse: MessageFns<CloseBinResponse> = {
  encode(message: CloseBinResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      CloseBinResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CloseBinResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCloseBinResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = CloseBinResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CloseBinResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? CloseBinResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: CloseBinResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = CloseBinResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CloseBinResponse>, I>>(base?: I): CloseBinResponse {
    return CloseBinResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CloseBinResponse>, I>>(object: I): CloseBinResponse {
    const message = createBaseCloseBinResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? CloseBinResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseCloseBinResponseBody(): CloseBinResponseBody {
  return {};
}

export const CloseBinResponseBody: MessageFns<CloseBinResponseBody> = {
  encode(_: CloseBinResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CloseBinResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCloseBinResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): CloseBinResponseBody {
    return {};
  },

  toJSON(_: CloseBinResponseBody): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<CloseBinResponseBody>, I>>(base?: I): CloseBinResponseBody {
    return CloseBinResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CloseBinResponseBody>, I>>(_: I): CloseBinResponseBody {
    const message = createBaseCloseBinResponseBody();
    return message;
  },
};

function createBaseMoveBinItemsRequest(): MoveBinItemsRequest {
  return { header: undefined, body: undefined };
}

export const MoveBinItemsRequest: MessageFns<MoveBinItemsRequest> = {
  encode(message: MoveBinItemsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      MoveBinItemsRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MoveBinItemsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMoveBinItemsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = MoveBinItemsRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MoveBinItemsRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? MoveBinItemsRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: MoveBinItemsRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = MoveBinItemsRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MoveBinItemsRequest>, I>>(base?: I): MoveBinItemsRequest {
    return MoveBinItemsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MoveBinItemsRequest>, I>>(object: I): MoveBinItemsRequest {
    const message = createBaseMoveBinItemsRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? MoveBinItemsRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseMoveBinItemsRequestBody(): MoveBinItemsRequestBody {
  return { sourceBinPath: "", destinationBinPath: "", mobId: [] };
}

export const MoveBinItemsRequestBody: MessageFns<MoveBinItemsRequestBody> = {
  encode(message: MoveBinItemsRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sourceBinPath !== "") {
      writer.uint32(10).string(message.sourceBinPath);
    }
    if (message.destinationBinPath !== "") {
      writer.uint32(18).string(message.destinationBinPath);
    }
    for (const v of message.mobId) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MoveBinItemsRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMoveBinItemsRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sourceBinPath = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.destinationBinPath = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.mobId.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MoveBinItemsRequestBody {
    return {
      sourceBinPath: isSet(object.sourceBinPath) ? globalThis.String(object.sourceBinPath) : "",
      destinationBinPath: isSet(object.destinationBinPath) ? globalThis.String(object.destinationBinPath) : "",
      mobId: globalThis.Array.isArray(object?.mobId) ? object.mobId.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: MoveBinItemsRequestBody): unknown {
    const obj: any = {};
    if (message.sourceBinPath !== "") {
      obj.sourceBinPath = message.sourceBinPath;
    }
    if (message.destinationBinPath !== "") {
      obj.destinationBinPath = message.destinationBinPath;
    }
    if (message.mobId?.length) {
      obj.mobId = message.mobId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MoveBinItemsRequestBody>, I>>(base?: I): MoveBinItemsRequestBody {
    return MoveBinItemsRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MoveBinItemsRequestBody>, I>>(object: I): MoveBinItemsRequestBody {
    const message = createBaseMoveBinItemsRequestBody();
    message.sourceBinPath = object.sourceBinPath ?? "";
    message.destinationBinPath = object.destinationBinPath ?? "";
    message.mobId = object.mobId?.map((e) => e) || [];
    return message;
  },
};

function createBaseMoveBinItemsResponse(): MoveBinItemsResponse {
  return { header: undefined, body: undefined };
}

export const MoveBinItemsResponse: MessageFns<MoveBinItemsResponse> = {
  encode(message: MoveBinItemsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      MoveBinItemsResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MoveBinItemsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMoveBinItemsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = MoveBinItemsResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MoveBinItemsResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? MoveBinItemsResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: MoveBinItemsResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = MoveBinItemsResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MoveBinItemsResponse>, I>>(base?: I): MoveBinItemsResponse {
    return MoveBinItemsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MoveBinItemsResponse>, I>>(object: I): MoveBinItemsResponse {
    const message = createBaseMoveBinItemsResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? MoveBinItemsResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseMoveBinItemsResponseBody(): MoveBinItemsResponseBody {
  return { mobId: [] };
}

export const MoveBinItemsResponseBody: MessageFns<MoveBinItemsResponseBody> = {
  encode(message: MoveBinItemsResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.mobId) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MoveBinItemsResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMoveBinItemsResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.mobId.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MoveBinItemsResponseBody {
    return { mobId: globalThis.Array.isArray(object?.mobId) ? object.mobId.map((e: any) => globalThis.String(e)) : [] };
  },

  toJSON(message: MoveBinItemsResponseBody): unknown {
    const obj: any = {};
    if (message.mobId?.length) {
      obj.mobId = message.mobId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MoveBinItemsResponseBody>, I>>(base?: I): MoveBinItemsResponseBody {
    return MoveBinItemsResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MoveBinItemsResponseBody>, I>>(object: I): MoveBinItemsResponseBody {
    const message = createBaseMoveBinItemsResponseBody();
    message.mobId = object.mobId?.map((e) => e) || [];
    return message;
  },
};

function createBaseCopyBinItemsRequest(): CopyBinItemsRequest {
  return { header: undefined, body: undefined };
}

export const CopyBinItemsRequest: MessageFns<CopyBinItemsRequest> = {
  encode(message: CopyBinItemsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      CopyBinItemsRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CopyBinItemsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCopyBinItemsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = CopyBinItemsRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CopyBinItemsRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? CopyBinItemsRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: CopyBinItemsRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = CopyBinItemsRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CopyBinItemsRequest>, I>>(base?: I): CopyBinItemsRequest {
    return CopyBinItemsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CopyBinItemsRequest>, I>>(object: I): CopyBinItemsRequest {
    const message = createBaseCopyBinItemsRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? CopyBinItemsRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseCopyBinItemsRequestBody(): CopyBinItemsRequestBody {
  return { sourceBinPath: "", destinationBinPath: "", mobId: [] };
}

export const CopyBinItemsRequestBody: MessageFns<CopyBinItemsRequestBody> = {
  encode(message: CopyBinItemsRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sourceBinPath !== "") {
      writer.uint32(10).string(message.sourceBinPath);
    }
    if (message.destinationBinPath !== "") {
      writer.uint32(18).string(message.destinationBinPath);
    }
    for (const v of message.mobId) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CopyBinItemsRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCopyBinItemsRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sourceBinPath = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.destinationBinPath = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.mobId.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CopyBinItemsRequestBody {
    return {
      sourceBinPath: isSet(object.sourceBinPath) ? globalThis.String(object.sourceBinPath) : "",
      destinationBinPath: isSet(object.destinationBinPath) ? globalThis.String(object.destinationBinPath) : "",
      mobId: globalThis.Array.isArray(object?.mobId) ? object.mobId.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: CopyBinItemsRequestBody): unknown {
    const obj: any = {};
    if (message.sourceBinPath !== "") {
      obj.sourceBinPath = message.sourceBinPath;
    }
    if (message.destinationBinPath !== "") {
      obj.destinationBinPath = message.destinationBinPath;
    }
    if (message.mobId?.length) {
      obj.mobId = message.mobId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CopyBinItemsRequestBody>, I>>(base?: I): CopyBinItemsRequestBody {
    return CopyBinItemsRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CopyBinItemsRequestBody>, I>>(object: I): CopyBinItemsRequestBody {
    const message = createBaseCopyBinItemsRequestBody();
    message.sourceBinPath = object.sourceBinPath ?? "";
    message.destinationBinPath = object.destinationBinPath ?? "";
    message.mobId = object.mobId?.map((e) => e) || [];
    return message;
  },
};

function createBaseCopyBinItemsResponse(): CopyBinItemsResponse {
  return { header: undefined, body: undefined };
}

export const CopyBinItemsResponse: MessageFns<CopyBinItemsResponse> = {
  encode(message: CopyBinItemsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      CopyBinItemsResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CopyBinItemsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCopyBinItemsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = CopyBinItemsResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CopyBinItemsResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? CopyBinItemsResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: CopyBinItemsResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = CopyBinItemsResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CopyBinItemsResponse>, I>>(base?: I): CopyBinItemsResponse {
    return CopyBinItemsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CopyBinItemsResponse>, I>>(object: I): CopyBinItemsResponse {
    const message = createBaseCopyBinItemsResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? CopyBinItemsResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseCopyBinItemsResponseBody(): CopyBinItemsResponseBody {
  return { mobId: [] };
}

export const CopyBinItemsResponseBody: MessageFns<CopyBinItemsResponseBody> = {
  encode(message: CopyBinItemsResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.mobId) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CopyBinItemsResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCopyBinItemsResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.mobId.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CopyBinItemsResponseBody {
    return { mobId: globalThis.Array.isArray(object?.mobId) ? object.mobId.map((e: any) => globalThis.String(e)) : [] };
  },

  toJSON(message: CopyBinItemsResponseBody): unknown {
    const obj: any = {};
    if (message.mobId?.length) {
      obj.mobId = message.mobId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CopyBinItemsResponseBody>, I>>(base?: I): CopyBinItemsResponseBody {
    return CopyBinItemsResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CopyBinItemsResponseBody>, I>>(object: I): CopyBinItemsResponseBody {
    const message = createBaseCopyBinItemsResponseBody();
    message.mobId = object.mobId?.map((e) => e) || [];
    return message;
  },
};

function createBaseDuplicateBinItemsRequest(): DuplicateBinItemsRequest {
  return { header: undefined, body: undefined };
}

export const DuplicateBinItemsRequest: MessageFns<DuplicateBinItemsRequest> = {
  encode(message: DuplicateBinItemsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      DuplicateBinItemsRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DuplicateBinItemsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDuplicateBinItemsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = DuplicateBinItemsRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DuplicateBinItemsRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? DuplicateBinItemsRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: DuplicateBinItemsRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = DuplicateBinItemsRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DuplicateBinItemsRequest>, I>>(base?: I): DuplicateBinItemsRequest {
    return DuplicateBinItemsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DuplicateBinItemsRequest>, I>>(object: I): DuplicateBinItemsRequest {
    const message = createBaseDuplicateBinItemsRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? DuplicateBinItemsRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseDuplicateBinItemsRequestBody(): DuplicateBinItemsRequestBody {
  return { binPath: "", mobId: [] };
}

export const DuplicateBinItemsRequestBody: MessageFns<DuplicateBinItemsRequestBody> = {
  encode(message: DuplicateBinItemsRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.binPath !== "") {
      writer.uint32(10).string(message.binPath);
    }
    for (const v of message.mobId) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DuplicateBinItemsRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDuplicateBinItemsRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.binPath = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.mobId.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DuplicateBinItemsRequestBody {
    return {
      binPath: isSet(object.binPath) ? globalThis.String(object.binPath) : "",
      mobId: globalThis.Array.isArray(object?.mobId) ? object.mobId.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: DuplicateBinItemsRequestBody): unknown {
    const obj: any = {};
    if (message.binPath !== "") {
      obj.binPath = message.binPath;
    }
    if (message.mobId?.length) {
      obj.mobId = message.mobId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DuplicateBinItemsRequestBody>, I>>(base?: I): DuplicateBinItemsRequestBody {
    return DuplicateBinItemsRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DuplicateBinItemsRequestBody>, I>>(object: I): DuplicateBinItemsRequestBody {
    const message = createBaseDuplicateBinItemsRequestBody();
    message.binPath = object.binPath ?? "";
    message.mobId = object.mobId?.map((e) => e) || [];
    return message;
  },
};

function createBaseDuplicateBinItemsResponse(): DuplicateBinItemsResponse {
  return { header: undefined, body: undefined };
}

export const DuplicateBinItemsResponse: MessageFns<DuplicateBinItemsResponse> = {
  encode(message: DuplicateBinItemsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      DuplicateBinItemsResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DuplicateBinItemsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDuplicateBinItemsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = DuplicateBinItemsResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DuplicateBinItemsResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? DuplicateBinItemsResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: DuplicateBinItemsResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = DuplicateBinItemsResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DuplicateBinItemsResponse>, I>>(base?: I): DuplicateBinItemsResponse {
    return DuplicateBinItemsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DuplicateBinItemsResponse>, I>>(object: I): DuplicateBinItemsResponse {
    const message = createBaseDuplicateBinItemsResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? DuplicateBinItemsResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseDuplicateBinItemsResponseBody(): DuplicateBinItemsResponseBody {
  return { mobId: [] };
}

export const DuplicateBinItemsResponseBody: MessageFns<DuplicateBinItemsResponseBody> = {
  encode(message: DuplicateBinItemsResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.mobId) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DuplicateBinItemsResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDuplicateBinItemsResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.mobId.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DuplicateBinItemsResponseBody {
    return { mobId: globalThis.Array.isArray(object?.mobId) ? object.mobId.map((e: any) => globalThis.String(e)) : [] };
  },

  toJSON(message: DuplicateBinItemsResponseBody): unknown {
    const obj: any = {};
    if (message.mobId?.length) {
      obj.mobId = message.mobId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DuplicateBinItemsResponseBody>, I>>(base?: I): DuplicateBinItemsResponseBody {
    return DuplicateBinItemsResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DuplicateBinItemsResponseBody>, I>>(
    object: I,
  ): DuplicateBinItemsResponseBody {
    const message = createBaseDuplicateBinItemsResponseBody();
    message.mobId = object.mobId?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetListOfLinkSettingsRequest(): GetListOfLinkSettingsRequest {
  return { header: undefined, body: undefined };
}

export const GetListOfLinkSettingsRequest: MessageFns<GetListOfLinkSettingsRequest> = {
  encode(message: GetListOfLinkSettingsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetListOfLinkSettingsRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetListOfLinkSettingsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetListOfLinkSettingsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetListOfLinkSettingsRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetListOfLinkSettingsRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetListOfLinkSettingsRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetListOfLinkSettingsRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetListOfLinkSettingsRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetListOfLinkSettingsRequest>, I>>(base?: I): GetListOfLinkSettingsRequest {
    return GetListOfLinkSettingsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetListOfLinkSettingsRequest>, I>>(object: I): GetListOfLinkSettingsRequest {
    const message = createBaseGetListOfLinkSettingsRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetListOfLinkSettingsRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetListOfLinkSettingsRequestBody(): GetListOfLinkSettingsRequestBody {
  return {};
}

export const GetListOfLinkSettingsRequestBody: MessageFns<GetListOfLinkSettingsRequestBody> = {
  encode(_: GetListOfLinkSettingsRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetListOfLinkSettingsRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetListOfLinkSettingsRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetListOfLinkSettingsRequestBody {
    return {};
  },

  toJSON(_: GetListOfLinkSettingsRequestBody): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetListOfLinkSettingsRequestBody>, I>>(
    base?: I,
  ): GetListOfLinkSettingsRequestBody {
    return GetListOfLinkSettingsRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetListOfLinkSettingsRequestBody>, I>>(
    _: I,
  ): GetListOfLinkSettingsRequestBody {
    const message = createBaseGetListOfLinkSettingsRequestBody();
    return message;
  },
};

function createBaseGetListOfLinkSettingsResponse(): GetListOfLinkSettingsResponse {
  return { header: undefined, body: undefined };
}

export const GetListOfLinkSettingsResponse: MessageFns<GetListOfLinkSettingsResponse> = {
  encode(message: GetListOfLinkSettingsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetListOfLinkSettingsResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetListOfLinkSettingsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetListOfLinkSettingsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetListOfLinkSettingsResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetListOfLinkSettingsResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetListOfLinkSettingsResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetListOfLinkSettingsResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetListOfLinkSettingsResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetListOfLinkSettingsResponse>, I>>(base?: I): GetListOfLinkSettingsResponse {
    return GetListOfLinkSettingsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetListOfLinkSettingsResponse>, I>>(
    object: I,
  ): GetListOfLinkSettingsResponse {
    const message = createBaseGetListOfLinkSettingsResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetListOfLinkSettingsResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetListOfLinkSettingsResponseBody(): GetListOfLinkSettingsResponseBody {
  return { settingNames: [] };
}

export const GetListOfLinkSettingsResponseBody: MessageFns<GetListOfLinkSettingsResponseBody> = {
  encode(message: GetListOfLinkSettingsResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.settingNames) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetListOfLinkSettingsResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetListOfLinkSettingsResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.settingNames.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetListOfLinkSettingsResponseBody {
    return {
      settingNames: globalThis.Array.isArray(object?.settingNames)
        ? object.settingNames.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: GetListOfLinkSettingsResponseBody): unknown {
    const obj: any = {};
    if (message.settingNames?.length) {
      obj.settingNames = message.settingNames;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetListOfLinkSettingsResponseBody>, I>>(
    base?: I,
  ): GetListOfLinkSettingsResponseBody {
    return GetListOfLinkSettingsResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetListOfLinkSettingsResponseBody>, I>>(
    object: I,
  ): GetListOfLinkSettingsResponseBody {
    const message = createBaseGetListOfLinkSettingsResponseBody();
    message.settingNames = object.settingNames?.map((e) => e) || [];
    return message;
  },
};

function createBaseLinkFileRequest(): LinkFileRequest {
  return { header: undefined, body: undefined };
}

export const LinkFileRequest: MessageFns<LinkFileRequest> = {
  encode(message: LinkFileRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      LinkFileRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LinkFileRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLinkFileRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = LinkFileRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LinkFileRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? LinkFileRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: LinkFileRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = LinkFileRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LinkFileRequest>, I>>(base?: I): LinkFileRequest {
    return LinkFileRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LinkFileRequest>, I>>(object: I): LinkFileRequest {
    const message = createBaseLinkFileRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? LinkFileRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseLinkFileRequestBody(): LinkFileRequestBody {
  return { filePath: "", destinationBin: "", linkSettingsName: "" };
}

export const LinkFileRequestBody: MessageFns<LinkFileRequestBody> = {
  encode(message: LinkFileRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.filePath !== "") {
      writer.uint32(10).string(message.filePath);
    }
    if (message.destinationBin !== "") {
      writer.uint32(18).string(message.destinationBin);
    }
    if (message.linkSettingsName !== "") {
      writer.uint32(26).string(message.linkSettingsName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LinkFileRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLinkFileRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.filePath = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.destinationBin = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.linkSettingsName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LinkFileRequestBody {
    return {
      filePath: isSet(object.filePath) ? globalThis.String(object.filePath) : "",
      destinationBin: isSet(object.destinationBin) ? globalThis.String(object.destinationBin) : "",
      linkSettingsName: isSet(object.linkSettingsName) ? globalThis.String(object.linkSettingsName) : "",
    };
  },

  toJSON(message: LinkFileRequestBody): unknown {
    const obj: any = {};
    if (message.filePath !== "") {
      obj.filePath = message.filePath;
    }
    if (message.destinationBin !== "") {
      obj.destinationBin = message.destinationBin;
    }
    if (message.linkSettingsName !== "") {
      obj.linkSettingsName = message.linkSettingsName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LinkFileRequestBody>, I>>(base?: I): LinkFileRequestBody {
    return LinkFileRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LinkFileRequestBody>, I>>(object: I): LinkFileRequestBody {
    const message = createBaseLinkFileRequestBody();
    message.filePath = object.filePath ?? "";
    message.destinationBin = object.destinationBin ?? "";
    message.linkSettingsName = object.linkSettingsName ?? "";
    return message;
  },
};

function createBaseLinkFileResponse(): LinkFileResponse {
  return { header: undefined, body: undefined };
}

export const LinkFileResponse: MessageFns<LinkFileResponse> = {
  encode(message: LinkFileResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      LinkFileResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LinkFileResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLinkFileResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = LinkFileResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LinkFileResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? LinkFileResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: LinkFileResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = LinkFileResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LinkFileResponse>, I>>(base?: I): LinkFileResponse {
    return LinkFileResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LinkFileResponse>, I>>(object: I): LinkFileResponse {
    const message = createBaseLinkFileResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? LinkFileResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseLinkFileResponseBody(): LinkFileResponseBody {
  return { mobId: "" };
}

export const LinkFileResponseBody: MessageFns<LinkFileResponseBody> = {
  encode(message: LinkFileResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mobId !== "") {
      writer.uint32(10).string(message.mobId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LinkFileResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLinkFileResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mobId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LinkFileResponseBody {
    return { mobId: isSet(object.mobId) ? globalThis.String(object.mobId) : "" };
  },

  toJSON(message: LinkFileResponseBody): unknown {
    const obj: any = {};
    if (message.mobId !== "") {
      obj.mobId = message.mobId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LinkFileResponseBody>, I>>(base?: I): LinkFileResponseBody {
    return LinkFileResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LinkFileResponseBody>, I>>(object: I): LinkFileResponseBody {
    const message = createBaseLinkFileResponseBody();
    message.mobId = object.mobId ?? "";
    return message;
  },
};

function createBaseGetListOfJobQueuesRequest(): GetListOfJobQueuesRequest {
  return { header: undefined, body: undefined };
}

export const GetListOfJobQueuesRequest: MessageFns<GetListOfJobQueuesRequest> = {
  encode(message: GetListOfJobQueuesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetListOfJobQueuesRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetListOfJobQueuesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetListOfJobQueuesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetListOfJobQueuesRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetListOfJobQueuesRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetListOfJobQueuesRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetListOfJobQueuesRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetListOfJobQueuesRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetListOfJobQueuesRequest>, I>>(base?: I): GetListOfJobQueuesRequest {
    return GetListOfJobQueuesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetListOfJobQueuesRequest>, I>>(object: I): GetListOfJobQueuesRequest {
    const message = createBaseGetListOfJobQueuesRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetListOfJobQueuesRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetListOfJobQueuesRequestBody(): GetListOfJobQueuesRequestBody {
  return {};
}

export const GetListOfJobQueuesRequestBody: MessageFns<GetListOfJobQueuesRequestBody> = {
  encode(_: GetListOfJobQueuesRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetListOfJobQueuesRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetListOfJobQueuesRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetListOfJobQueuesRequestBody {
    return {};
  },

  toJSON(_: GetListOfJobQueuesRequestBody): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetListOfJobQueuesRequestBody>, I>>(base?: I): GetListOfJobQueuesRequestBody {
    return GetListOfJobQueuesRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetListOfJobQueuesRequestBody>, I>>(_: I): GetListOfJobQueuesRequestBody {
    const message = createBaseGetListOfJobQueuesRequestBody();
    return message;
  },
};

function createBaseGetListOfJobQueuesResponse(): GetListOfJobQueuesResponse {
  return { header: undefined, body: undefined };
}

export const GetListOfJobQueuesResponse: MessageFns<GetListOfJobQueuesResponse> = {
  encode(message: GetListOfJobQueuesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      GetListOfJobQueuesResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetListOfJobQueuesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetListOfJobQueuesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = GetListOfJobQueuesResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetListOfJobQueuesResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? GetListOfJobQueuesResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: GetListOfJobQueuesResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = GetListOfJobQueuesResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetListOfJobQueuesResponse>, I>>(base?: I): GetListOfJobQueuesResponse {
    return GetListOfJobQueuesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetListOfJobQueuesResponse>, I>>(object: I): GetListOfJobQueuesResponse {
    const message = createBaseGetListOfJobQueuesResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? GetListOfJobQueuesResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseGetListOfJobQueuesResponseBody(): GetListOfJobQueuesResponseBody {
  return { jobQueues: [] };
}

export const GetListOfJobQueuesResponseBody: MessageFns<GetListOfJobQueuesResponseBody> = {
  encode(message: GetListOfJobQueuesResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.jobQueues) {
      GetListOfJobQueuesResponseBody_JobsQueue.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetListOfJobQueuesResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetListOfJobQueuesResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.jobQueues.push(GetListOfJobQueuesResponseBody_JobsQueue.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetListOfJobQueuesResponseBody {
    return {
      jobQueues: globalThis.Array.isArray(object?.jobQueues)
        ? object.jobQueues.map((e: any) => GetListOfJobQueuesResponseBody_JobsQueue.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetListOfJobQueuesResponseBody): unknown {
    const obj: any = {};
    if (message.jobQueues?.length) {
      obj.jobQueues = message.jobQueues.map((e) => GetListOfJobQueuesResponseBody_JobsQueue.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetListOfJobQueuesResponseBody>, I>>(base?: I): GetListOfJobQueuesResponseBody {
    return GetListOfJobQueuesResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetListOfJobQueuesResponseBody>, I>>(
    object: I,
  ): GetListOfJobQueuesResponseBody {
    const message = createBaseGetListOfJobQueuesResponseBody();
    message.jobQueues = object.jobQueues?.map((e) => GetListOfJobQueuesResponseBody_JobsQueue.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetListOfJobQueuesResponseBody_JobsQueue(): GetListOfJobQueuesResponseBody_JobsQueue {
  return { name: "", id: "" };
}

export const GetListOfJobQueuesResponseBody_JobsQueue: MessageFns<GetListOfJobQueuesResponseBody_JobsQueue> = {
  encode(message: GetListOfJobQueuesResponseBody_JobsQueue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetListOfJobQueuesResponseBody_JobsQueue {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetListOfJobQueuesResponseBody_JobsQueue();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetListOfJobQueuesResponseBody_JobsQueue {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      id: isSet(object.id) ? globalThis.String(object.id) : "",
    };
  },

  toJSON(message: GetListOfJobQueuesResponseBody_JobsQueue): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetListOfJobQueuesResponseBody_JobsQueue>, I>>(
    base?: I,
  ): GetListOfJobQueuesResponseBody_JobsQueue {
    return GetListOfJobQueuesResponseBody_JobsQueue.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetListOfJobQueuesResponseBody_JobsQueue>, I>>(
    object: I,
  ): GetListOfJobQueuesResponseBody_JobsQueue {
    const message = createBaseGetListOfJobQueuesResponseBody_JobsQueue();
    message.name = object.name ?? "";
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseDeleteMarkersRequest(): DeleteMarkersRequest {
  return { header: undefined, body: undefined };
}

export const DeleteMarkersRequest: MessageFns<DeleteMarkersRequest> = {
  encode(message: DeleteMarkersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      DeleteMarkersRequestBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteMarkersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteMarkersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = DeleteMarkersRequestBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteMarkersRequest {
    return {
      header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? DeleteMarkersRequestBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: DeleteMarkersRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = DeleteMarkersRequestBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteMarkersRequest>, I>>(base?: I): DeleteMarkersRequest {
    return DeleteMarkersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteMarkersRequest>, I>>(object: I): DeleteMarkersRequest {
    const message = createBaseDeleteMarkersRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? DeleteMarkersRequestBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseDeleteMarkersRequestBody(): DeleteMarkersRequestBody {
  return {
    mobId: "",
    guid: [],
    timecodeRangeStart: undefined,
    timecodeRangeEnd: undefined,
    color: undefined,
    trackLabel: undefined,
  };
}

export const DeleteMarkersRequestBody: MessageFns<DeleteMarkersRequestBody> = {
  encode(message: DeleteMarkersRequestBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mobId !== "") {
      writer.uint32(10).string(message.mobId);
    }
    for (const v of message.guid) {
      writer.uint32(18).string(v!);
    }
    if (message.timecodeRangeStart !== undefined) {
      writer.uint32(26).string(message.timecodeRangeStart);
    }
    if (message.timecodeRangeEnd !== undefined) {
      writer.uint32(34).string(message.timecodeRangeEnd);
    }
    if (message.color !== undefined) {
      writer.uint32(40).int32(message.color);
    }
    if (message.trackLabel !== undefined) {
      TrackLabel.encode(message.trackLabel, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteMarkersRequestBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteMarkersRequestBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mobId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.guid.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.timecodeRangeStart = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.timecodeRangeEnd = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.color = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.trackLabel = TrackLabel.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteMarkersRequestBody {
    return {
      mobId: isSet(object.mobId) ? globalThis.String(object.mobId) : "",
      guid: globalThis.Array.isArray(object?.guid) ? object.guid.map((e: any) => globalThis.String(e)) : [],
      timecodeRangeStart: isSet(object.timecodeRangeStart) ? globalThis.String(object.timecodeRangeStart) : undefined,
      timecodeRangeEnd: isSet(object.timecodeRangeEnd) ? globalThis.String(object.timecodeRangeEnd) : undefined,
      color: isSet(object.color) ? markerColorFromJSON(object.color) : undefined,
      trackLabel: isSet(object.trackLabel) ? TrackLabel.fromJSON(object.trackLabel) : undefined,
    };
  },

  toJSON(message: DeleteMarkersRequestBody): unknown {
    const obj: any = {};
    if (message.mobId !== "") {
      obj.mobId = message.mobId;
    }
    if (message.guid?.length) {
      obj.guid = message.guid;
    }
    if (message.timecodeRangeStart !== undefined) {
      obj.timecodeRangeStart = message.timecodeRangeStart;
    }
    if (message.timecodeRangeEnd !== undefined) {
      obj.timecodeRangeEnd = message.timecodeRangeEnd;
    }
    if (message.color !== undefined) {
      obj.color = markerColorToJSON(message.color);
    }
    if (message.trackLabel !== undefined) {
      obj.trackLabel = TrackLabel.toJSON(message.trackLabel);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteMarkersRequestBody>, I>>(base?: I): DeleteMarkersRequestBody {
    return DeleteMarkersRequestBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteMarkersRequestBody>, I>>(object: I): DeleteMarkersRequestBody {
    const message = createBaseDeleteMarkersRequestBody();
    message.mobId = object.mobId ?? "";
    message.guid = object.guid?.map((e) => e) || [];
    message.timecodeRangeStart = object.timecodeRangeStart ?? undefined;
    message.timecodeRangeEnd = object.timecodeRangeEnd ?? undefined;
    message.color = object.color ?? undefined;
    message.trackLabel = (object.trackLabel !== undefined && object.trackLabel !== null)
      ? TrackLabel.fromPartial(object.trackLabel)
      : undefined;
    return message;
  },
};

function createBaseDeleteMarkersResponse(): DeleteMarkersResponse {
  return { header: undefined, body: undefined };
}

export const DeleteMarkersResponse: MessageFns<DeleteMarkersResponse> = {
  encode(message: DeleteMarkersResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.body !== undefined) {
      DeleteMarkersResponseBody.encode(message.body, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteMarkersResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteMarkersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.body = DeleteMarkersResponseBody.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteMarkersResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      body: isSet(object.body) ? DeleteMarkersResponseBody.fromJSON(object.body) : undefined,
    };
  },

  toJSON(message: DeleteMarkersResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.body !== undefined) {
      obj.body = DeleteMarkersResponseBody.toJSON(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteMarkersResponse>, I>>(base?: I): DeleteMarkersResponse {
    return DeleteMarkersResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteMarkersResponse>, I>>(object: I): DeleteMarkersResponse {
    const message = createBaseDeleteMarkersResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.body = (object.body !== undefined && object.body !== null)
      ? DeleteMarkersResponseBody.fromPartial(object.body)
      : undefined;
    return message;
  },
};

function createBaseDeleteMarkersResponseBody(): DeleteMarkersResponseBody {
  return {};
}

export const DeleteMarkersResponseBody: MessageFns<DeleteMarkersResponseBody> = {
  encode(_: DeleteMarkersResponseBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteMarkersResponseBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteMarkersResponseBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DeleteMarkersResponseBody {
    return {};
  },

  toJSON(_: DeleteMarkersResponseBody): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteMarkersResponseBody>, I>>(base?: I): DeleteMarkersResponseBody {
    return DeleteMarkersResponseBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteMarkersResponseBody>, I>>(_: I): DeleteMarkersResponseBody {
    const message = createBaseDeleteMarkersResponseBody();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
